"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.reverse.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.function.bind.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.last-index-of.js");

function CSSScanner(e) {
  this.init(e);
}

function jscsspToken(e, t, i) {
  this.type = e, this.value = t, this.unit = i;
}

function jscsspStylesheet() {
  this.cssRules = [], this.variables = {};
}

function jscsspCharsetRule() {
  this.type = kJscsspCHARSET_RULE, this.encoding = null, this.parsedCssText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspErrorRule(e) {
  this.error = e || "INVALID", this.type = kJscsspUNKNOWN_RULE, this.parsedCssText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspComment() {
  this.type = kJscsspCOMMENT, this.parsedCssText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspWhitespace() {
  this.type = kJscsspWHITE_SPACE, this.parsedCssText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspImportRule() {
  this.type = kJscsspIMPORT_RULE, this.parsedCssText = null, this.href = null, this.media = [], this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspNamespaceRule() {
  this.type = kJscsspNAMESPACE_RULE, this.parsedCssText = null, this.prefix = null, this.url = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspDeclaration() {
  this.type = kJscsspSTYLE_DECLARATION, this.property = null, this.values = [], this.valueText = null, this.priority = null, this.parsedCssText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspFontFaceRule() {
  this.type = kJscsspFONT_FACE_RULE, this.parsedCssText = null, this.descriptors = [], this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspKeyframesRule() {
  this.type = kJscsspKEYFRAMES_RULE, this.parsedCssText = null, this.cssRules = [], this.name = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspKeyframeRule() {
  this.type = kJscsspKEYFRAME_RULE, this.parsedCssText = null, this.declarations = [], this.keyText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspMediaRule() {
  this.type = kJscsspMEDIA_RULE, this.parsedCssText = null, this.cssRules = [], this.media = [], this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspStyleRule() {
  this.type = kJscsspSTYLE_RULE, this.parsedCssText = null, this.declarations = [], this.mSelectorText = null, this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspPageRule() {
  this.type = kJscsspPAGE_RULE, this.parsedCssText = null, this.pageSelector = null, this.declarations = [], this.parentStyleSheet = null, this.parentRule = null;
}

function jscsspVariablesRule() {
  this.type = kJscsspVARIABLES_RULE, this.parsedCssText = null, this.declarations = [], this.parentStyleSheet = null, this.parentRule = null, this.media = null;
}

function jscsspVariable(e, t) {
  this.value = "", this.type = e, this.name = null, this.parentRule = null, this.parentStyleSheet = t;
}

function ParseURL(e) {
  var t = {};
  t.protocol = "", t.user = "", t.password = "", t.host = "", t.port = "", t.path = "", t.query = "";

  for (var i = "PROTOCOL", n = 0, s = !1; n < e.length;) {
    if ("PROTOCOL" == i) ":" == e.charAt(n) ? (i = "AFTER_PROTOCOL", n++) : "/" == e.charAt(n) && 0 == t.protocol.length() ? i = PATH : t.protocol += e.charAt(n++);else if ("AFTER_PROTOCOL" == i) {
      if ("/" != e.charAt(n)) throw new ParseException("Protocol shell be separated with 2 slashes");
      s ? (s = !1, i = "USER") : s = !0, n++;
    } else "USER" == i ? "/" == e.charAt(n) ? (t.host = t.user, t.user = "", i = "PATH") : "?" == e.charAt(n) ? (t.host = t.user, t.user = "", i = "QUERY", n++) : ":" == e.charAt(n) ? (i = "PASSWORD", n++) : "@" == e.charAt(n) ? (i = "HOST", n++) : t.user += e.charAt(n++) : "PASSWORD" == i ? "/" == e.charAt(n) ? (t.host = t.user, t.port = t.password, t.user = "", t.password = "", i = "PATH") : "?" == e.charAt(n) ? (t.host = t.user, t.port = t.password, t.user = "", t.password = "", i = "QUERY", n++) : "@" == e.charAt(n) ? (i = "HOST", n++) : t.password += e.charAt(n++) : "HOST" == i ? "/" == e.charAt(n) ? i = "PATH" : ":" == e.charAt(n) ? (i = "PORT", n++) : "?" == e.charAt(n) ? (i = "QUERY", n++) : t.host += e.charAt(n++) : "PORT" == i ? "/" == e.charAt(n) ? i = "PATH" : "?" == e.charAt(n) ? (i = "QUERY", n++) : t.port += e.charAt(n++) : "PATH" == i ? "?" == e.charAt(n) ? (i = "QUERY", n++) : t.path += e.charAt(n++) : "QUERY" == i && (t.query += e.charAt(n++));
  }

  if ("PROTOCOL" == i) t.host = t.protocol, t.protocol = "http";else {
    if ("AFTER_PROTOCOL" == i) throw new ParseException("Invalid url");
    "USER" == i ? (t.host = t.user, t.user = "") : "PASSWORD" == i && (t.host = t.user, t.port = t.password, t.user = "", t.password = "");
  }
  return t;
}

function ParseException(e) {
  this.description = e;
}

function CountLF(e) {
  var t = e.match(/\n/g);
  return t ? t.length + 1 : 1;
}

function DisposablePartialParsing(e, t) {
  var i = new CSSParser();
  return i._init(), i.mPreserveWS = !1, i.mPreserveComments = !1, i.mPreservedTokens = [], i.mScanner.init(e), i[t]();
}

function FilterLinearGradient(e, t) {
  var i = DisposablePartialParsing(e, "parseBackgroundImages");
  if (!i) return null;
  var n = i[0];
  if (!n.value) return null;
  var s = "",
      r = "position" in n.value ? n.value.position.toLowerCase() : "",
      o = "angle" in n.value ? n.value.angle.toLowerCase() : "";

  if ("webkit20110101" == t) {
    var a = !1;

    if (s = "-webkit-gradient(linear, ", o) {
      var l = o.match(/^([0-9\-\.\\+]+)([a-z]*)/),
          o = parseFloat(l[1]),
          u = l[2];

      switch (u) {
        case "grad":
          o = 90 * o / 100;
          break;

        case "rad":
          o = 180 * o / Math.PI;
      }

      for (; 0 > o;) {
        o += 360;
      }

      for (; o >= 360;) {
        o -= 360;
      }
    }

    var c = [],
        d = [];
    if ("" != r) {
      if ("center" == r && (r = "center center"), c = r.split(" "), "" == o && 0 != o) {
        switch (c[0]) {
          case "left":
            d.push("right");
            break;

          case "center":
            d.push("center");
            break;

          case "right":
            d.push("left");
            break;

          default:
            var l = c[0].match(/^([0-9\-\.\\+]+)([a-z]*)/),
                p = parseFloat(l[0]),
                u = l[1];
            "%" == u ? d.push(100 - p + "%") : a = !0;
        }

        if (!a) switch (c[1]) {
          case "top":
            d.push("bottom");
            break;

          case "center":
            d.push("center");
            break;

          case "bottom":
            d.push("top");
            break;

          default:
            var l = c[1].match(/^([0-9\-\.\\+]+)([a-z]*)/),
                p = parseFloat(l[0]),
                u = l[1];
            "%" == u ? d.push(100 - p + "%") : a = !0;
        }
      } else switch (o) {
        case 0:
          d.push("right"), d.push(c[1]);
          break;

        case 90:
          d.push(c[0]), d.push("top");
          break;

        case 180:
          d.push("left"), d.push(c[1]);
          break;

        case 270:
          d.push(c[0]), d.push("bottom");
          break;

        default:
          a = !0;
      }
    } else switch ("" == o && (o = 270), o) {
      case 0:
        c = ["left", "center"], d = ["right", "center"];
        break;

      case 90:
        c = ["center", "bottom"], d = ["center", "top"];
        break;

      case 180:
        c = ["right", "center"], d = ["left", "center"];
        break;

      case 270:
        c = ["center", "top"], d = ["center", "bottom"];
        break;

      default:
        a = !0;
    }
    if (a) return "";
    s += c.join(" ") + ", " + d.join(" "), n.value.stops[0].position || (n.value.stops[0].position = "0%"), n.value.stops[n.value.stops.length - 1].position || (n.value.stops[n.value.stops.length - 1].position = "100%");

    for (var h = 0, f = 0; f < n.value.stops.length && !a; f++) {
      var m = n.value.stops[f];

      if (m.position) {
        if (-1 == m.position.indexOf("%")) {
          a = !0;
          break;
        }
      } else {
        for (var g = f + 1; g < n.value.stops.length && !n.value.stops[g].position;) {
          g++;
        }

        for (var b = parseFloat(n.value.stops[g].position) - h, v = f; g > v; v++) {
          n.value.stops[v].position = h + b * (v - f + 1) / (g - f + 1) + "%";
        }
      }

      h = parseFloat(m.position), s += ", color-stop(" + parseFloat(h) / 100 + ", " + m.color + ")";
    }

    if (a) return "";
  } else {
    s = (n.value.isRepeating ? "repeating-" : "") + "linear-gradient(", (o || r) && (s += (o || r) + ", ");

    for (var f = 0; f < n.value.stops.length; f++) {
      var m = n.value.stops[f];
      s += m.color + (m.position ? " " + m.position : "") + (f != n.value.stops.length - 1 ? ", " : "");
    }
  }

  switch (s += ")", t) {
    case "webkit":
      s = "-webkit-" + s;
      break;

    case "gecko1.9.2":
      s = "-moz-" + s;
      break;

    case "presto":
      s = "-o-" + s;
      break;

    case "trident":
      s = "-ms-" + s;
  }

  return s;
}

function FilterRadialGradient(e, t) {
  var i = DisposablePartialParsing(e, "parseBackgroundImages");
  if (!i) return null;
  var n = i[0];
  if (!n.value) return null;
  if ("webkit20110101" == t) return null;
  var s = (n.value.isRepeating ? "repeating-" : "") + "radial-gradient(",
      r = "shape" in n.value ? n.value.shape : "",
      o = "extent" in n.value ? n.value.extent : "",
      a = "";

  switch (n.value.positions.length) {
    case 1:
      a = n.value.positions[0] + " " + n.value.positions[0];
      break;

    case 2:
      a = n.value.positions[0] + " " + n.value.positions[1];
  }

  var l = n.value.at;
  s += (l ? l + ", " : "") + (r || o || l ? (r ? r + " " : "") + (o ? o + " " : "") + (a ? a + " " : "") + ", " : "");

  for (var u = 0; u < n.value.stops.length; u++) {
    var c = n.value.stops[u];
    s += c.color + (c.position ? " " + c.position : "") + (u != n.value.stops.length - 1 ? ", " : "");
  }

  switch (s += ")", t) {
    case "webkit":
      s = "-webkit-" + s;
      break;

    case "gecko1.9.2":
      s = "-moz-" + s;
      break;

    case "presto":
      s = "-o-" + s;
      break;

    case "trident":
      s = "-ms-" + s;
  }

  return s;
}

define("page/business-awards", [], function () {
  for (var e = document.querySelectorAll(".business-awards .row"), t = AppConfig.Util.slice(e), i = t.length; i--;) {
    t[i].style.backgroundColor = i % 2 != 0 ? "#ffffff" : "#f3eddc";
  }
}), function (e, t) {
  "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof2["default"])(module)) && "object" == (0, _typeof2["default"])(module.exports) ? module.exports = e.document ? t(e, !0) : function (e) {
    if (!e.document) throw new Error("jQuery requires a window with a document");
    return t(e);
  } : t(e);
}("undefined" != typeof window ? window : void 0, function (e, t) {
  function i(e) {
    var t = e.length,
        i = se.type(e);
    return "function" !== i && !se.isWindow(e) && (!(1 !== e.nodeType || !t) || "array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
  }

  function n(e, t, i) {
    if (se.isFunction(t)) return se.grep(e, function (e, n) {
      return !!t.call(e, n, e) !== i;
    });
    if (t.nodeType) return se.grep(e, function (e) {
      return e === t !== i;
    });

    if ("string" == typeof t) {
      if (pe.test(t)) return se.filter(t, e, i);
      t = se.filter(t, e);
    }

    return se.grep(e, function (e) {
      return se.inArray(e, t) >= 0 !== i;
    });
  }

  function s(e, t) {
    do {
      e = e[t];
    } while (e && 1 !== e.nodeType);

    return e;
  }

  function r(e) {
    var t = ke[e] = {};
    return se.each(e.match(ve) || [], function (e, i) {
      t[i] = !0;
    }), t;
  }

  function o() {
    fe.addEventListener ? (fe.removeEventListener("DOMContentLoaded", a, !1), e.removeEventListener("load", a, !1)) : (fe.detachEvent("onreadystatechange", a), e.detachEvent("onload", a));
  }

  function a() {
    (fe.addEventListener || "load" === event.type || "complete" === fe.readyState) && (o(), se.ready());
  }

  function l(e, t, i) {
    if (void 0 === i && 1 === e.nodeType) {
      var n = "data-" + t.replace(xe, "-$1").toLowerCase();

      if ("string" == typeof (i = e.getAttribute(n))) {
        try {
          i = "true" === i || "false" !== i && ("null" === i ? null : +i + "" === i ? +i : Te.test(i) ? se.parseJSON(i) : i);
        } catch (e) {}

        se.data(e, t, i);
      } else i = void 0;
    }

    return i;
  }

  function u(e) {
    var t;

    for (t in e) {
      if (("data" !== t || !se.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
    }

    return !0;
  }

  function c(e, t, i, n) {
    if (se.acceptData(e)) {
      var s,
          r,
          o = se.expando,
          a = e.nodeType,
          l = a ? se.cache : e,
          u = a ? e[o] : e[o] && o;
      if (u && l[u] && (n || l[u].data) || void 0 !== i || "string" != typeof t) return u || (u = a ? e[o] = $.pop() || se.guid++ : o), l[u] || (l[u] = a ? {} : {
        toJSON: se.noop
      }), ("object" == (0, _typeof2["default"])(t) || "function" == typeof t) && (n ? l[u] = se.extend(l[u], t) : l[u].data = se.extend(l[u].data, t)), r = l[u], n || (r.data || (r.data = {}), r = r.data), void 0 !== i && (r[se.camelCase(t)] = i), "string" == typeof t ? null == (s = r[t]) && (s = r[se.camelCase(t)]) : s = r, s;
    }
  }

  function d(e, t, i) {
    if (se.acceptData(e)) {
      var n,
          s,
          r = e.nodeType,
          o = r ? se.cache : e,
          a = r ? e[se.expando] : se.expando;

      if (o[a]) {
        if (t && (n = i ? o[a] : o[a].data)) {
          se.isArray(t) ? t = t.concat(se.map(t, se.camelCase)) : t in n ? t = [t] : (t = se.camelCase(t), t = t in n ? [t] : t.split(" ")), s = t.length;

          for (; s--;) {
            delete n[t[s]];
          }

          if (i ? !u(n) : !se.isEmptyObject(n)) return;
        }

        (i || (delete o[a].data, u(o[a]))) && (r ? se.cleanData([e], !0) : ie.deleteExpando || o != o.window ? delete o[a] : o[a] = null);
      }
    }
  }

  function p() {
    return !0;
  }

  function h() {
    return !1;
  }

  function f() {
    try {
      return fe.activeElement;
    } catch (e) {}
  }

  function m(e) {
    var t = je.split("|"),
        i = e.createDocumentFragment();
    if (i.createElement) for (; t.length;) {
      i.createElement(t.pop());
    }
    return i;
  }

  function g(e, t) {
    var i,
        n,
        s = 0,
        r = (0, _typeof2["default"])(e.getElementsByTagName) !== Se ? e.getElementsByTagName(t || "*") : (0, _typeof2["default"])(e.querySelectorAll) !== Se ? e.querySelectorAll(t || "*") : void 0;
    if (!r) for (r = [], i = e.childNodes || e; null != (n = i[s]); s++) {
      !t || se.nodeName(n, t) ? r.push(n) : se.merge(r, g(n, t));
    }
    return void 0 === t || t && se.nodeName(e, t) ? se.merge([e], r) : r;
  }

  function b(e) {
    De.test(e.type) && (e.defaultChecked = e.checked);
  }

  function v(e, t) {
    return se.nodeName(e, "table") && se.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
  }

  function k(e) {
    return e.type = (null !== se.find.attr(e, "type")) + "/" + e.type, e;
  }

  function y(e) {
    var t = Xe.exec(e.type);
    return t ? e.type = t[1] : e.removeAttribute("type"), e;
  }

  function w(e, t) {
    for (var i, n = 0; null != (i = e[n]); n++) {
      se._data(i, "globalEval", !t || se._data(t[n], "globalEval"));
    }
  }

  function S(e, t) {
    if (1 === t.nodeType && se.hasData(e)) {
      var i,
          n,
          s,
          r = se._data(e),
          o = se._data(t, r),
          a = r.events;

      if (a) {
        delete o.handle, o.events = {};

        for (i in a) {
          for (n = 0, s = a[i].length; s > n; n++) {
            se.event.add(t, i, a[i][n]);
          }
        }
      }

      o.data && (o.data = se.extend({}, o.data));
    }
  }

  function T(e, t) {
    var i, n, s;

    if (1 === t.nodeType) {
      if (i = t.nodeName.toLowerCase(), !ie.noCloneEvent && t[se.expando]) {
        s = se._data(t);

        for (n in s.events) {
          se.removeEvent(t, n, s.handle);
        }

        t.removeAttribute(se.expando);
      }

      "script" === i && t.text !== e.text ? (k(t).text = e.text, y(t)) : "object" === i ? (t.parentNode && (t.outerHTML = e.outerHTML), ie.html5Clone && e.innerHTML && !se.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === i && De.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === i ? t.defaultSelected = t.selected = e.defaultSelected : ("input" === i || "textarea" === i) && (t.defaultValue = e.defaultValue);
    }
  }

  function x(t, i) {
    var n,
        s = se(i.createElement(t)).appendTo(i.body),
        r = e.getDefaultComputedStyle && (n = e.getDefaultComputedStyle(s[0])) ? n.display : se.css(s[0], "display");
    return s.detach(), r;
  }

  function E(e) {
    var t = fe,
        i = Qe[e];
    return i || (i = x(e, t), "none" !== i && i || (Ke = (Ke || se("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), t = (Ke[0].contentWindow || Ke[0].contentDocument).document, t.write(), t.close(), i = x(e, t), Ke.detach()), Qe[e] = i), i;
  }

  function C(e, t) {
    return {
      get: function get() {
        var i = e();
        if (null != i) return i ? void delete this.get : (this.get = t).apply(this, arguments);
      }
    };
  }

  function I(e, t) {
    if (t in e) return t;

    for (var i = t.charAt(0).toUpperCase() + t.slice(1), n = t, s = dt.length; s--;) {
      if ((t = dt[s] + i) in e) return t;
    }

    return n;
  }

  function R(e, t) {
    for (var i, n, s, r = [], o = 0, a = e.length; a > o; o++) {
      n = e[o], n.style && (r[o] = se._data(n, "olddisplay"), i = n.style.display, t ? (r[o] || "none" !== i || (n.style.display = ""), "" === n.style.display && Ie(n) && (r[o] = se._data(n, "olddisplay", E(n.nodeName)))) : (s = Ie(n), (i && "none" !== i || !s) && se._data(n, "olddisplay", s ? i : se.css(n, "display"))));
    }

    for (o = 0; a > o; o++) {
      n = e[o], n.style && (t && "none" !== n.style.display && "" !== n.style.display || (n.style.display = t ? r[o] || "" : "none"));
    }

    return e;
  }

  function D(e, t, i) {
    var n = at.exec(t);
    return n ? Math.max(0, n[1] - (i || 0)) + (n[2] || "px") : t;
  }

  function N(e, t, i, n, s) {
    for (var r = i === (n ? "border" : "content") ? 4 : "width" === t ? 1 : 0, o = 0; 4 > r; r += 2) {
      "margin" === i && (o += se.css(e, i + Ce[r], !0, s)), n ? ("content" === i && (o -= se.css(e, "padding" + Ce[r], !0, s)), "margin" !== i && (o -= se.css(e, "border" + Ce[r] + "Width", !0, s))) : (o += se.css(e, "padding" + Ce[r], !0, s), "padding" !== i && (o += se.css(e, "border" + Ce[r] + "Width", !0, s)));
    }

    return o;
  }

  function F(e, t, i) {
    var n = !0,
        s = "width" === t ? e.offsetWidth : e.offsetHeight,
        r = Ze(e),
        o = ie.boxSizing && "border-box" === se.css(e, "boxSizing", !1, r);

    if (0 >= s || null == s) {
      if (s = et(e, t, r), (0 > s || null == s) && (s = e.style[t]), it.test(s)) return s;
      n = o && (ie.boxSizingReliable() || s === e.style[t]), s = parseFloat(s) || 0;
    }

    return s + N(e, t, i || (o ? "border" : "content"), n, r) + "px";
  }

  function A(e, t, i, n, s) {
    return new A.prototype.init(e, t, i, n, s);
  }

  function _() {
    return setTimeout(function () {
      pt = void 0;
    }), pt = se.now();
  }

  function P(e, t) {
    var i,
        n = {
      height: e
    },
        s = 0;

    for (t = t ? 1 : 0; 4 > s; s += 2 - t) {
      i = Ce[s], n["margin" + i] = n["padding" + i] = e;
    }

    return t && (n.opacity = n.width = e), n;
  }

  function j(e, t, i) {
    for (var n, s = (vt[t] || []).concat(vt["*"]), r = 0, o = s.length; o > r; r++) {
      if (n = s[r].call(i, t, e)) return n;
    }
  }

  function L(e, t, i) {
    var n,
        s,
        r,
        o,
        a,
        l,
        u,
        c = this,
        d = {},
        p = e.style,
        h = e.nodeType && Ie(e),
        f = se._data(e, "fxshow");

    i.queue || (a = se._queueHooks(e, "fx"), null == a.unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function () {
      a.unqueued || l();
    }), a.unqueued++, c.always(function () {
      c.always(function () {
        a.unqueued--, se.queue(e, "fx").length || a.empty.fire();
      });
    })), 1 === e.nodeType && ("height" in t || "width" in t) && (i.overflow = [p.overflow, p.overflowX, p.overflowY], u = se.css(e, "display"), "inline" === ("none" === u ? se._data(e, "olddisplay") || E(e.nodeName) : u) && "none" === se.css(e, "float") && (ie.inlineBlockNeedsLayout && "inline" !== E(e.nodeName) ? p.zoom = 1 : p.display = "inline-block")), i.overflow && (p.overflow = "hidden", ie.shrinkWrapBlocks() || c.always(function () {
      p.overflow = i.overflow[0], p.overflowX = i.overflow[1], p.overflowY = i.overflow[2];
    }));

    for (n in t) {
      if (s = t[n], ft.exec(s)) {
        if (delete t[n], r = r || "toggle" === s, s === (h ? "hide" : "show")) {
          if ("show" !== s || !f || void 0 === f[n]) continue;
          h = !0;
        }

        d[n] = f && f[n] || se.style(e, n);
      } else u = void 0;
    }

    if (se.isEmptyObject(d)) "inline" === ("none" === u ? E(e.nodeName) : u) && (p.display = u);else {
      f ? "hidden" in f && (h = f.hidden) : f = se._data(e, "fxshow", {}), r && (f.hidden = !h), h ? se(e).show() : c.done(function () {
        se(e).hide();
      }), c.done(function () {
        var t;

        se._removeData(e, "fxshow");

        for (t in d) {
          se.style(e, t, d[t]);
        }
      });

      for (n in d) {
        o = j(h ? f[n] : 0, n, c), n in f || (f[n] = o.start, h && (o.end = o.start, o.start = "width" === n || "height" === n ? 1 : 0));
      }
    }
  }

  function O(e, t) {
    var i, n, s, r, o;

    for (i in e) {
      if (n = se.camelCase(i), s = t[n], r = e[i], se.isArray(r) && (s = r[1], r = e[i] = r[0]), i !== n && (e[n] = r, delete e[i]), (o = se.cssHooks[n]) && "expand" in o) {
        r = o.expand(r), delete e[n];

        for (i in r) {
          i in e || (e[i] = r[i], t[i] = s);
        }
      } else t[n] = s;
    }
  }

  function M(e, t, i) {
    var n,
        s,
        r = 0,
        o = bt.length,
        a = se.Deferred().always(function () {
      delete l.elem;
    }),
        l = function l() {
      if (s) return !1;

      for (var t = pt || _(), i = Math.max(0, u.startTime + u.duration - t), n = i / u.duration || 0, r = 1 - n, o = 0, l = u.tweens.length; l > o; o++) {
        u.tweens[o].run(r);
      }

      return a.notifyWith(e, [u, r, i]), 1 > r && l ? i : (a.resolveWith(e, [u]), !1);
    },
        u = a.promise({
      elem: e,
      props: se.extend({}, t),
      opts: se.extend(!0, {
        specialEasing: {}
      }, i),
      originalProperties: t,
      originalOptions: i,
      startTime: pt || _(),
      duration: i.duration,
      tweens: [],
      createTween: function createTween(t, i) {
        var n = se.Tween(e, u.opts, t, i, u.opts.specialEasing[t] || u.opts.easing);
        return u.tweens.push(n), n;
      },
      stop: function stop(t) {
        var i = 0,
            n = t ? u.tweens.length : 0;
        if (s) return this;

        for (s = !0; n > i; i++) {
          u.tweens[i].run(1);
        }

        return t ? a.resolveWith(e, [u, t]) : a.rejectWith(e, [u, t]), this;
      }
    }),
        c = u.props;

    for (O(c, u.opts.specialEasing); o > r; r++) {
      if (n = bt[r].call(u, e, c, u.opts)) return n;
    }

    return se.map(c, j, u), se.isFunction(u.opts.start) && u.opts.start.call(e, u), se.fx.timer(se.extend(l, {
      elem: e,
      anim: u,
      queue: u.opts.queue
    })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always);
  }

  function H(e) {
    return function (t, i) {
      "string" != typeof t && (i = t, t = "*");
      var n,
          s = 0,
          r = t.toLowerCase().match(ve) || [];
      if (se.isFunction(i)) for (; n = r[s++];) {
        "+" === n.charAt(0) ? (n = n.slice(1) || "*", (e[n] = e[n] || []).unshift(i)) : (e[n] = e[n] || []).push(i);
      }
    };
  }

  function z(e, t, i, n) {
    function s(a) {
      var l;
      return r[a] = !0, se.each(e[a] || [], function (e, a) {
        var u = a(t, i, n);
        return "string" != typeof u || o || r[u] ? o ? !(l = u) : void 0 : (t.dataTypes.unshift(u), s(u), !1);
      }), l;
    }

    var r = {},
        o = e === qt;
    return s(t.dataTypes[0]) || !r["*"] && s("*");
  }

  function U(e, t) {
    var i,
        n,
        s = se.ajaxSettings.flatOptions || {};

    for (n in t) {
      void 0 !== t[n] && ((s[n] ? e : i || (i = {}))[n] = t[n]);
    }

    return i && se.extend(!0, e, i), e;
  }

  function q(e, t, i) {
    for (var n, s, r, o, a = e.contents, l = e.dataTypes; "*" === l[0];) {
      l.shift(), void 0 === s && (s = e.mimeType || t.getResponseHeader("Content-Type"));
    }

    if (s) for (o in a) {
      if (a[o] && a[o].test(s)) {
        l.unshift(o);
        break;
      }
    }
    if (l[0] in i) r = l[0];else {
      for (o in i) {
        if (!l[0] || e.converters[o + " " + l[0]]) {
          r = o;
          break;
        }

        n || (n = o);
      }

      r = r || n;
    }
    return r ? (r !== l[0] && l.unshift(r), i[r]) : void 0;
  }

  function W(e, t, i, n) {
    var s,
        r,
        o,
        a,
        l,
        u = {},
        c = e.dataTypes.slice();
    if (c[1]) for (o in e.converters) {
      u[o.toLowerCase()] = e.converters[o];
    }

    for (r = c.shift(); r;) {
      if (e.responseFields[r] && (i[e.responseFields[r]] = t), !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = c.shift()) if ("*" === r) r = l;else if ("*" !== l && l !== r) {
        if (!(o = u[l + " " + r] || u["* " + r])) for (s in u) {
          if (a = s.split(" "), a[1] === r && (o = u[l + " " + a[0]] || u["* " + a[0]])) {
            !0 === o ? o = u[s] : !0 !== u[s] && (r = a[0], c.unshift(a[1]));
            break;
          }
        }
        if (!0 !== o) if (o && e["throws"]) t = o(t);else try {
          t = o(t);
        } catch (e) {
          return {
            state: "parsererror",
            error: o ? e : "No conversion from " + l + " to " + r
          };
        }
      }
    }

    return {
      state: "success",
      data: t
    };
  }

  function B(e, t, i, n) {
    var s;
    if (se.isArray(t)) se.each(t, function (t, s) {
      i || Vt.test(e) ? n(e, s) : B(e + "[" + ("object" == (0, _typeof2["default"])(s) ? t : "") + "]", s, i, n);
    });else if (i || "object" !== se.type(t)) n(e, t);else for (s in t) {
      B(e + "[" + s + "]", t[s], i, n);
    }
  }

  function V() {
    try {
      return new e.XMLHttpRequest();
    } catch (e) {}
  }

  function X() {
    try {
      return new e.ActiveXObject("Microsoft.XMLHTTP");
    } catch (e) {}
  }

  function Y(e) {
    return se.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow);
  }

  var $ = [],
      J = $.slice,
      G = $.concat,
      K = $.push,
      Q = $.indexOf,
      Z = {},
      ee = Z.toString,
      te = Z.hasOwnProperty,
      ie = {},
      ne = "1.11.2",
      se = function se(e, t) {
    return new se.fn.init(e, t);
  },
      re = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      oe = /^-ms-/,
      ae = /-([\da-z])/gi,
      le = function le(e, t) {
    return t.toUpperCase();
  };

  se.fn = se.prototype = {
    jquery: ne,
    constructor: se,
    selector: "",
    length: 0,
    toArray: function toArray() {
      return J.call(this);
    },
    get: function get(e) {
      return null != e ? 0 > e ? this[e + this.length] : this[e] : J.call(this);
    },
    pushStack: function pushStack(e) {
      var t = se.merge(this.constructor(), e);
      return t.prevObject = this, t.context = this.context, t;
    },
    each: function each(e, t) {
      return se.each(this, e, t);
    },
    map: function map(e) {
      return this.pushStack(se.map(this, function (t, i) {
        return e.call(t, i, t);
      }));
    },
    slice: function slice() {
      return this.pushStack(J.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    eq: function eq(e) {
      var t = this.length,
          i = +e + (0 > e ? t : 0);
      return this.pushStack(i >= 0 && t > i ? [this[i]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor(null);
    },
    push: K,
    sort: $.sort,
    splice: $.splice
  }, se.extend = se.fn.extend = function () {
    var e,
        t,
        i,
        n,
        s,
        r,
        o = arguments[0] || {},
        a = 1,
        l = arguments.length,
        u = !1;

    for ("boolean" == typeof o && (u = o, o = arguments[a] || {}, a++), "object" == (0, _typeof2["default"])(o) || se.isFunction(o) || (o = {}), a === l && (o = this, a--); l > a; a++) {
      if (null != (s = arguments[a])) for (n in s) {
        e = o[n], i = s[n], o !== i && (u && i && (se.isPlainObject(i) || (t = se.isArray(i))) ? (t ? (t = !1, r = e && se.isArray(e) ? e : []) : r = e && se.isPlainObject(e) ? e : {}, o[n] = se.extend(u, r, i)) : void 0 !== i && (o[n] = i));
      }
    }

    return o;
  }, se.extend({
    expando: "jQuery" + (ne + Math.random()).replace(/\D/g, ""),
    isReady: !0,
    error: function error(e) {
      throw new Error(e);
    },
    noop: function noop() {},
    isFunction: function isFunction(e) {
      return "function" === se.type(e);
    },
    isArray: Array.isArray || function (e) {
      return "array" === se.type(e);
    },
    isWindow: function isWindow(e) {
      return null != e && e == e.window;
    },
    isNumeric: function isNumeric(e) {
      return !se.isArray(e) && e - parseFloat(e) + 1 >= 0;
    },
    isEmptyObject: function isEmptyObject(e) {
      var t;

      for (t in e) {
        return !1;
      }

      return !0;
    },
    isPlainObject: function isPlainObject(e) {
      var t;
      if (!e || "object" !== se.type(e) || e.nodeType || se.isWindow(e)) return !1;

      try {
        if (e.constructor && !te.call(e, "constructor") && !te.call(e.constructor.prototype, "isPrototypeOf")) return !1;
      } catch (e) {
        return !1;
      }

      if (ie.ownLast) for (t in e) {
        return te.call(e, t);
      }

      for (t in e) {
        ;
      }

      return void 0 === t || te.call(e, t);
    },
    type: function type(e) {
      return null == e ? e + "" : "object" == (0, _typeof2["default"])(e) || "function" == typeof e ? Z[ee.call(e)] || "object" : (0, _typeof2["default"])(e);
    },
    globalEval: function globalEval(t) {
      t && se.trim(t) && (e.execScript || function (t) {
        e.eval.call(e, t);
      })(t);
    },
    camelCase: function camelCase(e) {
      return e.replace(oe, "ms-").replace(ae, le);
    },
    nodeName: function nodeName(e, t) {
      return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    },
    each: function each(e, t, n) {
      var s = 0,
          r = e.length,
          o = i(e);

      if (n) {
        if (o) for (; r > s && !1 !== t.apply(e[s], n); s++) {
          ;
        } else for (s in e) {
          if (!1 === t.apply(e[s], n)) break;
        }
      } else if (o) for (; r > s && !1 !== t.call(e[s], s, e[s]); s++) {
        ;
      } else for (s in e) {
        if (!1 === t.call(e[s], s, e[s])) break;
      }

      return e;
    },
    trim: function trim(e) {
      return null == e ? "" : (e + "").replace(re, "");
    },
    makeArray: function makeArray(e, t) {
      var n = t || [];
      return null != e && (i(Object(e)) ? se.merge(n, "string" == typeof e ? [e] : e) : K.call(n, e)), n;
    },
    inArray: function inArray(e, t, i) {
      var n;

      if (t) {
        if (Q) return Q.call(t, e, i);

        for (n = t.length, i = i ? 0 > i ? Math.max(0, n + i) : i : 0; n > i; i++) {
          if (i in t && t[i] === e) return i;
        }
      }

      return -1;
    },
    merge: function merge(e, t) {
      for (var i = +t.length, n = 0, s = e.length; i > n;) {
        e[s++] = t[n++];
      }

      if (i !== i) for (; void 0 !== t[n];) {
        e[s++] = t[n++];
      }
      return e.length = s, e;
    },
    grep: function grep(e, t, i) {
      for (var n = [], s = 0, r = e.length, o = !i; r > s; s++) {
        !t(e[s], s) !== o && n.push(e[s]);
      }

      return n;
    },
    map: function map(e, t, n) {
      var s,
          r = 0,
          o = e.length,
          a = i(e),
          l = [];
      if (a) for (; o > r; r++) {
        null != (s = t(e[r], r, n)) && l.push(s);
      } else for (r in e) {
        null != (s = t(e[r], r, n)) && l.push(s);
      }
      return G.apply([], l);
    },
    guid: 1,
    proxy: function proxy(e, t) {
      var i, n, s;
      return "string" == typeof t && (s = e[t], t = e, e = s), se.isFunction(e) ? (i = J.call(arguments, 2), n = function n() {
        return e.apply(t || this, i.concat(J.call(arguments)));
      }, n.guid = e.guid = e.guid || se.guid++, n) : void 0;
    },
    now: function now() {
      return +new Date();
    },
    support: ie
  }), se.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
    Z["[object " + t + "]"] = t.toLowerCase();
  });

  var ue = function (e) {
    function t(e, t, i, n) {
      var s, r, o, a, u, d, p, h, f, m;
      if ((t ? t.ownerDocument || t : M) !== N && D(t), t = t || N, i = i || [], a = t.nodeType, "string" != typeof e || !e || 1 !== a && 9 !== a && 11 !== a) return i;

      if (!n && A) {
        if (11 !== a && (s = ge.exec(e))) if (o = s[1]) {
          if (9 === a) {
            if (!(r = t.getElementById(o)) || !r.parentNode) return i;
            if (r.id === o) return i.push(r), i;
          } else if (t.ownerDocument && (r = t.ownerDocument.getElementById(o)) && L(t, r) && r.id === o) return i.push(r), i;
        } else {
          if (s[2]) return G.apply(i, t.getElementsByTagName(e)), i;
          if ((o = s[3]) && k.getElementsByClassName) return G.apply(i, t.getElementsByClassName(o)), i;
        }

        if (k.qsa && (!_ || !_.test(e))) {
          if (h = p = O, f = t, m = 1 !== a && e, 1 === a && "object" !== t.nodeName.toLowerCase()) {
            for (d = T(e), (p = t.getAttribute("id")) ? h = p.replace(ve, "\\$&") : t.setAttribute("id", h), h = "[id='" + h + "'] ", u = d.length; u--;) {
              d[u] = h + c(d[u]);
            }

            f = be.test(e) && l(t.parentNode) || t, m = d.join(",");
          }

          if (m) try {
            return G.apply(i, f.querySelectorAll(m)), i;
          } catch (e) {} finally {
            p || t.removeAttribute("id");
          }
        }
      }

      return E(e.replace(oe, "$1"), t, i, n);
    }

    function i() {
      function e(i, n) {
        return t.push(i + " ") > y.cacheLength && delete e[t.shift()], e[i + " "] = n;
      }

      var t = [];
      return e;
    }

    function n(e) {
      return e[O] = !0, e;
    }

    function s(e) {
      var t = N.createElement("div");

      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), t = null;
      }
    }

    function r(e, t) {
      for (var i = e.split("|"), n = e.length; n--;) {
        y.attrHandle[i[n]] = t;
      }
    }

    function o(e, t) {
      var i = t && e,
          n = i && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || V) - (~e.sourceIndex || V);
      if (n) return n;
      if (i) for (; i = i.nextSibling;) {
        if (i === t) return -1;
      }
      return e ? 1 : -1;
    }

    function a(e) {
      return n(function (t) {
        return t = +t, n(function (i, n) {
          for (var s, r = e([], i.length, t), o = r.length; o--;) {
            i[s = r[o]] && (i[s] = !(n[s] = i[s]));
          }
        });
      });
    }

    function l(e) {
      return e && void 0 !== e.getElementsByTagName && e;
    }

    function u() {}

    function c(e) {
      for (var t = 0, i = e.length, n = ""; i > t; t++) {
        n += e[t].value;
      }

      return n;
    }

    function d(e, t, i) {
      var n = t.dir,
          s = i && "parentNode" === n,
          r = z++;
      return t.first ? function (t, i, r) {
        for (; t = t[n];) {
          if (1 === t.nodeType || s) return e(t, i, r);
        }
      } : function (t, i, o) {
        var a,
            l,
            u = [H, r];

        if (o) {
          for (; t = t[n];) {
            if ((1 === t.nodeType || s) && e(t, i, o)) return !0;
          }
        } else for (; t = t[n];) {
          if (1 === t.nodeType || s) {
            if (l = t[O] || (t[O] = {}), (a = l[n]) && a[0] === H && a[1] === r) return u[2] = a[2];
            if (l[n] = u, u[2] = e(t, i, o)) return !0;
          }
        }
      };
    }

    function p(e) {
      return e.length > 1 ? function (t, i, n) {
        for (var s = e.length; s--;) {
          if (!e[s](t, i, n)) return !1;
        }

        return !0;
      } : e[0];
    }

    function h(e, i, n) {
      for (var s = 0, r = i.length; r > s; s++) {
        t(e, i[s], n);
      }

      return n;
    }

    function f(e, t, i, n, s) {
      for (var r, o = [], a = 0, l = e.length, u = null != t; l > a; a++) {
        (r = e[a]) && (!i || i(r, n, s)) && (o.push(r), u && t.push(a));
      }

      return o;
    }

    function m(e, t, i, s, r, o) {
      return s && !s[O] && (s = m(s)), r && !r[O] && (r = m(r, o)), n(function (n, o, a, l) {
        var u,
            c,
            d,
            p = [],
            m = [],
            g = o.length,
            b = n || h(t || "*", a.nodeType ? [a] : a, []),
            v = !e || !n && t ? b : f(b, p, e, a, l),
            k = i ? r || (n ? e : g || s) ? [] : o : v;
        if (i && i(v, k, a, l), s) for (u = f(k, m), s(u, [], a, l), c = u.length; c--;) {
          (d = u[c]) && (k[m[c]] = !(v[m[c]] = d));
        }

        if (n) {
          if (r || e) {
            if (r) {
              for (u = [], c = k.length; c--;) {
                (d = k[c]) && u.push(v[c] = d);
              }

              r(null, k = [], u, l);
            }

            for (c = k.length; c--;) {
              (d = k[c]) && (u = r ? Q(n, d) : p[c]) > -1 && (n[u] = !(o[u] = d));
            }
          }
        } else k = f(k === o ? k.splice(g, k.length) : k), r ? r(null, o, k, l) : G.apply(o, k);
      });
    }

    function g(e) {
      for (var t, i, n, s = e.length, r = y.relative[e[0].type], o = r || y.relative[" "], a = r ? 1 : 0, l = d(function (e) {
        return e === t;
      }, o, !0), u = d(function (e) {
        return Q(t, e) > -1;
      }, o, !0), h = [function (e, i, n) {
        var s = !r && (n || i !== C) || ((t = i).nodeType ? l(e, i, n) : u(e, i, n));
        return t = null, s;
      }]; s > a; a++) {
        if (i = y.relative[e[a].type]) h = [d(p(h), i)];else {
          if (i = y.filter[e[a].type].apply(null, e[a].matches), i[O]) {
            for (n = ++a; s > n && !y.relative[e[n].type]; n++) {
              ;
            }

            return m(a > 1 && p(h), a > 1 && c(e.slice(0, a - 1).concat({
              value: " " === e[a - 2].type ? "*" : ""
            })).replace(oe, "$1"), i, n > a && g(e.slice(a, n)), s > n && g(e = e.slice(n)), s > n && c(e));
          }

          h.push(i);
        }
      }

      return p(h);
    }

    function b(e, i) {
      var s = i.length > 0,
          r = e.length > 0,
          o = function o(n, _o, a, l, u) {
        var c,
            d,
            p,
            h = 0,
            m = "0",
            g = n && [],
            b = [],
            v = C,
            k = n || r && y.find.TAG("*", u),
            w = H += null == v ? 1 : Math.random() || .1,
            S = k.length;

        for (u && (C = _o !== N && _o); m !== S && null != (c = k[m]); m++) {
          if (r && c) {
            for (d = 0; p = e[d++];) {
              if (p(c, _o, a)) {
                l.push(c);
                break;
              }
            }

            u && (H = w);
          }

          s && ((c = !p && c) && h--, n && g.push(c));
        }

        if (h += m, s && m !== h) {
          for (d = 0; p = i[d++];) {
            p(g, b, _o, a);
          }

          if (n) {
            if (h > 0) for (; m--;) {
              g[m] || b[m] || (b[m] = $.call(l));
            }
            b = f(b);
          }

          G.apply(l, b), u && !n && b.length > 0 && h + i.length > 1 && t.uniqueSort(l);
        }

        return u && (H = w, C = v), g;
      };

      return s ? n(o) : o;
    }

    var v,
        k,
        y,
        w,
        S,
        T,
        x,
        E,
        C,
        I,
        R,
        D,
        N,
        F,
        A,
        _,
        P,
        j,
        L,
        O = "sizzle" + 1 * new Date(),
        M = e.document,
        H = 0,
        z = 0,
        U = i(),
        q = i(),
        W = i(),
        B = function B(e, t) {
      return e === t && (R = !0), 0;
    },
        V = 1 << 31,
        X = {}.hasOwnProperty,
        Y = [],
        $ = Y.pop,
        J = Y.push,
        G = Y.push,
        K = Y.slice,
        Q = function Q(e, t) {
      for (var i = 0, n = e.length; n > i; i++) {
        if (e[i] === t) return i;
      }

      return -1;
    },
        Z = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        ee = "[\\x20\\t\\r\\n\\f]",
        te = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        ie = te.replace("w", "w#"),
        ne = "\\[" + ee + "*(" + te + ")(?:" + ee + "*([*^$|!~]?=)" + ee + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ie + "))|)" + ee + "*\\]",
        se = ":(" + te + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ne + ")*)|.*)\\)|)",
        re = new RegExp(ee + "+", "g"),
        oe = new RegExp("^" + ee + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ee + "+$", "g"),
        ae = new RegExp("^" + ee + "*," + ee + "*"),
        le = new RegExp("^" + ee + "*([>+~]|" + ee + ")" + ee + "*"),
        ue = new RegExp("=" + ee + "*([^\\]'\"]*?)" + ee + "*\\]", "g"),
        ce = new RegExp(se),
        de = new RegExp("^" + ie + "$"),
        pe = {
      ID: new RegExp("^#(" + te + ")"),
      CLASS: new RegExp("^\\.(" + te + ")"),
      TAG: new RegExp("^(" + te.replace("w", "w*") + ")"),
      ATTR: new RegExp("^" + ne),
      PSEUDO: new RegExp("^" + se),
      CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ee + "*(even|odd|(([+-]|)(\\d*)n|)" + ee + "*(?:([+-]|)" + ee + "*(\\d+)|))" + ee + "*\\)|)", "i"),
      bool: new RegExp("^(?:" + Z + ")$", "i"),
      needsContext: new RegExp("^" + ee + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ee + "*((?:-\\d)?\\d*)" + ee + "*\\)|)(?=[^-]|$)", "i")
    },
        he = /^(?:input|select|textarea|button)$/i,
        fe = /^h\d$/i,
        me = /^[^{]+\{\s*\[native \w/,
        ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        be = /[+~]/,
        ve = /'|\\/g,
        ke = new RegExp("\\\\([\\da-f]{1,6}" + ee + "?|(" + ee + ")|.)", "ig"),
        ye = function ye(e, t, i) {
      var n = "0x" + t - 65536;
      return n !== n || i ? t : 0 > n ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320);
    },
        we = function we() {
      D();
    };

    try {
      G.apply(Y = K.call(M.childNodes), M.childNodes), Y[M.childNodes.length].nodeType;
    } catch (e) {
      G = {
        apply: Y.length ? function (e, t) {
          J.apply(e, K.call(t));
        } : function (e, t) {
          for (var i = e.length, n = 0; e[i++] = t[n++];) {
            ;
          }

          e.length = i - 1;
        }
      };
    }

    k = t.support = {}, S = t.isXML = function (e) {
      var t = e && (e.ownerDocument || e).documentElement;
      return !!t && "HTML" !== t.nodeName;
    }, D = t.setDocument = function (e) {
      var t,
          i,
          n = e ? e.ownerDocument || e : M;
      return n !== N && 9 === n.nodeType && n.documentElement ? (N = n, F = n.documentElement, i = n.defaultView, i && i !== i.top && (i.addEventListener ? i.addEventListener("unload", we, !1) : i.attachEvent && i.attachEvent("onunload", we)), A = !S(n), k.attributes = s(function (e) {
        return e.className = "i", !e.getAttribute("className");
      }), k.getElementsByTagName = s(function (e) {
        return e.appendChild(n.createComment("")), !e.getElementsByTagName("*").length;
      }), k.getElementsByClassName = me.test(n.getElementsByClassName), k.getById = s(function (e) {
        return F.appendChild(e).id = O, !n.getElementsByName || !n.getElementsByName(O).length;
      }), k.getById ? (y.find.ID = function (e, t) {
        if (void 0 !== t.getElementById && A) {
          var i = t.getElementById(e);
          return i && i.parentNode ? [i] : [];
        }
      }, y.filter.ID = function (e) {
        var t = e.replace(ke, ye);
        return function (e) {
          return e.getAttribute("id") === t;
        };
      }) : (delete y.find.ID, y.filter.ID = function (e) {
        var t = e.replace(ke, ye);
        return function (e) {
          var i = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
          return i && i.value === t;
        };
      }), y.find.TAG = k.getElementsByTagName ? function (e, t) {
        return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : k.qsa ? t.querySelectorAll(e) : void 0;
      } : function (e, t) {
        var i,
            n = [],
            s = 0,
            r = t.getElementsByTagName(e);

        if ("*" === e) {
          for (; i = r[s++];) {
            1 === i.nodeType && n.push(i);
          }

          return n;
        }

        return r;
      }, y.find.CLASS = k.getElementsByClassName && function (e, t) {
        return A ? t.getElementsByClassName(e) : void 0;
      }, P = [], _ = [], (k.qsa = me.test(n.querySelectorAll)) && (s(function (e) {
        F.appendChild(e).innerHTML = "<a id='" + O + "'></a><select id='" + O + "-\f]' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && _.push("[*^$]=" + ee + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || _.push("\\[" + ee + "*(?:value|" + Z + ")"), e.querySelectorAll("[id~=" + O + "-]").length || _.push("~="), e.querySelectorAll(":checked").length || _.push(":checked"), e.querySelectorAll("a#" + O + "+*").length || _.push(".#.+[+~]");
      }), s(function (e) {
        var t = n.createElement("input");
        t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && _.push("name" + ee + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || _.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), _.push(",.*:");
      })), (k.matchesSelector = me.test(j = F.matches || F.webkitMatchesSelector || F.mozMatchesSelector || F.oMatchesSelector || F.msMatchesSelector)) && s(function (e) {
        k.disconnectedMatch = j.call(e, "div"), j.call(e, "[s!='']:x"), P.push("!=", se);
      }), _ = _.length && new RegExp(_.join("|")), P = P.length && new RegExp(P.join("|")), t = me.test(F.compareDocumentPosition), L = t || me.test(F.contains) ? function (e, t) {
        var i = 9 === e.nodeType ? e.documentElement : e,
            n = t && t.parentNode;
        return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)));
      } : function (e, t) {
        if (t) for (; t = t.parentNode;) {
          if (t === e) return !0;
        }
        return !1;
      }, B = t ? function (e, t) {
        if (e === t) return R = !0, 0;
        var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
        return i || (i = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & i || !k.sortDetached && t.compareDocumentPosition(e) === i ? e === n || e.ownerDocument === M && L(M, e) ? -1 : t === n || t.ownerDocument === M && L(M, t) ? 1 : I ? Q(I, e) - Q(I, t) : 0 : 4 & i ? -1 : 1);
      } : function (e, t) {
        if (e === t) return R = !0, 0;
        var i,
            s = 0,
            r = e.parentNode,
            a = t.parentNode,
            l = [e],
            u = [t];
        if (!r || !a) return e === n ? -1 : t === n ? 1 : r ? -1 : a ? 1 : I ? Q(I, e) - Q(I, t) : 0;
        if (r === a) return o(e, t);

        for (i = e; i = i.parentNode;) {
          l.unshift(i);
        }

        for (i = t; i = i.parentNode;) {
          u.unshift(i);
        }

        for (; l[s] === u[s];) {
          s++;
        }

        return s ? o(l[s], u[s]) : l[s] === M ? -1 : u[s] === M ? 1 : 0;
      }, n) : N;
    }, t.matches = function (e, i) {
      return t(e, null, null, i);
    }, t.matchesSelector = function (e, i) {
      if ((e.ownerDocument || e) !== N && D(e), i = i.replace(ue, "='$1']"), !(!k.matchesSelector || !A || P && P.test(i) || _ && _.test(i))) try {
        var n = j.call(e, i);
        if (n || k.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n;
      } catch (e) {}
      return t(i, N, null, [e]).length > 0;
    }, t.contains = function (e, t) {
      return (e.ownerDocument || e) !== N && D(e), L(e, t);
    }, t.attr = function (e, t) {
      (e.ownerDocument || e) !== N && D(e);
      var i = y.attrHandle[t.toLowerCase()],
          n = i && X.call(y.attrHandle, t.toLowerCase()) ? i(e, t, !A) : void 0;
      return void 0 !== n ? n : k.attributes || !A ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null;
    }, t.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }, t.uniqueSort = function (e) {
      var t,
          i = [],
          n = 0,
          s = 0;

      if (R = !k.detectDuplicates, I = !k.sortStable && e.slice(0), e.sort(B), R) {
        for (; t = e[s++];) {
          t === e[s] && (n = i.push(s));
        }

        for (; n--;) {
          e.splice(i[n], 1);
        }
      }

      return I = null, e;
    }, w = t.getText = function (e) {
      var t,
          i = "",
          n = 0,
          s = e.nodeType;

      if (s) {
        if (1 === s || 9 === s || 11 === s) {
          if ("string" == typeof e.textContent) return e.textContent;

          for (e = e.firstChild; e; e = e.nextSibling) {
            i += w(e);
          }
        } else if (3 === s || 4 === s) return e.nodeValue;
      } else for (; t = e[n++];) {
        i += w(t);
      }

      return i;
    }, y = t.selectors = {
      cacheLength: 50,
      createPseudo: n,
      match: pe,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: !0
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: !0
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        ATTR: function ATTR(e) {
          return e[1] = e[1].replace(ke, ye), e[3] = (e[3] || e[4] || e[5] || "").replace(ke, ye), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        },
        CHILD: function CHILD(e) {
          return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e;
        },
        PSEUDO: function PSEUDO(e) {
          var t,
              i = !e[6] && e[2];
          return pe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && ce.test(i) && (t = T(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t), e[2] = i.slice(0, t)), e.slice(0, 3));
        }
      },
      filter: {
        TAG: function TAG(e) {
          var t = e.replace(ke, ye).toLowerCase();
          return "*" === e ? function () {
            return !0;
          } : function (e) {
            return e.nodeName && e.nodeName.toLowerCase() === t;
          };
        },
        CLASS: function CLASS(e) {
          var t = U[e + " "];
          return t || (t = new RegExp("(^|" + ee + ")" + e + "(" + ee + "|$)")) && U(e, function (e) {
            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
          });
        },
        ATTR: function ATTR(e, i, n) {
          return function (s) {
            var r = t.attr(s, e);
            return null == r ? "!=" === i : !i || (r += "", "=" === i ? r === n : "!=" === i ? r !== n : "^=" === i ? n && 0 === r.indexOf(n) : "*=" === i ? n && r.indexOf(n) > -1 : "$=" === i ? n && r.slice(-n.length) === n : "~=" === i ? (" " + r.replace(re, " ") + " ").indexOf(n) > -1 : "|=" === i && (r === n || r.slice(0, n.length + 1) === n + "-"));
          };
        },
        CHILD: function CHILD(e, t, i, n, s) {
          var r = "nth" !== e.slice(0, 3),
              o = "last" !== e.slice(-4),
              a = "of-type" === t;
          return 1 === n && 0 === s ? function (e) {
            return !!e.parentNode;
          } : function (t, i, l) {
            var u,
                c,
                d,
                p,
                h,
                f,
                m = r !== o ? "nextSibling" : "previousSibling",
                g = t.parentNode,
                b = a && t.nodeName.toLowerCase(),
                v = !l && !a;

            if (g) {
              if (r) {
                for (; m;) {
                  for (d = t; d = d[m];) {
                    if (a ? d.nodeName.toLowerCase() === b : 1 === d.nodeType) return !1;
                  }

                  f = m = "only" === e && !f && "nextSibling";
                }

                return !0;
              }

              if (f = [o ? g.firstChild : g.lastChild], o && v) {
                for (c = g[O] || (g[O] = {}), u = c[e] || [], h = u[0] === H && u[1], p = u[0] === H && u[2], d = h && g.childNodes[h]; d = ++h && d && d[m] || (p = h = 0) || f.pop();) {
                  if (1 === d.nodeType && ++p && d === t) {
                    c[e] = [H, h, p];
                    break;
                  }
                }
              } else if (v && (u = (t[O] || (t[O] = {}))[e]) && u[0] === H) p = u[1];else for (; (d = ++h && d && d[m] || (p = h = 0) || f.pop()) && ((a ? d.nodeName.toLowerCase() !== b : 1 !== d.nodeType) || !++p || (v && ((d[O] || (d[O] = {}))[e] = [H, p]), d !== t));) {
                ;
              }

              return (p -= s) === n || p % n == 0 && p / n >= 0;
            }
          };
        },
        PSEUDO: function PSEUDO(e, i) {
          var s,
              r = y.pseudos[e] || y.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
          return r[O] ? r(i) : r.length > 1 ? (s = [e, e, "", i], y.setFilters.hasOwnProperty(e.toLowerCase()) ? n(function (e, t) {
            for (var n, s = r(e, i), o = s.length; o--;) {
              n = Q(e, s[o]), e[n] = !(t[n] = s[o]);
            }
          }) : function (e) {
            return r(e, 0, s);
          }) : r;
        }
      },
      pseudos: {
        not: n(function (e) {
          var t = [],
              i = [],
              s = x(e.replace(oe, "$1"));
          return s[O] ? n(function (e, t, i, n) {
            for (var r, o = s(e, null, n, []), a = e.length; a--;) {
              (r = o[a]) && (e[a] = !(t[a] = r));
            }
          }) : function (e, n, r) {
            return t[0] = e, s(t, null, r, i), t[0] = null, !i.pop();
          };
        }),
        has: n(function (e) {
          return function (i) {
            return t(e, i).length > 0;
          };
        }),
        contains: n(function (e) {
          return e = e.replace(ke, ye), function (t) {
            return (t.textContent || t.innerText || w(t)).indexOf(e) > -1;
          };
        }),
        lang: n(function (e) {
          return de.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(ke, ye).toLowerCase(), function (t) {
            var i;

            do {
              if (i = A ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-");
            } while ((t = t.parentNode) && 1 === t.nodeType);

            return !1;
          };
        }),
        target: function target(t) {
          var i = e.location && e.location.hash;
          return i && i.slice(1) === t.id;
        },
        root: function root(e) {
          return e === F;
        },
        focus: function focus(e) {
          return e === N.activeElement && (!N.hasFocus || N.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        },
        enabled: function enabled(e) {
          return !1 === e.disabled;
        },
        disabled: function disabled(e) {
          return !0 === e.disabled;
        },
        checked: function checked(e) {
          var t = e.nodeName.toLowerCase();
          return "input" === t && !!e.checked || "option" === t && !!e.selected;
        },
        selected: function selected(e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        },
        empty: function empty(e) {
          for (e = e.firstChild; e; e = e.nextSibling) {
            if (e.nodeType < 6) return !1;
          }

          return !0;
        },
        parent: function parent(e) {
          return !y.pseudos.empty(e);
        },
        header: function header(e) {
          return fe.test(e.nodeName);
        },
        input: function input(e) {
          return he.test(e.nodeName);
        },
        button: function button(e) {
          var t = e.nodeName.toLowerCase();
          return "input" === t && "button" === e.type || "button" === t;
        },
        text: function text(e) {
          var t;
          return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
        },
        first: a(function () {
          return [0];
        }),
        last: a(function (e, t) {
          return [t - 1];
        }),
        eq: a(function (e, t, i) {
          return [0 > i ? i + t : i];
        }),
        even: a(function (e, t) {
          for (var i = 0; t > i; i += 2) {
            e.push(i);
          }

          return e;
        }),
        odd: a(function (e, t) {
          for (var i = 1; t > i; i += 2) {
            e.push(i);
          }

          return e;
        }),
        lt: a(function (e, t, i) {
          for (var n = 0 > i ? i + t : i; --n >= 0;) {
            e.push(n);
          }

          return e;
        }),
        gt: a(function (e, t, i) {
          for (var n = 0 > i ? i + t : i; ++n < t;) {
            e.push(n);
          }

          return e;
        })
      }
    }, y.pseudos.nth = y.pseudos.eq;

    for (v in {
      radio: !0,
      checkbox: !0,
      file: !0,
      password: !0,
      image: !0
    }) {
      y.pseudos[v] = function (e) {
        return function (t) {
          return "input" === t.nodeName.toLowerCase() && t.type === e;
        };
      }(v);
    }

    for (v in {
      submit: !0,
      reset: !0
    }) {
      y.pseudos[v] = function (e) {
        return function (t) {
          var i = t.nodeName.toLowerCase();
          return ("input" === i || "button" === i) && t.type === e;
        };
      }(v);
    }

    return u.prototype = y.filters = y.pseudos, y.setFilters = new u(), T = t.tokenize = function (e, i) {
      var n,
          s,
          r,
          o,
          a,
          l,
          u,
          c = q[e + " "];
      if (c) return i ? 0 : c.slice(0);

      for (a = e, l = [], u = y.preFilter; a;) {
        (!n || (s = ae.exec(a))) && (s && (a = a.slice(s[0].length) || a), l.push(r = [])), n = !1, (s = le.exec(a)) && (n = s.shift(), r.push({
          value: n,
          type: s[0].replace(oe, " ")
        }), a = a.slice(n.length));

        for (o in y.filter) {
          !(s = pe[o].exec(a)) || u[o] && !(s = u[o](s)) || (n = s.shift(), r.push({
            value: n,
            type: o,
            matches: s
          }), a = a.slice(n.length));
        }

        if (!n) break;
      }

      return i ? a.length : a ? t.error(e) : q(e, l).slice(0);
    }, x = t.compile = function (e, t) {
      var i,
          n = [],
          s = [],
          r = W[e + " "];

      if (!r) {
        for (t || (t = T(e)), i = t.length; i--;) {
          r = g(t[i]), r[O] ? n.push(r) : s.push(r);
        }

        r = W(e, b(s, n)), r.selector = e;
      }

      return r;
    }, E = t.select = function (e, t, i, n) {
      var s,
          r,
          o,
          a,
          u,
          d = "function" == typeof e && e,
          p = !n && T(e = d.selector || e);

      if (i = i || [], 1 === p.length) {
        if (r = p[0] = p[0].slice(0), r.length > 2 && "ID" === (o = r[0]).type && k.getById && 9 === t.nodeType && A && y.relative[r[1].type]) {
          if (!(t = (y.find.ID(o.matches[0].replace(ke, ye), t) || [])[0])) return i;
          d && (t = t.parentNode), e = e.slice(r.shift().value.length);
        }

        for (s = pe.needsContext.test(e) ? 0 : r.length; s-- && (o = r[s], !y.relative[a = o.type]);) {
          if ((u = y.find[a]) && (n = u(o.matches[0].replace(ke, ye), be.test(r[0].type) && l(t.parentNode) || t))) {
            if (r.splice(s, 1), !(e = n.length && c(r))) return G.apply(i, n), i;
            break;
          }
        }
      }

      return (d || x(e, p))(n, t, !A, i, be.test(e) && l(t.parentNode) || t), i;
    }, k.sortStable = O.split("").sort(B).join("") === O, k.detectDuplicates = !!R, D(), k.sortDetached = s(function (e) {
      return 1 & e.compareDocumentPosition(N.createElement("div"));
    }), s(function (e) {
      return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
    }) || r("type|href|height|width", function (e, t, i) {
      return i ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
    }), k.attributes && s(function (e) {
      return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
    }) || r("value", function (e, t, i) {
      return i || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue;
    }), s(function (e) {
      return null == e.getAttribute("disabled");
    }) || r(Z, function (e, t, i) {
      var n;
      return i ? void 0 : !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null;
    }), t;
  }(e);

  se.find = ue, se.expr = ue.selectors, se.expr[":"] = se.expr.pseudos, se.unique = ue.uniqueSort, se.text = ue.getText, se.isXMLDoc = ue.isXML, se.contains = ue.contains;
  var ce = se.expr.match.needsContext,
      de = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      pe = /^.[^:#\[\.,]*$/;
  se.filter = function (e, t, i) {
    var n = t[0];
    return i && (e = ":not(" + e + ")"), 1 === t.length && 1 === n.nodeType ? se.find.matchesSelector(n, e) ? [n] : [] : se.find.matches(e, se.grep(t, function (e) {
      return 1 === e.nodeType;
    }));
  }, se.fn.extend({
    find: function find(e) {
      var t,
          i = [],
          n = this,
          s = n.length;
      if ("string" != typeof e) return this.pushStack(se(e).filter(function () {
        for (t = 0; s > t; t++) {
          if (se.contains(n[t], this)) return !0;
        }
      }));

      for (t = 0; s > t; t++) {
        se.find(e, n[t], i);
      }

      return i = this.pushStack(s > 1 ? se.unique(i) : i), i.selector = this.selector ? this.selector + " " + e : e, i;
    },
    filter: function filter(e) {
      return this.pushStack(n(this, e || [], !1));
    },
    not: function not(e) {
      return this.pushStack(n(this, e || [], !0));
    },
    is: function is(e) {
      return !!n(this, "string" == typeof e && ce.test(e) ? se(e) : e || [], !1).length;
    }
  });
  var he,
      fe = e.document,
      me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
  (se.fn.init = function (e, t) {
    var i, n;
    if (!e) return this;

    if ("string" == typeof e) {
      if (!(i = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : me.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || he).find(e) : this.constructor(t).find(e);

      if (i[1]) {
        if (t = t instanceof se ? t[0] : t, se.merge(this, se.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : fe, !0)), de.test(i[1]) && se.isPlainObject(t)) for (i in t) {
          se.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        }
        return this;
      }

      if ((n = fe.getElementById(i[2])) && n.parentNode) {
        if (n.id !== i[2]) return he.find(e);
        this.length = 1, this[0] = n;
      }

      return this.context = fe, this.selector = e, this;
    }

    return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : se.isFunction(e) ? void 0 !== he.ready ? he.ready(e) : e(se) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), se.makeArray(e, this));
  }).prototype = se.fn, he = se(fe);
  var ge = /^(?:parents|prev(?:Until|All))/,
      be = {
    children: !0,
    contents: !0,
    next: !0,
    prev: !0
  };
  se.extend({
    dir: function dir(e, t, i) {
      for (var n = [], s = e[t]; s && 9 !== s.nodeType && (void 0 === i || 1 !== s.nodeType || !se(s).is(i));) {
        1 === s.nodeType && n.push(s), s = s[t];
      }

      return n;
    },
    sibling: function sibling(e, t) {
      for (var i = []; e; e = e.nextSibling) {
        1 === e.nodeType && e !== t && i.push(e);
      }

      return i;
    }
  }), se.fn.extend({
    has: function has(e) {
      var t,
          i = se(e, this),
          n = i.length;
      return this.filter(function () {
        for (t = 0; n > t; t++) {
          if (se.contains(this, i[t])) return !0;
        }
      });
    },
    closest: function closest(e, t) {
      for (var i, n = 0, s = this.length, r = [], o = ce.test(e) || "string" != typeof e ? se(e, t || this.context) : 0; s > n; n++) {
        for (i = this[n]; i && i !== t; i = i.parentNode) {
          if (i.nodeType < 11 && (o ? o.index(i) > -1 : 1 === i.nodeType && se.find.matchesSelector(i, e))) {
            r.push(i);
            break;
          }
        }
      }

      return this.pushStack(r.length > 1 ? se.unique(r) : r);
    },
    index: function index(e) {
      return e ? "string" == typeof e ? se.inArray(this[0], se(e)) : se.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    },
    add: function add(e, t) {
      return this.pushStack(se.unique(se.merge(this.get(), se(e, t))));
    },
    addBack: function addBack(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }
  }), se.each({
    parent: function parent(e) {
      var t = e.parentNode;
      return t && 11 !== t.nodeType ? t : null;
    },
    parents: function parents(e) {
      return se.dir(e, "parentNode");
    },
    parentsUntil: function parentsUntil(e, t, i) {
      return se.dir(e, "parentNode", i);
    },
    next: function next(e) {
      return s(e, "nextSibling");
    },
    prev: function prev(e) {
      return s(e, "previousSibling");
    },
    nextAll: function nextAll(e) {
      return se.dir(e, "nextSibling");
    },
    prevAll: function prevAll(e) {
      return se.dir(e, "previousSibling");
    },
    nextUntil: function nextUntil(e, t, i) {
      return se.dir(e, "nextSibling", i);
    },
    prevUntil: function prevUntil(e, t, i) {
      return se.dir(e, "previousSibling", i);
    },
    siblings: function siblings(e) {
      return se.sibling((e.parentNode || {}).firstChild, e);
    },
    children: function children(e) {
      return se.sibling(e.firstChild);
    },
    contents: function contents(e) {
      return se.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : se.merge([], e.childNodes);
    }
  }, function (e, t) {
    se.fn[e] = function (i, n) {
      var s = se.map(this, t, i);
      return "Until" !== e.slice(-5) && (n = i), n && "string" == typeof n && (s = se.filter(n, s)), this.length > 1 && (be[e] || (s = se.unique(s)), ge.test(e) && (s = s.reverse())), this.pushStack(s);
    };
  });
  var ve = /\S+/g,
      ke = {};
  se.Callbacks = function (e) {
    e = "string" == typeof e ? ke[e] || r(e) : se.extend({}, e);

    var t,
        i,
        n,
        s,
        o,
        a,
        l = [],
        u = !e.once && [],
        c = function c(r) {
      for (i = e.memory && r, n = !0, o = a || 0, a = 0, s = l.length, t = !0; l && s > o; o++) {
        if (!1 === l[o].apply(r[0], r[1]) && e.stopOnFalse) {
          i = !1;
          break;
        }
      }

      t = !1, l && (u ? u.length && c(u.shift()) : i ? l = [] : d.disable());
    },
        d = {
      add: function add() {
        if (l) {
          var n = l.length;
          !function t(i) {
            se.each(i, function (i, n) {
              var s = se.type(n);
              "function" === s ? e.unique && d.has(n) || l.push(n) : n && n.length && "string" !== s && t(n);
            });
          }(arguments), t ? s = l.length : i && (a = n, c(i));
        }

        return this;
      },
      remove: function remove() {
        return l && se.each(arguments, function (e, i) {
          for (var n; (n = se.inArray(i, l, n)) > -1;) {
            l.splice(n, 1), t && (s >= n && s--, o >= n && o--);
          }
        }), this;
      },
      has: function has(e) {
        return e ? se.inArray(e, l) > -1 : !(!l || !l.length);
      },
      empty: function empty() {
        return l = [], s = 0, this;
      },
      disable: function disable() {
        return l = u = i = void 0, this;
      },
      disabled: function disabled() {
        return !l;
      },
      lock: function lock() {
        return u = void 0, i || d.disable(), this;
      },
      locked: function locked() {
        return !u;
      },
      fireWith: function fireWith(e, i) {
        return !l || n && !u || (i = i || [], i = [e, i.slice ? i.slice() : i], t ? u.push(i) : c(i)), this;
      },
      fire: function fire() {
        return d.fireWith(this, arguments), this;
      },
      fired: function fired() {
        return !!n;
      }
    };

    return d;
  }, se.extend({
    Deferred: function Deferred(e) {
      var t = [["resolve", "done", se.Callbacks("once memory"), "resolved"], ["reject", "fail", se.Callbacks("once memory"), "rejected"], ["notify", "progress", se.Callbacks("memory")]],
          i = "pending",
          n = {
        state: function state() {
          return i;
        },
        always: function always() {
          return s.done(arguments).fail(arguments), this;
        },
        then: function then() {
          var e = arguments;
          return se.Deferred(function (i) {
            se.each(t, function (t, r) {
              var o = se.isFunction(e[t]) && e[t];
              s[r[1]](function () {
                var e = o && o.apply(this, arguments);
                e && se.isFunction(e.promise) ? e.promise().done(i.resolve).fail(i.reject).progress(i.notify) : i[r[0] + "With"](this === n ? i.promise() : this, o ? [e] : arguments);
              });
            }), e = null;
          }).promise();
        },
        promise: function promise(e) {
          return null != e ? se.extend(e, n) : n;
        }
      },
          s = {};
      return n.pipe = n.then, se.each(t, function (e, r) {
        var o = r[2],
            a = r[3];
        n[r[1]] = o.add, a && o.add(function () {
          i = a;
        }, t[1 ^ e][2].disable, t[2][2].lock), s[r[0]] = function () {
          return s[r[0] + "With"](this === s ? n : this, arguments), this;
        }, s[r[0] + "With"] = o.fireWith;
      }), n.promise(s), e && e.call(s, s), s;
    },
    when: function when(e) {
      var t,
          i,
          n,
          s = 0,
          r = J.call(arguments),
          o = r.length,
          a = 1 !== o || e && se.isFunction(e.promise) ? o : 0,
          l = 1 === a ? e : se.Deferred(),
          u = function u(e, i, n) {
        return function (s) {
          i[e] = this, n[e] = arguments.length > 1 ? J.call(arguments) : s, n === t ? l.notifyWith(i, n) : --a || l.resolveWith(i, n);
        };
      };

      if (o > 1) for (t = new Array(o), i = new Array(o), n = new Array(o); o > s; s++) {
        r[s] && se.isFunction(r[s].promise) ? r[s].promise().done(u(s, n, r)).fail(l.reject).progress(u(s, i, t)) : --a;
      }
      return a || l.resolveWith(n, r), l.promise();
    }
  });
  var ye;
  se.fn.ready = function (e) {
    return se.ready.promise().done(e), this;
  }, se.extend({
    isReady: !1,
    readyWait: 1,
    holdReady: function holdReady(e) {
      e ? se.readyWait++ : se.ready(!0);
    },
    ready: function ready(e) {
      if (!0 === e ? ! --se.readyWait : !se.isReady) {
        if (!fe.body) return setTimeout(se.ready);
        se.isReady = !0, !0 !== e && --se.readyWait > 0 || (ye.resolveWith(fe, [se]), se.fn.triggerHandler && (se(fe).triggerHandler("ready"), se(fe).off("ready")));
      }
    }
  }), se.ready.promise = function (t) {
    if (!ye) if (ye = se.Deferred(), "complete" === fe.readyState) setTimeout(se.ready);else if (fe.addEventListener) fe.addEventListener("DOMContentLoaded", a, !1), e.addEventListener("load", a, !1);else {
      fe.attachEvent("onreadystatechange", a), e.attachEvent("onload", a);
      var i = !1;

      try {
        i = null == e.frameElement && fe.documentElement;
      } catch (e) {}

      i && i.doScroll && function e() {
        if (!se.isReady) {
          try {
            i.doScroll("left");
          } catch (t) {
            return setTimeout(e, 50);
          }

          o(), se.ready();
        }
      }();
    }
    return ye.promise(t);
  };
  var we,
      Se = "undefined";

  for (we in se(ie)) {
    break;
  }

  ie.ownLast = "0" !== we, ie.inlineBlockNeedsLayout = !1, se(function () {
    var e, t, i, n;
    (i = fe.getElementsByTagName("body")[0]) && i.style && (t = fe.createElement("div"), n = fe.createElement("div"), n.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", i.appendChild(n).appendChild(t), (0, _typeof2["default"])(t.style.zoom) !== Se && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", ie.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (i.style.zoom = 1)), i.removeChild(n));
  }), function () {
    var e = fe.createElement("div");

    if (null == ie.deleteExpando) {
      ie.deleteExpando = !0;

      try {
        delete e.test;
      } catch (e) {
        ie.deleteExpando = !1;
      }
    }

    e = null;
  }(), se.acceptData = function (e) {
    var t = se.noData[(e.nodeName + " ").toLowerCase()],
        i = +e.nodeType || 1;
    return (1 === i || 9 === i) && (!t || !0 !== t && e.getAttribute("classid") === t);
  };
  var Te = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      xe = /([A-Z])/g;
  se.extend({
    cache: {},
    noData: {
      "applet ": !0,
      "embed ": !0,
      "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
    },
    hasData: function hasData(e) {
      return !!(e = e.nodeType ? se.cache[e[se.expando]] : e[se.expando]) && !u(e);
    },
    data: function data(e, t, i) {
      return c(e, t, i);
    },
    removeData: function removeData(e, t) {
      return d(e, t);
    },
    _data: function _data(e, t, i) {
      return c(e, t, i, !0);
    },
    _removeData: function _removeData(e, t) {
      return d(e, t, !0);
    }
  }), se.fn.extend({
    data: function data(e, t) {
      var i,
          n,
          s,
          r = this[0],
          o = r && r.attributes;

      if (void 0 === e) {
        if (this.length && (s = se.data(r), 1 === r.nodeType && !se._data(r, "parsedAttrs"))) {
          for (i = o.length; i--;) {
            o[i] && (n = o[i].name, 0 === n.indexOf("data-") && (n = se.camelCase(n.slice(5)), l(r, n, s[n])));
          }

          se._data(r, "parsedAttrs", !0);
        }

        return s;
      }

      return "object" == (0, _typeof2["default"])(e) ? this.each(function () {
        se.data(this, e);
      }) : arguments.length > 1 ? this.each(function () {
        se.data(this, e, t);
      }) : r ? l(r, e, se.data(r, e)) : void 0;
    },
    removeData: function removeData(e) {
      return this.each(function () {
        se.removeData(this, e);
      });
    }
  }), se.extend({
    queue: function queue(e, t, i) {
      var n;
      return e ? (t = (t || "fx") + "queue", n = se._data(e, t), i && (!n || se.isArray(i) ? n = se._data(e, t, se.makeArray(i)) : n.push(i)), n || []) : void 0;
    },
    dequeue: function dequeue(e, t) {
      t = t || "fx";

      var i = se.queue(e, t),
          n = i.length,
          s = i.shift(),
          r = se._queueHooks(e, t),
          o = function o() {
        se.dequeue(e, t);
      };

      "inprogress" === s && (s = i.shift(), n--), s && ("fx" === t && i.unshift("inprogress"), delete r.stop, s.call(e, o, r)), !n && r && r.empty.fire();
    },
    _queueHooks: function _queueHooks(e, t) {
      var i = t + "queueHooks";
      return se._data(e, i) || se._data(e, i, {
        empty: se.Callbacks("once memory").add(function () {
          se._removeData(e, t + "queue"), se._removeData(e, i);
        })
      });
    }
  }), se.fn.extend({
    queue: function queue(e, t) {
      var i = 2;
      return "string" != typeof e && (t = e, e = "fx", i--), arguments.length < i ? se.queue(this[0], e) : void 0 === t ? this : this.each(function () {
        var i = se.queue(this, e, t);
        se._queueHooks(this, e), "fx" === e && "inprogress" !== i[0] && se.dequeue(this, e);
      });
    },
    dequeue: function dequeue(e) {
      return this.each(function () {
        se.dequeue(this, e);
      });
    },
    clearQueue: function clearQueue(e) {
      return this.queue(e || "fx", []);
    },
    promise: function promise(e, t) {
      var i,
          n = 1,
          s = se.Deferred(),
          r = this,
          o = this.length,
          a = function a() {
        --n || s.resolveWith(r, [r]);
      };

      for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; o--;) {
        (i = se._data(r[o], e + "queueHooks")) && i.empty && (n++, i.empty.add(a));
      }

      return a(), s.promise(t);
    }
  });

  var Ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Ce = ["Top", "Right", "Bottom", "Left"],
      Ie = function Ie(e, t) {
    return e = t || e, "none" === se.css(e, "display") || !se.contains(e.ownerDocument, e);
  },
      Re = se.access = function (e, t, i, n, s, r, o) {
    var a = 0,
        l = e.length,
        u = null == i;

    if ("object" === se.type(i)) {
      s = !0;

      for (a in i) {
        se.access(e, t, a, i[a], !0, r, o);
      }
    } else if (void 0 !== n && (s = !0, se.isFunction(n) || (o = !0), u && (o ? (t.call(e, n), t = null) : (u = t, t = function t(e, _t2, i) {
      return u.call(se(e), i);
    })), t)) for (; l > a; a++) {
      t(e[a], i, o ? n : n.call(e[a], a, t(e[a], i)));
    }

    return s ? e : u ? t.call(e) : l ? t(e[0], i) : r;
  },
      De = /^(?:checkbox|radio)$/i;

  !function () {
    var e = fe.createElement("input"),
        t = fe.createElement("div"),
        i = fe.createDocumentFragment();

    if (t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", ie.leadingWhitespace = 3 === t.firstChild.nodeType, ie.tbody = !t.getElementsByTagName("tbody").length, ie.htmlSerialize = !!t.getElementsByTagName("link").length, ie.html5Clone = "<:nav></:nav>" !== fe.createElement("nav").cloneNode(!0).outerHTML, e.type = "checkbox", e.checked = !0, i.appendChild(e), ie.appendChecked = e.checked, t.innerHTML = "<textarea>x</textarea>", ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, i.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, ie.noCloneEvent = !0, t.attachEvent && (t.attachEvent("onclick", function () {
      ie.noCloneEvent = !1;
    }), t.cloneNode(!0).click()), null == ie.deleteExpando) {
      ie.deleteExpando = !0;

      try {
        delete t.test;
      } catch (e) {
        ie.deleteExpando = !1;
      }
    }
  }(), function () {
    var t,
        i,
        n = fe.createElement("div");

    for (t in {
      submit: !0,
      change: !0,
      focusin: !0
    }) {
      i = "on" + t, (ie[t + "Bubbles"] = i in e) || (n.setAttribute(i, "t"), ie[t + "Bubbles"] = !1 === n.attributes[i].expando);
    }

    n = null;
  }();
  var Ne = /^(?:input|select|textarea)$/i,
      Fe = /^key/,
      Ae = /^(?:mouse|pointer|contextmenu)|click/,
      _e = /^(?:focusinfocus|focusoutblur)$/,
      Pe = /^([^.]*)(?:\.(.+)|)$/;
  se.event = {
    global: {},
    add: function add(e, t, i, n, s) {
      var r,
          o,
          a,
          l,
          u,
          c,
          d,
          p,
          h,
          f,
          m,
          g = se._data(e);

      if (g) {
        for (i.handler && (l = i, i = l.handler, s = l.selector), i.guid || (i.guid = se.guid++), (o = g.events) || (o = g.events = {}), (c = g.handle) || (c = g.handle = function (e) {
          return (0, _typeof2["default"])(se) === Se || e && se.event.triggered === e.type ? void 0 : se.event.dispatch.apply(c.elem, arguments);
        }, c.elem = e), t = (t || "").match(ve) || [""], a = t.length; a--;) {
          r = Pe.exec(t[a]) || [], h = m = r[1], f = (r[2] || "").split(".").sort(), h && (u = se.event.special[h] || {}, h = (s ? u.delegateType : u.bindType) || h, u = se.event.special[h] || {}, d = se.extend({
            type: h,
            origType: m,
            data: n,
            handler: i,
            guid: i.guid,
            selector: s,
            needsContext: s && se.expr.match.needsContext.test(s),
            namespace: f.join(".")
          }, l), (p = o[h]) || (p = o[h] = [], p.delegateCount = 0, u.setup && !1 !== u.setup.call(e, n, f, c) || (e.addEventListener ? e.addEventListener(h, c, !1) : e.attachEvent && e.attachEvent("on" + h, c))), u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = i.guid)), s ? p.splice(p.delegateCount++, 0, d) : p.push(d), se.event.global[h] = !0);
        }

        e = null;
      }
    },
    remove: function remove(e, t, i, n, s) {
      var r,
          o,
          a,
          l,
          u,
          c,
          d,
          p,
          h,
          f,
          m,
          g = se.hasData(e) && se._data(e);

      if (g && (c = g.events)) {
        for (t = (t || "").match(ve) || [""], u = t.length; u--;) {
          if (a = Pe.exec(t[u]) || [], h = m = a[1], f = (a[2] || "").split(".").sort(), h) {
            for (d = se.event.special[h] || {}, h = (n ? d.delegateType : d.bindType) || h, p = c[h] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), l = r = p.length; r--;) {
              o = p[r], !s && m !== o.origType || i && i.guid !== o.guid || a && !a.test(o.namespace) || n && n !== o.selector && ("**" !== n || !o.selector) || (p.splice(r, 1), o.selector && p.delegateCount--, d.remove && d.remove.call(e, o));
            }

            l && !p.length && (d.teardown && !1 !== d.teardown.call(e, f, g.handle) || se.removeEvent(e, h, g.handle), delete c[h]);
          } else for (h in c) {
            se.event.remove(e, h + t[u], i, n, !0);
          }
        }

        se.isEmptyObject(c) && (delete g.handle, se._removeData(e, "events"));
      }
    },
    trigger: function trigger(t, i, n, s) {
      var r,
          o,
          a,
          l,
          u,
          c,
          d,
          p = [n || fe],
          h = te.call(t, "type") ? t.type : t,
          f = te.call(t, "namespace") ? t.namespace.split(".") : [];

      if (a = c = n = n || fe, 3 !== n.nodeType && 8 !== n.nodeType && !_e.test(h + se.event.triggered) && (h.indexOf(".") >= 0 && (f = h.split("."), h = f.shift(), f.sort()), o = h.indexOf(":") < 0 && "on" + h, t = t[se.expando] ? t : new se.Event(h, "object" == (0, _typeof2["default"])(t) && t), t.isTrigger = s ? 2 : 3, t.namespace = f.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), i = null == i ? [t] : se.makeArray(i, [t]), u = se.event.special[h] || {}, s || !u.trigger || !1 !== u.trigger.apply(n, i))) {
        if (!s && !u.noBubble && !se.isWindow(n)) {
          for (l = u.delegateType || h, _e.test(l + h) || (a = a.parentNode); a; a = a.parentNode) {
            p.push(a), c = a;
          }

          c === (n.ownerDocument || fe) && p.push(c.defaultView || c.parentWindow || e);
        }

        for (d = 0; (a = p[d++]) && !t.isPropagationStopped();) {
          t.type = d > 1 ? l : u.bindType || h, r = (se._data(a, "events") || {})[t.type] && se._data(a, "handle"), r && r.apply(a, i), (r = o && a[o]) && r.apply && se.acceptData(a) && (t.result = r.apply(a, i), !1 === t.result && t.preventDefault());
        }

        if (t.type = h, !s && !t.isDefaultPrevented() && (!u._default || !1 === u._default.apply(p.pop(), i)) && se.acceptData(n) && o && n[h] && !se.isWindow(n)) {
          c = n[o], c && (n[o] = null), se.event.triggered = h;

          try {
            n[h]();
          } catch (e) {}

          se.event.triggered = void 0, c && (n[o] = c);
        }

        return t.result;
      }
    },
    dispatch: function dispatch(e) {
      e = se.event.fix(e);
      var t,
          i,
          n,
          s,
          r,
          o = [],
          a = J.call(arguments),
          l = (se._data(this, "events") || {})[e.type] || [],
          u = se.event.special[e.type] || {};

      if (a[0] = e, e.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, e)) {
        for (o = se.event.handlers.call(this, e, l), t = 0; (s = o[t++]) && !e.isPropagationStopped();) {
          for (e.currentTarget = s.elem, r = 0; (n = s.handlers[r++]) && !e.isImmediatePropagationStopped();) {
            (!e.namespace_re || e.namespace_re.test(n.namespace)) && (e.handleObj = n, e.data = n.data, void 0 !== (i = ((se.event.special[n.origType] || {}).handle || n.handler).apply(s.elem, a)) && !1 === (e.result = i) && (e.preventDefault(), e.stopPropagation()));
          }
        }

        return u.postDispatch && u.postDispatch.call(this, e), e.result;
      }
    },
    handlers: function handlers(e, t) {
      var i,
          n,
          s,
          r,
          o = [],
          a = t.delegateCount,
          l = e.target;
      if (a && l.nodeType && (!e.button || "click" !== e.type)) for (; l != this; l = l.parentNode || this) {
        if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
          for (s = [], r = 0; a > r; r++) {
            n = t[r], i = n.selector + " ", void 0 === s[i] && (s[i] = n.needsContext ? se(i, this).index(l) >= 0 : se.find(i, this, null, [l]).length), s[i] && s.push(n);
          }

          s.length && o.push({
            elem: l,
            handlers: s
          });
        }
      }
      return a < t.length && o.push({
        elem: this,
        handlers: t.slice(a)
      }), o;
    },
    fix: function fix(e) {
      if (e[se.expando]) return e;
      var t,
          i,
          n,
          s = e.type,
          r = e,
          o = this.fixHooks[s];

      for (o || (this.fixHooks[s] = o = Ae.test(s) ? this.mouseHooks : Fe.test(s) ? this.keyHooks : {}), n = o.props ? this.props.concat(o.props) : this.props, e = new se.Event(r), t = n.length; t--;) {
        i = n[t], e[i] = r[i];
      }

      return e.target || (e.target = r.srcElement || fe), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, o.filter ? o.filter(e, r) : e;
    },
    props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function filter(e, t) {
        return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
      }
    },
    mouseHooks: {
      props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
      filter: function filter(e, t) {
        var i,
            n,
            s,
            r = t.button,
            o = t.fromElement;
        return null == e.pageX && null != t.clientX && (n = e.target.ownerDocument || fe, s = n.documentElement, i = n.body, e.pageX = t.clientX + (s && s.scrollLeft || i && i.scrollLeft || 0) - (s && s.clientLeft || i && i.clientLeft || 0), e.pageY = t.clientY + (s && s.scrollTop || i && i.scrollTop || 0) - (s && s.clientTop || i && i.clientTop || 0)), !e.relatedTarget && o && (e.relatedTarget = o === e.target ? t.toElement : o), e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0), e;
      }
    },
    special: {
      load: {
        noBubble: !0
      },
      focus: {
        trigger: function trigger() {
          if (this !== f() && this.focus) try {
            return this.focus(), !1;
          } catch (e) {}
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function trigger() {
          return this === f() && this.blur ? (this.blur(), !1) : void 0;
        },
        delegateType: "focusout"
      },
      click: {
        trigger: function trigger() {
          return se.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0;
        },
        _default: function _default(e) {
          return se.nodeName(e.target, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        }
      }
    },
    simulate: function simulate(e, t, i, n) {
      var s = se.extend(new se.Event(), i, {
        type: e,
        isSimulated: !0,
        originalEvent: {}
      });
      n ? se.event.trigger(s, null, t) : se.event.dispatch.call(t, s), s.isDefaultPrevented() && i.preventDefault();
    }
  }, se.removeEvent = fe.removeEventListener ? function (e, t, i) {
    e.removeEventListener && e.removeEventListener(t, i, !1);
  } : function (e, t, i) {
    var n = "on" + t;
    e.detachEvent && ((0, _typeof2["default"])(e[n]) === Se && (e[n] = null), e.detachEvent(n, i));
  }, se.Event = function (e, t) {
    return this instanceof se.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? p : h) : this.type = e, t && se.extend(this, t), this.timeStamp = e && e.timeStamp || se.now(), void (this[se.expando] = !0)) : new se.Event(e, t);
  }, se.Event.prototype = {
    isDefaultPrevented: h,
    isPropagationStopped: h,
    isImmediatePropagationStopped: h,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = p, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1);
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = p, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0);
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = p, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation();
    }
  }, se.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (e, t) {
    se.event.special[e] = {
      delegateType: t,
      bindType: t,
      handle: function handle(e) {
        var i,
            n = this,
            s = e.relatedTarget,
            r = e.handleObj;
        return (!s || s !== n && !se.contains(n, s)) && (e.type = r.origType, i = r.handler.apply(this, arguments), e.type = t), i;
      }
    };
  }), ie.submitBubbles || (se.event.special.submit = {
    setup: function setup() {
      return !se.nodeName(this, "form") && void se.event.add(this, "click._submit keypress._submit", function (e) {
        var t = e.target,
            i = se.nodeName(t, "input") || se.nodeName(t, "button") ? t.form : void 0;
        i && !se._data(i, "submitBubbles") && (se.event.add(i, "submit._submit", function (e) {
          e._submit_bubble = !0;
        }), se._data(i, "submitBubbles", !0));
      });
    },
    postDispatch: function postDispatch(e) {
      e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && se.event.simulate("submit", this.parentNode, e, !0));
    },
    teardown: function teardown() {
      return !se.nodeName(this, "form") && void se.event.remove(this, "._submit");
    }
  }), ie.changeBubbles || (se.event.special.change = {
    setup: function setup() {
      return Ne.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (se.event.add(this, "propertychange._change", function (e) {
        "checked" === e.originalEvent.propertyName && (this._just_changed = !0);
      }), se.event.add(this, "click._change", function (e) {
        this._just_changed && !e.isTrigger && (this._just_changed = !1), se.event.simulate("change", this, e, !0);
      })), !1) : void se.event.add(this, "beforeactivate._change", function (e) {
        var t = e.target;
        Ne.test(t.nodeName) && !se._data(t, "changeBubbles") && (se.event.add(t, "change._change", function (e) {
          !this.parentNode || e.isSimulated || e.isTrigger || se.event.simulate("change", this.parentNode, e, !0);
        }), se._data(t, "changeBubbles", !0));
      });
    },
    handle: function handle(e) {
      var t = e.target;
      return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0;
    },
    teardown: function teardown() {
      return se.event.remove(this, "._change"), !Ne.test(this.nodeName);
    }
  }), ie.focusinBubbles || se.each({
    focus: "focusin",
    blur: "focusout"
  }, function (e, t) {
    var i = function i(e) {
      se.event.simulate(t, e.target, se.event.fix(e), !0);
    };

    se.event.special[t] = {
      setup: function setup() {
        var n = this.ownerDocument || this,
            s = se._data(n, t);

        s || n.addEventListener(e, i, !0), se._data(n, t, (s || 0) + 1);
      },
      teardown: function teardown() {
        var n = this.ownerDocument || this,
            s = se._data(n, t) - 1;
        s ? se._data(n, t, s) : (n.removeEventListener(e, i, !0), se._removeData(n, t));
      }
    };
  }), se.fn.extend({
    on: function on(e, t, i, n, s) {
      var r, o;

      if ("object" == (0, _typeof2["default"])(e)) {
        "string" != typeof t && (i = i || t, t = void 0);

        for (r in e) {
          this.on(r, t, i, e[r], s);
        }

        return this;
      }

      if (null == i && null == n ? (n = t, i = t = void 0) : null == n && ("string" == typeof t ? (n = i, i = void 0) : (n = i, i = t, t = void 0)), !1 === n) n = h;else if (!n) return this;
      return 1 === s && (o = n, n = function n(e) {
        return se().off(e), o.apply(this, arguments);
      }, n.guid = o.guid || (o.guid = se.guid++)), this.each(function () {
        se.event.add(this, e, n, i, t);
      });
    },
    one: function one(e, t, i, n) {
      return this.on(e, t, i, n, 1);
    },
    off: function off(e, t, i) {
      var n, s;
      if (e && e.preventDefault && e.handleObj) return n = e.handleObj, se(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;

      if ("object" == (0, _typeof2["default"])(e)) {
        for (s in e) {
          this.off(s, t, e[s]);
        }

        return this;
      }

      return (!1 === t || "function" == typeof t) && (i = t, t = void 0), !1 === i && (i = h), this.each(function () {
        se.event.remove(this, e, i, t);
      });
    },
    trigger: function trigger(e, t) {
      return this.each(function () {
        se.event.trigger(e, t, this);
      });
    },
    triggerHandler: function triggerHandler(e, t) {
      var i = this[0];
      return i ? se.event.trigger(e, t, i, !0) : void 0;
    }
  });
  var je = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
      Le = / jQuery\d+="(?:null|\d+)"/g,
      Oe = new RegExp("<(?:" + je + ")[\\s/>]", "i"),
      Me = /^\s+/,
      He = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      ze = /<([\w:]+)/,
      Ue = /<tbody/i,
      qe = /<|&#?\w+;/,
      We = /<(?:script|style|link)/i,
      Be = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Ve = /^$|\/(?:java|ecma)script/i,
      Xe = /^true\/(.*)/,
      Ye = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      $e = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    legend: [1, "<fieldset>", "</fieldset>"],
    area: [1, "<map>", "</map>"],
    param: [1, "<object>", "</object>"],
    thead: [1, "<table>", "</table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: ie.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
  },
      Je = m(fe),
      Ge = Je.appendChild(fe.createElement("div"));
  $e.optgroup = $e.option, $e.tbody = $e.tfoot = $e.colgroup = $e.caption = $e.thead, $e.th = $e.td, se.extend({
    clone: function clone(e, t, i) {
      var n,
          s,
          r,
          o,
          a,
          l = se.contains(e.ownerDocument, e);
      if (ie.html5Clone || se.isXMLDoc(e) || !Oe.test("<" + e.nodeName + ">") ? r = e.cloneNode(!0) : (Ge.innerHTML = e.outerHTML, Ge.removeChild(r = Ge.firstChild)), !(ie.noCloneEvent && ie.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || se.isXMLDoc(e))) for (n = g(r), a = g(e), o = 0; null != (s = a[o]); ++o) {
        n[o] && T(s, n[o]);
      }
      if (t) if (i) for (a = a || g(e), n = n || g(r), o = 0; null != (s = a[o]); o++) {
        S(s, n[o]);
      } else S(e, r);
      return n = g(r, "script"), n.length > 0 && w(n, !l && g(e, "script")), n = a = s = null, r;
    },
    buildFragment: function buildFragment(e, t, i, n) {
      for (var s, r, o, a, l, u, c, d = e.length, p = m(t), h = [], f = 0; d > f; f++) {
        if ((r = e[f]) || 0 === r) if ("object" === se.type(r)) se.merge(h, r.nodeType ? [r] : r);else if (qe.test(r)) {
          for (a = a || p.appendChild(t.createElement("div")), l = (ze.exec(r) || ["", ""])[1].toLowerCase(), c = $e[l] || $e._default, a.innerHTML = c[1] + r.replace(He, "<$1></$2>") + c[2], s = c[0]; s--;) {
            a = a.lastChild;
          }

          if (!ie.leadingWhitespace && Me.test(r) && h.push(t.createTextNode(Me.exec(r)[0])), !ie.tbody) for (r = "table" !== l || Ue.test(r) ? "<table>" !== c[1] || Ue.test(r) ? 0 : a : a.firstChild, s = r && r.childNodes.length; s--;) {
            se.nodeName(u = r.childNodes[s], "tbody") && !u.childNodes.length && r.removeChild(u);
          }

          for (se.merge(h, a.childNodes), a.textContent = ""; a.firstChild;) {
            a.removeChild(a.firstChild);
          }

          a = p.lastChild;
        } else h.push(t.createTextNode(r));
      }

      for (a && p.removeChild(a), ie.appendChecked || se.grep(g(h, "input"), b), f = 0; r = h[f++];) {
        if ((!n || -1 === se.inArray(r, n)) && (o = se.contains(r.ownerDocument, r), a = g(p.appendChild(r), "script"), o && w(a), i)) for (s = 0; r = a[s++];) {
          Ve.test(r.type || "") && i.push(r);
        }
      }

      return a = null, p;
    },
    cleanData: function cleanData(e, t) {
      for (var i, n, s, r, o = 0, a = se.expando, l = se.cache, u = ie.deleteExpando, c = se.event.special; null != (i = e[o]); o++) {
        if ((t || se.acceptData(i)) && (s = i[a], r = s && l[s])) {
          if (r.events) for (n in r.events) {
            c[n] ? se.event.remove(i, n) : se.removeEvent(i, n, r.handle);
          }
          l[s] && (delete l[s], u ? delete i[a] : (0, _typeof2["default"])(i.removeAttribute) !== Se ? i.removeAttribute(a) : i[a] = null, $.push(s));
        }
      }
    }
  }), se.fn.extend({
    text: function text(e) {
      return Re(this, function (e) {
        return void 0 === e ? se.text(this) : this.empty().append((this[0] && this[0].ownerDocument || fe).createTextNode(e));
      }, null, e, arguments.length);
    },
    append: function append() {
      return this.domManip(arguments, function (e) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          v(this, e).appendChild(e);
        }
      });
    },
    prepend: function prepend() {
      return this.domManip(arguments, function (e) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var t = v(this, e);
          t.insertBefore(e, t.firstChild);
        }
      });
    },
    before: function before() {
      return this.domManip(arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this);
      });
    },
    after: function after() {
      return this.domManip(arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
      });
    },
    remove: function remove(e, t) {
      for (var i, n = e ? se.filter(e, this) : this, s = 0; null != (i = n[s]); s++) {
        t || 1 !== i.nodeType || se.cleanData(g(i)), i.parentNode && (t && se.contains(i.ownerDocument, i) && w(g(i, "script")), i.parentNode.removeChild(i));
      }

      return this;
    },
    empty: function empty() {
      for (var e, t = 0; null != (e = this[t]); t++) {
        for (1 === e.nodeType && se.cleanData(g(e, !1)); e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.options && se.nodeName(e, "select") && (e.options.length = 0);
      }

      return this;
    },
    clone: function clone(e, t) {
      return e = null != e && e, t = null == t ? e : t, this.map(function () {
        return se.clone(this, e, t);
      });
    },
    html: function html(e) {
      return Re(this, function (e) {
        var t = this[0] || {},
            i = 0,
            n = this.length;
        if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(Le, "") : void 0;

        if (!("string" != typeof e || We.test(e) || !ie.htmlSerialize && Oe.test(e) || !ie.leadingWhitespace && Me.test(e) || $e[(ze.exec(e) || ["", ""])[1].toLowerCase()])) {
          e = e.replace(He, "<$1></$2>");

          try {
            for (; n > i; i++) {
              t = this[i] || {}, 1 === t.nodeType && (se.cleanData(g(t, !1)), t.innerHTML = e);
            }

            t = 0;
          } catch (e) {}
        }

        t && this.empty().append(e);
      }, null, e, arguments.length);
    },
    replaceWith: function replaceWith() {
      var e = arguments[0];
      return this.domManip(arguments, function (t) {
        e = this.parentNode, se.cleanData(g(this)), e && e.replaceChild(t, this);
      }), e && (e.length || e.nodeType) ? this : this.remove();
    },
    detach: function detach(e) {
      return this.remove(e, !0);
    },
    domManip: function domManip(e, t) {
      e = G.apply([], e);
      var i,
          n,
          s,
          r,
          o,
          a,
          l = 0,
          u = this.length,
          c = this,
          d = u - 1,
          p = e[0],
          h = se.isFunction(p);
      if (h || u > 1 && "string" == typeof p && !ie.checkClone && Be.test(p)) return this.each(function (i) {
        var n = c.eq(i);
        h && (e[0] = p.call(this, i, n.html())), n.domManip(e, t);
      });

      if (u && (a = se.buildFragment(e, this[0].ownerDocument, !1, this), i = a.firstChild, 1 === a.childNodes.length && (a = i), i)) {
        for (r = se.map(g(a, "script"), k), s = r.length; u > l; l++) {
          n = a, l !== d && (n = se.clone(n, !0, !0), s && se.merge(r, g(n, "script"))), t.call(this[l], n, l);
        }

        if (s) for (o = r[r.length - 1].ownerDocument, se.map(r, y), l = 0; s > l; l++) {
          n = r[l], Ve.test(n.type || "") && !se._data(n, "globalEval") && se.contains(o, n) && (n.src ? se._evalUrl && se._evalUrl(n.src) : se.globalEval((n.text || n.textContent || n.innerHTML || "").replace(Ye, "")));
        }
        a = i = null;
      }

      return this;
    }
  }), se.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (e, t) {
    se.fn[e] = function (e) {
      for (var i, n = 0, s = [], r = se(e), o = r.length - 1; o >= n; n++) {
        i = n === o ? this : this.clone(!0), se(r[n])[t](i), K.apply(s, i.get());
      }

      return this.pushStack(s);
    };
  });
  var Ke,
      Qe = {};
  !function () {
    var e;

    ie.shrinkWrapBlocks = function () {
      if (null != e) return e;
      e = !1;
      var t, i, n;
      return i = fe.getElementsByTagName("body")[0], i && i.style ? (t = fe.createElement("div"), n = fe.createElement("div"), n.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", i.appendChild(n).appendChild(t), (0, _typeof2["default"])(t.style.zoom) !== Se && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", t.appendChild(fe.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), i.removeChild(n), e) : void 0;
    };
  }();
  var Ze,
      et,
      tt = /^margin/,
      it = new RegExp("^(" + Ee + ")(?!px)[a-z%]+$", "i"),
      nt = /^(top|right|bottom|left)$/;
  e.getComputedStyle ? (Ze = function Ze(t) {
    return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : e.getComputedStyle(t, null);
  }, et = function et(e, t, i) {
    var n,
        s,
        r,
        o,
        a = e.style;
    return i = i || Ze(e), o = i ? i.getPropertyValue(t) || i[t] : void 0, i && ("" !== o || se.contains(e.ownerDocument, e) || (o = se.style(e, t)), it.test(o) && tt.test(t) && (n = a.width, s = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = o, o = i.width, a.width = n, a.minWidth = s, a.maxWidth = r)), void 0 === o ? o : o + "";
  }) : fe.documentElement.currentStyle && (Ze = function Ze(e) {
    return e.currentStyle;
  }, et = function et(e, t, i) {
    var n,
        s,
        r,
        o,
        a = e.style;
    return i = i || Ze(e), o = i ? i[t] : void 0, null == o && a && a[t] && (o = a[t]), it.test(o) && !nt.test(t) && (n = a.left, s = e.runtimeStyle, r = s && s.left, r && (s.left = e.currentStyle.left), a.left = "fontSize" === t ? "1em" : o, o = a.pixelLeft + "px", a.left = n, r && (s.left = r)), void 0 === o ? o : o + "" || "auto";
  }), !function () {
    function t() {
      var t, i, n, s;
      (i = fe.getElementsByTagName("body")[0]) && i.style && (t = fe.createElement("div"), n = fe.createElement("div"), n.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", i.appendChild(n).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", r = o = !1, l = !0, e.getComputedStyle && (r = "1%" !== (e.getComputedStyle(t, null) || {}).top, o = "4px" === (e.getComputedStyle(t, null) || {
        width: "4px"
      }).width, s = t.appendChild(fe.createElement("div")), s.style.cssText = t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", s.style.marginRight = s.style.width = "0", t.style.width = "1px", l = !parseFloat((e.getComputedStyle(s, null) || {}).marginRight), t.removeChild(s)), t.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", s = t.getElementsByTagName("td"), s[0].style.cssText = "margin:0;border:0;padding:0;display:none", a = 0 === s[0].offsetHeight, a && (s[0].style.display = "", s[1].style.display = "none", a = 0 === s[0].offsetHeight), i.removeChild(n));
    }

    var i, n, s, r, o, a, l;
    i = fe.createElement("div"), i.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", s = i.getElementsByTagName("a")[0], (n = s && s.style) && (n.cssText = "float:left;opacity:.5", ie.opacity = "0.5" === n.opacity, ie.cssFloat = !!n.cssFloat, i.style.backgroundClip = "content-box", i.cloneNode(!0).style.backgroundClip = "", ie.clearCloneStyle = "content-box" === i.style.backgroundClip, ie.boxSizing = "" === n.boxSizing || "" === n.MozBoxSizing || "" === n.WebkitBoxSizing, se.extend(ie, {
      reliableHiddenOffsets: function reliableHiddenOffsets() {
        return null == a && t(), a;
      },
      boxSizingReliable: function boxSizingReliable() {
        return null == o && t(), o;
      },
      pixelPosition: function pixelPosition() {
        return null == r && t(), r;
      },
      reliableMarginRight: function reliableMarginRight() {
        return null == l && t(), l;
      }
    }));
  }(), se.swap = function (e, t, i, n) {
    var s,
        r,
        o = {};

    for (r in t) {
      o[r] = e.style[r], e.style[r] = t[r];
    }

    s = i.apply(e, n || []);

    for (r in t) {
      e.style[r] = o[r];
    }

    return s;
  };
  var st = /alpha\([^)]*\)/i,
      rt = /opacity\s*=\s*([^)]*)/,
      ot = /^(none|table(?!-c[ea]).+)/,
      at = new RegExp("^(" + Ee + ")(.*)$", "i"),
      lt = new RegExp("^([+-])=(" + Ee + ")", "i"),
      ut = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
  },
      ct = {
    letterSpacing: "0",
    fontWeight: "400"
  },
      dt = ["Webkit", "O", "Moz", "ms"];
  se.extend({
    cssHooks: {
      opacity: {
        get: function get(e, t) {
          if (t) {
            var i = et(e, "opacity");
            return "" === i ? "1" : i;
          }
        }
      }
    },
    cssNumber: {
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {
      "float": ie.cssFloat ? "cssFloat" : "styleFloat"
    },
    style: function style(e, t, i, n) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var s,
            r,
            o,
            a = se.camelCase(t),
            l = e.style;
        if (t = se.cssProps[a] || (se.cssProps[a] = I(l, a)), o = se.cssHooks[t] || se.cssHooks[a], void 0 === i) return o && "get" in o && void 0 !== (s = o.get(e, !1, n)) ? s : l[t];
        if (r = (0, _typeof2["default"])(i), "string" === r && (s = lt.exec(i)) && (i = (s[1] + 1) * s[2] + parseFloat(se.css(e, t)), r = "number"), null != i && i === i && ("number" !== r || se.cssNumber[a] || (i += "px"), ie.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (l[t] = "inherit"), !(o && "set" in o && void 0 === (i = o.set(e, i, n))))) try {
          l[t] = i;
        } catch (e) {}
      }
    },
    css: function css(e, t, i, n) {
      var s,
          r,
          o,
          a = se.camelCase(t);
      return t = se.cssProps[a] || (se.cssProps[a] = I(e.style, a)), o = se.cssHooks[t] || se.cssHooks[a], o && "get" in o && (r = o.get(e, !0, i)), void 0 === r && (r = et(e, t, n)), "normal" === r && t in ct && (r = ct[t]), "" === i || i ? (s = parseFloat(r), !0 === i || se.isNumeric(s) ? s || 0 : r) : r;
    }
  }), se.each(["height", "width"], function (e, t) {
    se.cssHooks[t] = {
      get: function get(e, i, n) {
        return i ? ot.test(se.css(e, "display")) && 0 === e.offsetWidth ? se.swap(e, ut, function () {
          return F(e, t, n);
        }) : F(e, t, n) : void 0;
      },
      set: function set(e, i, n) {
        var s = n && Ze(e);
        return D(e, i, n ? N(e, t, n, ie.boxSizing && "border-box" === se.css(e, "boxSizing", !1, s), s) : 0);
      }
    };
  }), ie.opacity || (se.cssHooks.opacity = {
    get: function get(e, t) {
      return rt.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : "";
    },
    set: function set(e, t) {
      var i = e.style,
          n = e.currentStyle,
          s = se.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
          r = n && n.filter || i.filter || "";
      i.zoom = 1, (t >= 1 || "" === t) && "" === se.trim(r.replace(st, "")) && i.removeAttribute && (i.removeAttribute("filter"), "" === t || n && !n.filter) || (i.filter = st.test(r) ? r.replace(st, s) : r + " " + s);
    }
  }), se.cssHooks.marginRight = C(ie.reliableMarginRight, function (e, t) {
    return t ? se.swap(e, {
      display: "inline-block"
    }, et, [e, "marginRight"]) : void 0;
  }), se.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (e, t) {
    se.cssHooks[e + t] = {
      expand: function expand(i) {
        for (var n = 0, s = {}, r = "string" == typeof i ? i.split(" ") : [i]; 4 > n; n++) {
          s[e + Ce[n] + t] = r[n] || r[n - 2] || r[0];
        }

        return s;
      }
    }, tt.test(e) || (se.cssHooks[e + t].set = D);
  }), se.fn.extend({
    css: function css(e, t) {
      return Re(this, function (e, t, i) {
        var n,
            s,
            r = {},
            o = 0;

        if (se.isArray(t)) {
          for (n = Ze(e), s = t.length; s > o; o++) {
            r[t[o]] = se.css(e, t[o], !1, n);
          }

          return r;
        }

        return void 0 !== i ? se.style(e, t, i) : se.css(e, t);
      }, e, t, arguments.length > 1);
    },
    show: function show() {
      return R(this, !0);
    },
    hide: function hide() {
      return R(this);
    },
    toggle: function toggle(e) {
      return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
        Ie(this) ? se(this).show() : se(this).hide();
      });
    }
  }), se.Tween = A, A.prototype = {
    constructor: A,
    init: function init(e, t, i, n, s, r) {
      this.elem = e, this.prop = i, this.easing = s || "swing", this.options = t, this.start = this.now = this.cur(), this.end = n, this.unit = r || (se.cssNumber[i] ? "" : "px");
    },
    cur: function cur() {
      var e = A.propHooks[this.prop];
      return e && e.get ? e.get(this) : A.propHooks._default.get(this);
    },
    run: function run(e) {
      var t,
          i = A.propHooks[this.prop];
      return this.pos = t = this.options.duration ? se.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : A.propHooks._default.set(this), this;
    }
  }, A.prototype.init.prototype = A.prototype, A.propHooks = {
    _default: {
      get: function get(e) {
        var t;
        return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = se.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0) : e.elem[e.prop];
      },
      set: function set(e) {
        se.fx.step[e.prop] ? se.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[se.cssProps[e.prop]] || se.cssHooks[e.prop]) ? se.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now;
      }
    }
  }, A.propHooks.scrollTop = A.propHooks.scrollLeft = {
    set: function set(e) {
      e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
    }
  }, se.easing = {
    linear: function linear(e) {
      return e;
    },
    swing: function swing(e) {
      return .5 - Math.cos(e * Math.PI) / 2;
    }
  }, se.fx = A.prototype.init, se.fx.step = {};
  var pt,
      ht,
      ft = /^(?:toggle|show|hide)$/,
      mt = new RegExp("^(?:([+-])=|)(" + Ee + ")([a-z%]*)$", "i"),
      gt = /queueHooks$/,
      bt = [L],
      vt = {
    "*": [function (e, t) {
      var i = this.createTween(e, t),
          n = i.cur(),
          s = mt.exec(t),
          r = s && s[3] || (se.cssNumber[e] ? "" : "px"),
          o = (se.cssNumber[e] || "px" !== r && +n) && mt.exec(se.css(i.elem, e)),
          a = 1,
          l = 20;

      if (o && o[3] !== r) {
        r = r || o[3], s = s || [], o = +n || 1;

        do {
          a = a || ".5", o /= a, se.style(i.elem, e, o + r);
        } while (a !== (a = i.cur() / n) && 1 !== a && --l);
      }

      return s && (o = i.start = +o || +n || 0, i.unit = r, i.end = s[1] ? o + (s[1] + 1) * s[2] : +s[2]), i;
    }]
  };
  se.Animation = se.extend(M, {
    tweener: function tweener(e, t) {
      se.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");

      for (var i, n = 0, s = e.length; s > n; n++) {
        i = e[n], vt[i] = vt[i] || [], vt[i].unshift(t);
      }
    },
    prefilter: function prefilter(e, t) {
      t ? bt.unshift(e) : bt.push(e);
    }
  }), se.speed = function (e, t, i) {
    var n = e && "object" == (0, _typeof2["default"])(e) ? se.extend({}, e) : {
      complete: i || !i && t || se.isFunction(e) && e,
      duration: e,
      easing: i && t || t && !se.isFunction(t) && t
    };
    return n.duration = se.fx.off ? 0 : "number" == typeof n.duration ? n.duration : n.duration in se.fx.speeds ? se.fx.speeds[n.duration] : se.fx.speeds._default, (null == n.queue || !0 === n.queue) && (n.queue = "fx"), n.old = n.complete, n.complete = function () {
      se.isFunction(n.old) && n.old.call(this), n.queue && se.dequeue(this, n.queue);
    }, n;
  }, se.fn.extend({
    fadeTo: function fadeTo(e, t, i, n) {
      return this.filter(Ie).css("opacity", 0).show().end().animate({
        opacity: t
      }, e, i, n);
    },
    animate: function animate(e, t, i, n) {
      var s = se.isEmptyObject(e),
          r = se.speed(t, i, n),
          o = function o() {
        var t = M(this, se.extend({}, e), r);
        (s || se._data(this, "finish")) && t.stop(!0);
      };

      return o.finish = o, s || !1 === r.queue ? this.each(o) : this.queue(r.queue, o);
    },
    stop: function stop(e, t, i) {
      var n = function n(e) {
        var t = e.stop;
        delete e.stop, t(i);
      };

      return "string" != typeof e && (i = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
        var t = !0,
            s = null != e && e + "queueHooks",
            r = se.timers,
            o = se._data(this);

        if (s) o[s] && o[s].stop && n(o[s]);else for (s in o) {
          o[s] && o[s].stop && gt.test(s) && n(o[s]);
        }

        for (s = r.length; s--;) {
          r[s].elem !== this || null != e && r[s].queue !== e || (r[s].anim.stop(i), t = !1, r.splice(s, 1));
        }

        (t || !i) && se.dequeue(this, e);
      });
    },
    finish: function finish(e) {
      return !1 !== e && (e = e || "fx"), this.each(function () {
        var t,
            i = se._data(this),
            n = i[e + "queue"],
            s = i[e + "queueHooks"],
            r = se.timers,
            o = n ? n.length : 0;

        for (i.finish = !0, se.queue(this, e, []), s && s.stop && s.stop.call(this, !0), t = r.length; t--;) {
          r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
        }

        for (t = 0; o > t; t++) {
          n[t] && n[t].finish && n[t].finish.call(this);
        }

        delete i.finish;
      });
    }
  }), se.each(["toggle", "show", "hide"], function (e, t) {
    var i = se.fn[t];

    se.fn[t] = function (e, n, s) {
      return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(P(t, !0), e, n, s);
    };
  }), se.each({
    slideDown: P("show"),
    slideUp: P("hide"),
    slideToggle: P("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (e, t) {
    se.fn[e] = function (e, i, n) {
      return this.animate(t, e, i, n);
    };
  }), se.timers = [], se.fx.tick = function () {
    var e,
        t = se.timers,
        i = 0;

    for (pt = se.now(); i < t.length; i++) {
      (e = t[i])() || t[i] !== e || t.splice(i--, 1);
    }

    t.length || se.fx.stop(), pt = void 0;
  }, se.fx.timer = function (e) {
    se.timers.push(e), e() ? se.fx.start() : se.timers.pop();
  }, se.fx.interval = 13, se.fx.start = function () {
    ht || (ht = setInterval(se.fx.tick, se.fx.interval));
  }, se.fx.stop = function () {
    clearInterval(ht), ht = null;
  }, se.fx.speeds = {
    slow: 600,
    fast: 200,
    _default: 400
  }, se.fn.delay = function (e, t) {
    return e = se.fx ? se.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, i) {
      var n = setTimeout(t, e);

      i.stop = function () {
        clearTimeout(n);
      };
    });
  }, function () {
    var e, t, i, n, s;
    t = fe.createElement("div"), t.setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", n = t.getElementsByTagName("a")[0], i = fe.createElement("select"), s = i.appendChild(fe.createElement("option")), e = t.getElementsByTagName("input")[0], n.style.cssText = "top:1px", ie.getSetAttribute = "t" !== t.className, ie.style = /top/.test(n.getAttribute("style")), ie.hrefNormalized = "/a" === n.getAttribute("href"), ie.checkOn = !!e.value, ie.optSelected = s.selected, ie.enctype = !!fe.createElement("form").enctype, i.disabled = !0, ie.optDisabled = !s.disabled, e = fe.createElement("input"), e.setAttribute("value", ""), ie.input = "" === e.getAttribute("value"), e.value = "t", e.setAttribute("type", "radio"), ie.radioValue = "t" === e.value;
  }();
  var kt = /\r/g;
  se.fn.extend({
    val: function val(e) {
      var t,
          i,
          n,
          s = this[0];
      return arguments.length ? (n = se.isFunction(e), this.each(function (i) {
        var s;
        1 === this.nodeType && (s = n ? e.call(this, i, se(this).val()) : e, null == s ? s = "" : "number" == typeof s ? s += "" : se.isArray(s) && (s = se.map(s, function (e) {
          return null == e ? "" : e + "";
        })), (t = se.valHooks[this.type] || se.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, s, "value") || (this.value = s));
      })) : s ? (t = se.valHooks[s.type] || se.valHooks[s.nodeName.toLowerCase()], t && "get" in t && void 0 !== (i = t.get(s, "value")) ? i : (i = s.value, "string" == typeof i ? i.replace(kt, "") : null == i ? "" : i)) : void 0;
    }
  }), se.extend({
    valHooks: {
      option: {
        get: function get(e) {
          var t = se.find.attr(e, "value");
          return null != t ? t : se.trim(se.text(e));
        }
      },
      select: {
        get: function get(e) {
          for (var t, i, n = e.options, s = e.selectedIndex, r = "select-one" === e.type || 0 > s, o = r ? null : [], a = r ? s + 1 : n.length, l = 0 > s ? a : r ? s : 0; a > l; l++) {
            if (i = n[l], !(!i.selected && l !== s || (ie.optDisabled ? i.disabled : null !== i.getAttribute("disabled")) || i.parentNode.disabled && se.nodeName(i.parentNode, "optgroup"))) {
              if (t = se(i).val(), r) return t;
              o.push(t);
            }
          }

          return o;
        },
        set: function set(e, t) {
          for (var i, n, s = e.options, r = se.makeArray(t), o = s.length; o--;) {
            if (n = s[o], se.inArray(se.valHooks.option.get(n), r) >= 0) try {
              n.selected = i = !0;
            } catch (e) {
              n.scrollHeight;
            } else n.selected = !1;
          }

          return i || (e.selectedIndex = -1), s;
        }
      }
    }
  }), se.each(["radio", "checkbox"], function () {
    se.valHooks[this] = {
      set: function set(e, t) {
        return se.isArray(t) ? e.checked = se.inArray(se(e).val(), t) >= 0 : void 0;
      }
    }, ie.checkOn || (se.valHooks[this].get = function (e) {
      return null === e.getAttribute("value") ? "on" : e.value;
    });
  });
  var yt,
      wt,
      St = se.expr.attrHandle,
      Tt = /^(?:checked|selected)$/i,
      xt = ie.getSetAttribute,
      Et = ie.input;
  se.fn.extend({
    attr: function attr(e, t) {
      return Re(this, se.attr, e, t, arguments.length > 1);
    },
    removeAttr: function removeAttr(e) {
      return this.each(function () {
        se.removeAttr(this, e);
      });
    }
  }), se.extend({
    attr: function attr(e, t, i) {
      var n,
          s,
          r = e.nodeType;
      if (e && 3 !== r && 8 !== r && 2 !== r) return (0, _typeof2["default"])(e.getAttribute) === Se ? se.prop(e, t, i) : (1 === r && se.isXMLDoc(e) || (t = t.toLowerCase(), n = se.attrHooks[t] || (se.expr.match.bool.test(t) ? wt : yt)), void 0 === i ? n && "get" in n && null !== (s = n.get(e, t)) ? s : (s = se.find.attr(e, t), null == s ? void 0 : s) : null !== i ? n && "set" in n && void 0 !== (s = n.set(e, i, t)) ? s : (e.setAttribute(t, i + ""), i) : void se.removeAttr(e, t));
    },
    removeAttr: function removeAttr(e, t) {
      var i,
          n,
          s = 0,
          r = t && t.match(ve);
      if (r && 1 === e.nodeType) for (; i = r[s++];) {
        n = se.propFix[i] || i, se.expr.match.bool.test(i) ? Et && xt || !Tt.test(i) ? e[n] = !1 : e[se.camelCase("default-" + i)] = e[n] = !1 : se.attr(e, i, ""), e.removeAttribute(xt ? i : n);
      }
    },
    attrHooks: {
      type: {
        set: function set(e, t) {
          if (!ie.radioValue && "radio" === t && se.nodeName(e, "input")) {
            var i = e.value;
            return e.setAttribute("type", t), i && (e.value = i), t;
          }
        }
      }
    }
  }), wt = {
    set: function set(e, t, i) {
      return !1 === t ? se.removeAttr(e, i) : Et && xt || !Tt.test(i) ? e.setAttribute(!xt && se.propFix[i] || i, i) : e[se.camelCase("default-" + i)] = e[i] = !0, i;
    }
  }, se.each(se.expr.match.bool.source.match(/\w+/g), function (e, t) {
    var i = St[t] || se.find.attr;
    St[t] = Et && xt || !Tt.test(t) ? function (e, t, n) {
      var s, r;
      return n || (r = St[t], St[t] = s, s = null != i(e, t, n) ? t.toLowerCase() : null, St[t] = r), s;
    } : function (e, t, i) {
      return i ? void 0 : e[se.camelCase("default-" + t)] ? t.toLowerCase() : null;
    };
  }), Et && xt || (se.attrHooks.value = {
    set: function set(e, t, i) {
      return se.nodeName(e, "input") ? void (e.defaultValue = t) : yt && yt.set(e, t, i);
    }
  }), xt || (yt = {
    set: function set(e, t, i) {
      var n = e.getAttributeNode(i);
      return n || e.setAttributeNode(n = e.ownerDocument.createAttribute(i)), n.value = t += "", "value" === i || t === e.getAttribute(i) ? t : void 0;
    }
  }, St.id = St.name = St.coords = function (e, t, i) {
    var n;
    return i ? void 0 : (n = e.getAttributeNode(t)) && "" !== n.value ? n.value : null;
  }, se.valHooks.button = {
    get: function get(e, t) {
      var i = e.getAttributeNode(t);
      return i && i.specified ? i.value : void 0;
    },
    set: yt.set
  }, se.attrHooks.contenteditable = {
    set: function set(e, t, i) {
      yt.set(e, "" !== t && t, i);
    }
  }, se.each(["width", "height"], function (e, t) {
    se.attrHooks[t] = {
      set: function set(e, i) {
        return "" === i ? (e.setAttribute(t, "auto"), i) : void 0;
      }
    };
  })), ie.style || (se.attrHooks.style = {
    get: function get(e) {
      return e.style.cssText || void 0;
    },
    set: function set(e, t) {
      return e.style.cssText = t + "";
    }
  });
  var Ct = /^(?:input|select|textarea|button|object)$/i,
      It = /^(?:a|area)$/i;
  se.fn.extend({
    prop: function prop(e, t) {
      return Re(this, se.prop, e, t, arguments.length > 1);
    },
    removeProp: function removeProp(e) {
      return e = se.propFix[e] || e, this.each(function () {
        try {
          this[e] = void 0, delete this[e];
        } catch (e) {}
      });
    }
  }), se.extend({
    propFix: {
      "for": "htmlFor",
      "class": "className"
    },
    prop: function prop(e, t, i) {
      var n,
          s,
          r,
          o = e.nodeType;
      if (e && 3 !== o && 8 !== o && 2 !== o) return r = 1 !== o || !se.isXMLDoc(e), r && (t = se.propFix[t] || t, s = se.propHooks[t]), void 0 !== i ? s && "set" in s && void 0 !== (n = s.set(e, i, t)) ? n : e[t] = i : s && "get" in s && null !== (n = s.get(e, t)) ? n : e[t];
    },
    propHooks: {
      tabIndex: {
        get: function get(e) {
          var t = se.find.attr(e, "tabindex");
          return t ? parseInt(t, 10) : Ct.test(e.nodeName) || It.test(e.nodeName) && e.href ? 0 : -1;
        }
      }
    }
  }), ie.hrefNormalized || se.each(["href", "src"], function (e, t) {
    se.propHooks[t] = {
      get: function get(e) {
        return e.getAttribute(t, 4);
      }
    };
  }), ie.optSelected || (se.propHooks.selected = {
    get: function get(e) {
      var t = e.parentNode;
      return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
    }
  }), se.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    se.propFix[this.toLowerCase()] = this;
  }), ie.enctype || (se.propFix.enctype = "encoding");
  var Rt = /[\t\r\n\f]/g;
  se.fn.extend({
    addClass: function addClass(e) {
      var t,
          i,
          n,
          s,
          r,
          o,
          a = 0,
          l = this.length,
          u = "string" == typeof e && e;
      if (se.isFunction(e)) return this.each(function (t) {
        se(this).addClass(e.call(this, t, this.className));
      });
      if (u) for (t = (e || "").match(ve) || []; l > a; a++) {
        if (i = this[a], n = 1 === i.nodeType && (i.className ? (" " + i.className + " ").replace(Rt, " ") : " ")) {
          for (r = 0; s = t[r++];) {
            n.indexOf(" " + s + " ") < 0 && (n += s + " ");
          }

          o = se.trim(n), i.className !== o && (i.className = o);
        }
      }
      return this;
    },
    removeClass: function removeClass(e) {
      var t,
          i,
          n,
          s,
          r,
          o,
          a = 0,
          l = this.length,
          u = 0 === arguments.length || "string" == typeof e && e;
      if (se.isFunction(e)) return this.each(function (t) {
        se(this).removeClass(e.call(this, t, this.className));
      });
      if (u) for (t = (e || "").match(ve) || []; l > a; a++) {
        if (i = this[a], n = 1 === i.nodeType && (i.className ? (" " + i.className + " ").replace(Rt, " ") : "")) {
          for (r = 0; s = t[r++];) {
            for (; n.indexOf(" " + s + " ") >= 0;) {
              n = n.replace(" " + s + " ", " ");
            }
          }

          o = e ? se.trim(n) : "", i.className !== o && (i.className = o);
        }
      }
      return this;
    },
    toggleClass: function toggleClass(e, t) {
      var i = (0, _typeof2["default"])(e);
      return "boolean" == typeof t && "string" === i ? t ? this.addClass(e) : this.removeClass(e) : this.each(se.isFunction(e) ? function (i) {
        se(this).toggleClass(e.call(this, i, this.className, t), t);
      } : function () {
        if ("string" === i) for (var t, n = 0, s = se(this), r = e.match(ve) || []; t = r[n++];) {
          s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
        } else (i === Se || "boolean" === i) && (this.className && se._data(this, "__className__", this.className), this.className = this.className || !1 === e ? "" : se._data(this, "__className__") || "");
      });
    },
    hasClass: function hasClass(e) {
      for (var t = " " + e + " ", i = 0, n = this.length; n > i; i++) {
        if (1 === this[i].nodeType && (" " + this[i].className + " ").replace(Rt, " ").indexOf(t) >= 0) return !0;
      }

      return !1;
    }
  }), se.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
    se.fn[t] = function (e, i) {
      return arguments.length > 0 ? this.on(t, null, e, i) : this.trigger(t);
    };
  }), se.fn.extend({
    hover: function hover(e, t) {
      return this.mouseenter(e).mouseleave(t || e);
    },
    bind: function bind(e, t, i) {
      return this.on(e, null, t, i);
    },
    unbind: function unbind(e, t) {
      return this.off(e, null, t);
    },
    delegate: function delegate(e, t, i, n) {
      return this.on(t, e, i, n);
    },
    undelegate: function undelegate(e, t, i) {
      return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i);
    }
  });
  var Dt = se.now(),
      Nt = /\?/,
      Ft = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
  se.parseJSON = function (t) {
    if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
    var i,
        n = null,
        s = se.trim(t + "");
    return s && !se.trim(s.replace(Ft, function (e, t, s, r) {
      return i && t && (n = 0), 0 === n ? e : (i = s || t, n += !r - !s, "");
    })) ? Function("return " + s)() : se.error("Invalid JSON: " + t);
  }, se.parseXML = function (t) {
    var i, n;
    if (!t || "string" != typeof t) return null;

    try {
      e.DOMParser ? (n = new DOMParser(), i = n.parseFromString(t, "text/xml")) : (i = new ActiveXObject("Microsoft.XMLDOM"), i.async = "false", i.loadXML(t));
    } catch (e) {
      i = void 0;
    }

    return i && i.documentElement && !i.getElementsByTagName("parsererror").length || se.error("Invalid XML: " + t), i;
  };

  var At,
      _t,
      Pt = /#.*$/,
      jt = /([?&])_=[^&]*/,
      Lt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      Ot = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Mt = /^(?:GET|HEAD)$/,
      Ht = /^\/\//,
      zt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      Ut = {},
      qt = {},
      Wt = "*/".concat("*");

  try {
    _t = location.href;
  } catch (e) {
    _t = fe.createElement("a"), _t.href = "", _t = _t.href;
  }

  At = zt.exec(_t.toLowerCase()) || [], se.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: _t,
      type: "GET",
      isLocal: Ot.test(At[1]),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": Wt,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /xml/,
        html: /html/,
        json: /json/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": se.parseJSON,
        "text xml": se.parseXML
      },
      flatOptions: {
        url: !0,
        context: !0
      }
    },
    ajaxSetup: function ajaxSetup(e, t) {
      return t ? U(U(e, se.ajaxSettings), t) : U(se.ajaxSettings, e);
    },
    ajaxPrefilter: H(Ut),
    ajaxTransport: H(qt),
    ajax: function ajax(e, t) {
      function i(e, t, i, n) {
        var s,
            c,
            b,
            v,
            y,
            S = t;
        2 !== k && (k = 2, a && clearTimeout(a), u = void 0, o = n || "", w.readyState = e > 0 ? 4 : 0, s = e >= 200 && 300 > e || 304 === e, i && (v = q(d, w, i)), v = W(d, v, w, s), s ? (d.ifModified && (y = w.getResponseHeader("Last-Modified"), y && (se.lastModified[r] = y), (y = w.getResponseHeader("etag")) && (se.etag[r] = y)), 204 === e || "HEAD" === d.type ? S = "nocontent" : 304 === e ? S = "notmodified" : (S = v.state, c = v.data, b = v.error, s = !b)) : (b = S, (e || !S) && (S = "error", 0 > e && (e = 0))), w.status = e, w.statusText = (t || S) + "", s ? f.resolveWith(p, [c, S, w]) : f.rejectWith(p, [w, S, b]), w.statusCode(g), g = void 0, l && h.trigger(s ? "ajaxSuccess" : "ajaxError", [w, d, s ? c : b]), m.fireWith(p, [w, S]), l && (h.trigger("ajaxComplete", [w, d]), --se.active || se.event.trigger("ajaxStop")));
      }

      "object" == (0, _typeof2["default"])(e) && (t = e, e = void 0), t = t || {};
      var n,
          s,
          r,
          o,
          a,
          l,
          u,
          c,
          d = se.ajaxSetup({}, t),
          p = d.context || d,
          h = d.context && (p.nodeType || p.jquery) ? se(p) : se.event,
          f = se.Deferred(),
          m = se.Callbacks("once memory"),
          g = d.statusCode || {},
          b = {},
          v = {},
          k = 0,
          y = "canceled",
          w = {
        readyState: 0,
        getResponseHeader: function getResponseHeader(e) {
          var t;

          if (2 === k) {
            if (!c) for (c = {}; t = Lt.exec(o);) {
              c[t[1].toLowerCase()] = t[2];
            }
            t = c[e.toLowerCase()];
          }

          return null == t ? null : t;
        },
        getAllResponseHeaders: function getAllResponseHeaders() {
          return 2 === k ? o : null;
        },
        setRequestHeader: function setRequestHeader(e, t) {
          var i = e.toLowerCase();
          return k || (e = v[i] = v[i] || e, b[e] = t), this;
        },
        overrideMimeType: function overrideMimeType(e) {
          return k || (d.mimeType = e), this;
        },
        statusCode: function statusCode(e) {
          var t;
          if (e) if (2 > k) for (t in e) {
            g[t] = [g[t], e[t]];
          } else w.always(e[w.status]);
          return this;
        },
        abort: function abort(e) {
          var t = e || y;
          return u && u.abort(t), i(0, t), this;
        }
      };
      if (f.promise(w).complete = m.add, w.success = w.done, w.error = w.fail, d.url = ((e || d.url || _t) + "").replace(Pt, "").replace(Ht, At[1] + "//"), d.type = t.method || t.type || d.method || d.type, d.dataTypes = se.trim(d.dataType || "*").toLowerCase().match(ve) || [""], null == d.crossDomain && (n = zt.exec(d.url.toLowerCase()), d.crossDomain = !(!n || n[1] === At[1] && n[2] === At[2] && (n[3] || ("http:" === n[1] ? "80" : "443")) === (At[3] || ("http:" === At[1] ? "80" : "443")))), d.data && d.processData && "string" != typeof d.data && (d.data = se.param(d.data, d.traditional)), z(Ut, d, t, w), 2 === k) return w;
      l = se.event && d.global, l && 0 == se.active++ && se.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !Mt.test(d.type), r = d.url, d.hasContent || (d.data && (r = d.url += (Nt.test(r) ? "&" : "?") + d.data, delete d.data), !1 === d.cache && (d.url = jt.test(r) ? r.replace(jt, "$1_=" + Dt++) : r + (Nt.test(r) ? "&" : "?") + "_=" + Dt++)), d.ifModified && (se.lastModified[r] && w.setRequestHeader("If-Modified-Since", se.lastModified[r]), se.etag[r] && w.setRequestHeader("If-None-Match", se.etag[r])), (d.data && d.hasContent && !1 !== d.contentType || t.contentType) && w.setRequestHeader("Content-Type", d.contentType), w.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + Wt + "; q=0.01" : "") : d.accepts["*"]);

      for (s in d.headers) {
        w.setRequestHeader(s, d.headers[s]);
      }

      if (d.beforeSend && (!1 === d.beforeSend.call(p, w, d) || 2 === k)) return w.abort();
      y = "abort";

      for (s in {
        success: 1,
        error: 1,
        complete: 1
      }) {
        w[s](d[s]);
      }

      if (u = z(qt, d, t, w)) {
        w.readyState = 1, l && h.trigger("ajaxSend", [w, d]), d.async && d.timeout > 0 && (a = setTimeout(function () {
          w.abort("timeout");
        }, d.timeout));

        try {
          k = 1, u.send(b, i);
        } catch (e) {
          if (!(2 > k)) throw e;
          i(-1, e);
        }
      } else i(-1, "No Transport");

      return w;
    },
    getJSON: function getJSON(e, t, i) {
      return se.get(e, t, i, "json");
    },
    getScript: function getScript(e, t) {
      return se.get(e, void 0, t, "script");
    }
  }), se.each(["get", "post"], function (e, t) {
    se[t] = function (e, i, n, s) {
      return se.isFunction(i) && (s = s || n, n = i, i = void 0), se.ajax({
        url: e,
        type: t,
        dataType: s,
        data: i,
        success: n
      });
    };
  }), se._evalUrl = function (e) {
    return se.ajax({
      url: e,
      type: "GET",
      dataType: "script",
      async: !1,
      global: !1,
      "throws": !0
    });
  }, se.fn.extend({
    wrapAll: function wrapAll(e) {
      if (se.isFunction(e)) return this.each(function (t) {
        se(this).wrapAll(e.call(this, t));
      });

      if (this[0]) {
        var t = se(e, this[0].ownerDocument).eq(0).clone(!0);
        this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
          for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) {
            e = e.firstChild;
          }

          return e;
        }).append(this);
      }

      return this;
    },
    wrapInner: function wrapInner(e) {
      return this.each(se.isFunction(e) ? function (t) {
        se(this).wrapInner(e.call(this, t));
      } : function () {
        var t = se(this),
            i = t.contents();
        i.length ? i.wrapAll(e) : t.append(e);
      });
    },
    wrap: function wrap(e) {
      var t = se.isFunction(e);
      return this.each(function (i) {
        se(this).wrapAll(t ? e.call(this, i) : e);
      });
    },
    unwrap: function unwrap() {
      return this.parent().each(function () {
        se.nodeName(this, "body") || se(this).replaceWith(this.childNodes);
      }).end();
    }
  }), se.expr.filters.hidden = function (e) {
    return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !ie.reliableHiddenOffsets() && "none" === (e.style && e.style.display || se.css(e, "display"));
  }, se.expr.filters.visible = function (e) {
    return !se.expr.filters.hidden(e);
  };
  var Bt = /%20/g,
      Vt = /\[\]$/,
      Xt = /\r?\n/g,
      Yt = /^(?:submit|button|image|reset|file)$/i,
      $t = /^(?:input|select|textarea|keygen)/i;
  se.param = function (e, t) {
    var i,
        n = [],
        s = function s(e, t) {
      t = se.isFunction(t) ? t() : null == t ? "" : t, n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
    };

    if (void 0 === t && (t = se.ajaxSettings && se.ajaxSettings.traditional), se.isArray(e) || e.jquery && !se.isPlainObject(e)) se.each(e, function () {
      s(this.name, this.value);
    });else for (i in e) {
      B(i, e[i], t, s);
    }
    return n.join("&").replace(Bt, "+");
  }, se.fn.extend({
    serialize: function serialize() {
      return se.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        var e = se.prop(this, "elements");
        return e ? se.makeArray(e) : this;
      }).filter(function () {
        var e = this.type;
        return this.name && !se(this).is(":disabled") && $t.test(this.nodeName) && !Yt.test(e) && (this.checked || !De.test(e));
      }).map(function (e, t) {
        var i = se(this).val();
        return null == i ? null : se.isArray(i) ? se.map(i, function (e) {
          return {
            name: t.name,
            value: e.replace(Xt, "\r\n")
          };
        }) : {
          name: t.name,
          value: i.replace(Xt, "\r\n")
        };
      }).get();
    }
  }), se.ajaxSettings.xhr = void 0 !== e.ActiveXObject ? function () {
    return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && V() || X();
  } : V;
  var Jt = 0,
      Gt = {},
      Kt = se.ajaxSettings.xhr();
  e.attachEvent && e.attachEvent("onunload", function () {
    for (var e in Gt) {
      Gt[e](void 0, !0);
    }
  }), ie.cors = !!Kt && "withCredentials" in Kt, (Kt = ie.ajax = !!Kt) && se.ajaxTransport(function (e) {
    if (!e.crossDomain || ie.cors) {
      var _t3;

      return {
        send: function send(i, n) {
          var s,
              r = e.xhr(),
              o = ++Jt;
          if (r.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (s in e.xhrFields) {
            r[s] = e.xhrFields[s];
          }
          e.mimeType && r.overrideMimeType && r.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");

          for (s in i) {
            void 0 !== i[s] && r.setRequestHeader(s, i[s] + "");
          }

          r.send(e.hasContent && e.data || null), _t3 = function t(i, s) {
            var a, l, u;
            if (_t3 && (s || 4 === r.readyState)) if (delete Gt[o], _t3 = void 0, r.onreadystatechange = se.noop, s) 4 !== r.readyState && r.abort();else {
              u = {}, a = r.status, "string" == typeof r.responseText && (u.text = r.responseText);

              try {
                l = r.statusText;
              } catch (e) {
                l = "";
              }

              a || !e.isLocal || e.crossDomain ? 1223 === a && (a = 204) : a = u.text ? 200 : 404;
            }
            u && n(a, l, u, r.getAllResponseHeaders());
          }, e.async ? 4 === r.readyState ? setTimeout(_t3) : r.onreadystatechange = Gt[o] = _t3 : _t3();
        },
        abort: function abort() {
          _t3 && _t3(void 0, !0);
        }
      };
    }
  }), se.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /(?:java|ecma)script/
    },
    converters: {
      "text script": function textScript(e) {
        return se.globalEval(e), e;
      }
    }
  }), se.ajaxPrefilter("script", function (e) {
    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1);
  }), se.ajaxTransport("script", function (e) {
    if (e.crossDomain) {
      var t,
          i = fe.head || se("head")[0] || fe.documentElement;
      return {
        send: function send(n, s) {
          t = fe.createElement("script"), t.async = !0, e.scriptCharset && (t.charset = e.scriptCharset), t.src = e.url, t.onload = t.onreadystatechange = function (e, i) {
            (i || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, t.parentNode && t.parentNode.removeChild(t), t = null, i || s(200, "success"));
          }, i.insertBefore(t, i.firstChild);
        },
        abort: function abort() {
          t && t.onload(void 0, !0);
        }
      };
    }
  });
  var Qt = [],
      Zt = /(=)\?(?=&|$)|\?\?/;
  se.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var e = Qt.pop() || se.expando + "_" + Dt++;
      return this[e] = !0, e;
    }
  }), se.ajaxPrefilter("json jsonp", function (t, i, n) {
    var s,
        r,
        o,
        a = !1 !== t.jsonp && (Zt.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && Zt.test(t.data) && "data");
    return a || "jsonp" === t.dataTypes[0] ? (s = t.jsonpCallback = se.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Zt, "$1" + s) : !1 !== t.jsonp && (t.url += (Nt.test(t.url) ? "&" : "?") + t.jsonp + "=" + s), t.converters["script json"] = function () {
      return o || se.error(s + " was not called"), o[0];
    }, t.dataTypes[0] = "json", r = e[s], e[s] = function () {
      o = arguments;
    }, n.always(function () {
      e[s] = r, t[s] && (t.jsonpCallback = i.jsonpCallback, Qt.push(s)), o && se.isFunction(r) && r(o[0]), o = r = void 0;
    }), "script") : void 0;
  }), se.parseHTML = function (e, t, i) {
    if (!e || "string" != typeof e) return null;
    "boolean" == typeof t && (i = t, t = !1), t = t || fe;
    var n = de.exec(e),
        s = !i && [];
    return n ? [t.createElement(n[1])] : (n = se.buildFragment([e], t, s), s && s.length && se(s).remove(), se.merge([], n.childNodes));
  };
  var ei = se.fn.load;
  se.fn.load = function (e, t, i) {
    if ("string" != typeof e && ei) return ei.apply(this, arguments);
    var n,
        s,
        r,
        o = this,
        a = e.indexOf(" ");
    return a >= 0 && (n = se.trim(e.slice(a, e.length)), e = e.slice(0, a)), se.isFunction(t) ? (i = t, t = void 0) : t && "object" == (0, _typeof2["default"])(t) && (r = "POST"), o.length > 0 && se.ajax({
      url: e,
      type: r,
      dataType: "html",
      data: t
    }).done(function (e) {
      s = arguments, o.html(n ? se("<div>").append(se.parseHTML(e)).find(n) : e);
    }).complete(i && function (e, t) {
      o.each(i, s || [e.responseText, t, e]);
    }), this;
  }, se.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
    se.fn[t] = function (e) {
      return this.on(t, e);
    };
  }), se.expr.filters.animated = function (e) {
    return se.grep(se.timers, function (t) {
      return e === t.elem;
    }).length;
  };
  var ti = e.document.documentElement;
  se.offset = {
    setOffset: function setOffset(e, t, i) {
      var n,
          s,
          r,
          o,
          a,
          l,
          u,
          c = se.css(e, "position"),
          d = se(e),
          p = {};
      "static" === c && (e.style.position = "relative"), a = d.offset(), r = se.css(e, "top"), l = se.css(e, "left"), u = ("absolute" === c || "fixed" === c) && se.inArray("auto", [r, l]) > -1, u ? (n = d.position(), o = n.top, s = n.left) : (o = parseFloat(r) || 0, s = parseFloat(l) || 0), se.isFunction(t) && (t = t.call(e, i, a)), null != t.top && (p.top = t.top - a.top + o), null != t.left && (p.left = t.left - a.left + s), "using" in t ? t.using.call(e, p) : d.css(p);
    }
  }, se.fn.extend({
    offset: function offset(e) {
      if (arguments.length) return void 0 === e ? this : this.each(function (t) {
        se.offset.setOffset(this, e, t);
      });
      var t,
          i,
          n = {
        top: 0,
        left: 0
      },
          s = this[0],
          r = s && s.ownerDocument;
      return r ? (t = r.documentElement, se.contains(t, s) ? ((0, _typeof2["default"])(s.getBoundingClientRect) !== Se && (n = s.getBoundingClientRect()), i = Y(r), {
        top: n.top + (i.pageYOffset || t.scrollTop) - (t.clientTop || 0),
        left: n.left + (i.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
      }) : n) : void 0;
    },
    position: function position() {
      if (this[0]) {
        var e,
            t,
            i = {
          top: 0,
          left: 0
        },
            n = this[0];
        return "fixed" === se.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), se.nodeName(e[0], "html") || (i = e.offset()), i.top += se.css(e[0], "borderTopWidth", !0), i.left += se.css(e[0], "borderLeftWidth", !0)), {
          top: t.top - i.top - se.css(n, "marginTop", !0),
          left: t.left - i.left - se.css(n, "marginLeft", !0)
        };
      }
    },
    offsetParent: function offsetParent() {
      return this.map(function () {
        for (var e = this.offsetParent || ti; e && !se.nodeName(e, "html") && "static" === se.css(e, "position");) {
          e = e.offsetParent;
        }

        return e || ti;
      });
    }
  }), se.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (e, t) {
    var i = /Y/.test(t);

    se.fn[e] = function (n) {
      return Re(this, function (e, n, s) {
        var r = Y(e);
        return void 0 === s ? r ? t in r ? r[t] : r.document.documentElement[n] : e[n] : void (r ? r.scrollTo(i ? se(r).scrollLeft() : s, i ? s : se(r).scrollTop()) : e[n] = s);
      }, e, n, arguments.length, null);
    };
  }), se.each(["top", "left"], function (e, t) {
    se.cssHooks[t] = C(ie.pixelPosition, function (e, i) {
      return i ? (i = et(e, t), it.test(i) ? se(e).position()[t] + "px" : i) : void 0;
    });
  }), se.each({
    Height: "height",
    Width: "width"
  }, function (e, t) {
    se.each({
      padding: "inner" + e,
      content: t,
      "": "outer" + e
    }, function (i, n) {
      se.fn[n] = function (n, s) {
        var r = arguments.length && (i || "boolean" != typeof n),
            o = i || (!0 === n || !0 === s ? "margin" : "border");
        return Re(this, function (t, i, n) {
          var s;
          return se.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (s = t.documentElement, Math.max(t.body["scroll" + e], s["scroll" + e], t.body["offset" + e], s["offset" + e], s["client" + e])) : void 0 === n ? se.css(t, i, o) : se.style(t, i, n, o);
        }, t, r ? n : void 0, r, null);
      };
    });
  }), se.fn.size = function () {
    return this.length;
  }, se.fn.andSelf = se.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function () {
    return se;
  });
  var ii = e.jQuery,
      ni = e.$;
  return se.noConflict = function (t) {
    return e.$ === se && (e.$ = ni), t && e.jQuery === se && (e.jQuery = ii), se;
  }, (0, _typeof2["default"])(t) === Se && (e.jQuery = e.$ = se), se;
}), define("page/business-milestone", ["jquery"], function (e) {
  var t = e(".m-s-item"),
      i = e(".m-s-tab"),
      n = e("#m-s-select");
  t.bind("click", function (s) {
    s.preventDefault(), s.stopPropagation();
    var r = t.index(this);
    t.removeClass("current"), e(this).addClass("current"), n.val(r.toString()), e(i.removeClass("current").get(r)).addClass("current");
  }), n.bind("change", function () {
    var n = parseInt(e(this).val());
    e(t.removeClass("current").get(n)).addClass("current"), e(i.removeClass("current").get(n)).addClass("current");
  });
}), define("plugin/wyt.validateform", ["jquery"], function (e) {
  function t(e, t) {
    return t.indexOf(e) >= 0;
  }

  function i(i) {
    var n;

    switch (i) {
      case "num":
        n = d;
        break;

      case "letter":
      case "character":
        n = p;
        break;

      case "symbol":
        n = h;
        break;

      default:
        return e.noop;
    }

    return function (e) {
      t(e.keyCode || e.charCode, n) || e.preventDefault();
    };
  }

  function n(t, i) {
    return e("<div class='validate-error " + i + "'>" + t + "</div>");
  }

  var s = {
    form: "",
    url: "",
    type: "GET",
    defaultsubmit: !1,
    ajaxfile: !1,
    autoclean: !1,
    enbletip: !0,
    enbleempty: !1,
    enblelock: !1,
    enblepaste: !0,
    enblebinding: !1,
    validateclass: "",
    validatechange: e.noop,
    validateerror: e.noop,
    validatesuccess: e.noop,
    successsubmit: e.noop,
    failsubmit: e.noop,
    beforesubmit: e.noop,
    aftersubmit: e.noop
  },
      r = {
    en: {
      name: {
        empty: "Invalid Empty Name",
        error: "Name format is incorrect. Please input a-z,A-Z character"
      },
      email: {
        empty: "Invalid Empty Email",
        error: "Email format is incorrect. Format like : example@gmail.com"
      },
      telephone: {
        empty: "Invalid Empty Telephone",
        error: "Telephone format is incorrect. Please fill with 8-11 Digital"
      },
      mobile: {
        empty: "Invalid Empty MobilePhone",
        error: "MobilePhone format is incorrect. Please fill with 8-11 Digital"
      },
      phone: {
        empty: "Invalid Empty PhoneNumber",
        error: "PhoneNumber format is incorrect. Please fill with 8-11 Digital"
      },
      content: {
        empty: "Invalid Empty Content",
        error: "Content format is incorrect with Special Symbols"
      },
      other: {
        empty: "Invalid Empty",
        error: "Format is incorrect"
      }
    },
    cn: {
      name: {
        empty: "请填写名称",
        error: "名称格式错误,请使用a-z,A-Z的字母或者中文"
      },
      email: {
        empty: "请填写电子邮箱",
        error: "电子邮箱格式错误,例: example@gmail.com"
      },
      telephone: {
        empty: "请填写电话号码",
        error: "电话号码格式错误,请填写8位以上纯数字"
      },
      mobile: {
        empty: "请填写手机号码",
        error: "手机号码格式错误,请填写8位以上纯数字"
      },
      phone: {
        empty: "请填写号码",
        error: "号码格式错误, 请确保全部填写为数字"
      },
      content: {
        empty: "请填写内容",
        error: "内容格式错误"
      },
      other: {
        empty: "不能为空",
        error: "格式错误"
      }
    },
    hk: {
      name: {
        empty: "請填寫姓名",
        error: "名稱格式錯誤, 请使用英文字母或中文"
      },
      email: {
        empty: "請填寫電子郵箱",
        error: "電子郵箱格式錯誤 例: example@gmail.com"
      },
      telephone: {
        empty: "請填寫聯絡電話",
        error: "聯絡電話格式錯誤 請為8位以上純數字"
      },
      mobile: {
        empty: "請填寫手提電話",
        error: "手提電話格式錯誤 請為8位以上純數字"
      },
      phone: {
        empty: "請填寫電話号码",
        error: "電話格式錯誤 請填寫純數字"
      },
      content: {
        empty: "請填寫内容",
        error: "内容格式錯誤"
      },
      other: {
        empty: "内容为空",
        error: "内容格式錯誤"
      }
    }
  },
      o = {
    name: /^[a-z0-9\u4E00-\u9FA5\s]+$/i,
    email: /\w+@\w{2,}\.\w{2,4}/i,
    telephone: /^[0-9]{8,}$/i,
    mobile: /^[0-9]{8,}$/i,
    phone: /^[0-9]{8,}$/i,
    content: /([\s\S]+)/i
  },
      a = [8, 9, 17, 18, 37, 38, 39, 40, 46, 110],
      l = a.concat([13, 190]),
      u = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
      c = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90],
      d = u.concat(a),
      p = c.concat(l),
      h = c.concat(u).concat(l);
  return e.fn.validateForm = function (a) {
    for (var l = e.extend({}, s, a), u = this, c = [], d = u.length; d--;) {
      c.push(0);
    }

    return e(l.form).bind("submit", function (i) {
      i.preventDefault(), i.stopPropagation();
      var n = e(this),
          s = l.url ? l.url : n.attr("action") || n.attr("data-url") || window.location.href,
          r = l.type || "POST",
          o = n.serialize();

      if (!t(0, c)) {
        if (l.defaultsubmit) return this.submit() && !0;

        if (l.ajaxfile) {
          var a = new Date().getTime(),
              d = "afu_" + a,
              p = document.createElement("iframe");
          return p.id = d, p.name = d, p.style.display = "none", p.style.height = 0, p.style.lineHeight = 0, e(p).insertBefore(n).load(function (t) {
            l.aftersubmit.call(a, t);
            var i = e(this).contents().find("body").html();
            return console.log(i), e(this).unbind("load").remove(), i ? l.successsubmit.call(n, JSON.parse(i) || new Object(), t) : l.failsubmit.call(n, t);
          }), function (e) {
            return n.attr({
              action: s,
              target: d,
              method: r,
              enctype: "multipart/form-data"
            }).get(0).submit(e);
          }(function () {
            return l.beforesubmit.call(a);
          });
        }

        return e(document).ajaxStart(function () {
          l.beforesubmit.call(this, i);
        }).ajaxStop(function () {
          l.aftersubmit.call(this, i);
        }), e.ajax({
          url: s,
          type: r,
          data: o,
          success: function success(e) {
            return l.successsubmit.call(n, JSON.parse(e), i);
          },
          error: function error(e, t, i) {
            return l.failsubmit.call(n, e, t, i);
          }
        }) && n;
      }

      u.each(function (t, i) {
        c[t] || e(i).trigger(l.enblebinding ? "keydown" : "blur");
      }), !t(0, c) && n.trigger("submit");
    }) && u.each(function (t, s) {
      var a = e(s);
      l.enblepaste || a.data("validate-paste") || a.bind("contextmenu copy paste", function (e) {
        e.preventDefault();
      });
      var d = a.data("validate-lock");
      l.enblelock && d && a.bind("keydown", i(d)), a.bind("change", function (e) {
        l.validatechange.call(this, e, a.val());
      }).bind(l.enblebinding ? "keydown blur" : "blur", function (t) {
        var i = e.trim(a.val()),
            s = u.index(this),
            d = a.data("validate-type") || "other",
            p = a.data("validate-lang") || "en",
            h = a.data("validate-clean") || l.autoclean,
            f = a.data("validate-exp") ? new RegExp(a.data("validate-exp"), "gi") : o[d],
            m = Boolean(a.data("validate-empty")) || l.enbleempty,
            g = !i && !m,
            b = c[s];
        a.next(".validate-error").remove(), g ? (l.enbletip && n(r[p][d].empty, l.validateclass).insertAfter(a), l.validateerror.call(this, t, i, f), c[s] = 0) : i && !f.test(i) ? (l.enbletip && n(r[p][d].error, l.validateclass).insertAfter(a), l.validateerror.call(this, t, i, f), h && a.val(""), c[s] = 0) : (b || l.validatesuccess.call(this, t, i), c[s] = 1);
      });
    });
  }, !0;
}), define("page/business-recruitment", ["jquery", "plugin/wyt.validateform"], function (e, t) {
  e(".select-val").css("width", e(".select-box").width() - 10), AppConfig.Info.ualtIE9 || e("#bs-f-fileupload,.f-file,#bs-f-filename").bind("click", function (t) {
    t.preventDefault(), t.stopPropagation(), e("#bs-f-file").trigger("click");
  }), e("#bs-f-file").on("change", function (t) {
    t.stopPropagation();
    var i = e(this).val(),
        n = i.match(/[^\/\\]+$/);
    e("#bs-f-filename").val(n);
  }), e(".v-item").validateForm({
    form: "#f-form",
    type: "POST",
    ajaxfile: !0,
    enblelock: !0,
    enblepaste: !1,
    enblebinding: !0,
    validatechange: function validatechange(e, t) {},
    validatesuccess: function validatesuccess(e, t, i) {},
    validateerror: function validateerror(e, t, i) {},
    onsubmit: function onsubmit(e, t) {
      console.log(e);
    }
  });
}), define("page/business-statement", ["jquery"], function (e) {
  var t = e("#require").data("require-option"),
      i = "Details";
  t && t.lang && t.lang.details && (i = t.lang.details);
  var n = e(".control"),
      s = e(".bs-st-content"),
      r = "<span>+</span><i>" + i + "</i>",
      o = "<span>-</span><i>" + i + "</i>";
  n.bind("click", function (t) {
    var i = e(this),
        a = n.index(this);
    i.hasClass("open") ? (i.html(r), i.removeClass("open"), e(s.get(a)).removeClass("show")) : (s.removeClass("show"), e(".control.open").html(r), i.html(o), i.addClass("open"), e(s.get(a)).addClass("show"));
  }), n.first().trigger("click");
}), define("page/health", ["jquery"], function (e) {
  var t = e(".health-nav-item"),
      i = e(".health-right"),
      n = e(".health-right-con"),
      s = t.eq(0).find(".health-left-detail").clone(),
      r = e(".health-nav-title"),
      o = e(".health-nav-open"),
      a = !1;
  r.on("click", function () {
    var i = e(this),
        s = i.parents(".health-nav-item");

    if (!s.hasClass("current")) {
      var r = s.find(".health-left-detail").clone(),
          l = s.find(".health-nav-open"),
          u = o.find("i"),
          c = l.find("i");
      t.removeClass("current"), s.addClass("current"), n.html(r), u.text("+"), c.text("-"), a = !1;
    }
  }), o.on("click", function () {
    var i = e(this),
        s = i.parents(".health-nav-item"),
        r = i.find("i");
    if (s.hasClass("current")) s.removeClass("current"), r.text("+"), a = !0;else {
      var l = s.find(".health-left-detail").clone();
      o.find("i").text("+"), t.removeClass("current"), s.addClass("current"), n.html(l), r.text("-"), a = !1;
    }
  }), e(window).width() > 767 ? r.eq(0).trigger("click") : o.eq(0).trigger("click");

  var l = function l() {
    if (e(window).width() > 767) {
      var r = e(".health-left"),
          o = r.height(),
          l = 2 * parseInt(i.css("paddingTop"));
      n.css("minHeight", o - l), a && (t.eq(0).addClass("current"), n.html(s));
    } else a && t.eq(0).removeClass("current");
  };

  l(), e(window).on("resize", l), require(["common/map/filter"]);
}), define("plugin/wyt.slide", ["jquery"], function (e) {
  return function (t) {
    var i = e(t.view),
        n = i.find(t.items),
        s = i.find(t.controller),
        r = t.dotActiveCls;
    s.html(""), n.css("display", "none"), n.eq(0).css("display", "block"), n.each(function (e, i) {
      s.append(t.dotHtml);
    }), s.children().eq(0).addClass(r);
    var o = n.length;

    if (!(o < 2)) {
      var a,
          l,
          u = 0,
          c = 0,
          d = 0,
          p = i.width(),
          h = n.eq(0),
          f = "ios" == AppConfig.Info.devicePlatForm,
          m = !1;
      f ? e(window).on("orientationchange", function () {
        p = i.width();
      }) : e(window).on("resize", function () {
        p = i.width();
      });

      var g,
          b,
          v,
          k,
          y,
          w,
          S,
          T,
          x,
          E,
          C,
          I,
          R,
          D,
          N = !1,
          F = function F(e) {
        var t = e.clientX - g,
            i = e.clientY - b,
            n = {
          clientX: e.clientX,
          clientY: e.clientY,
          deltaX: t,
          deltaY: i,
          absDeltaX: Math.abs(t),
          absDeltaY: Math.abs(i),
          previousDeltaX: e.clientX - k,
          previousDeltaY: e.clientY - y
        };
        return k = n.clientX, y = n.clientY, S = n, n;
      },
          A = function A(e, t) {
        if (e) {
          var i = Math.abs(parseInt(a.css("left"))),
              n = i / p,
              t = t || n < .5 ? n < .2 ? 100 : 500 : 1e3;
          if (0 == d) return N = !1, clearInterval(q), void W();
          if (i <= 5) return h.css("display", "none"), a.css("left", 0), h = a, N = !1, clearInterval(q), void W();
          var o = s.children();
          o.removeClass(r), s.children().eq(u).addClass(r), a.animate({
            left: 0
          }, t), h.animate({
            left: -l
          }, t, function () {
            h.css("display", "none"), h = a, N = !1, clearInterval(q), W();
          });
        } else {
          var o = s.children();
          o.removeClass(r), s.children().eq(u).addClass(r), h.css("left", d), a.css({
            display: "",
            left: l + d
          });
        }
      },
          _ = function _(e) {
        N = !0, u = u == o - 1 ? 0 : u + 1, a = n.eq(u), a.css({
          display: "",
          left: p
        }), l = p, A(e);
      },
          P = function P(e, t, i) {
        (e = Math.min(Math.max(e, 0), o - 1)) != u && (N = !0, a = n.eq(e), l = e > u ? p : -p, a.css({
          display: "",
          left: l
        }), u = e, A(t, i));
      },
          j = function j(e, t) {
        f && m || (d = t.deltaX, d > 0 ? c <= 0 && (a = 0 == u ? n.eq(o - 1) : n.eq(u - 1), l = -p, a.css({
          display: "",
          left: l
        })) : 0 == d ? (a = null, l = 0) : c >= 0 && (a = u == o - 1 ? n.eq(0) : n.eq(u + 1), l = p, a.css({
          display: "",
          left: l
        })), c = d, A());
      },
          L = function L(e, t) {
        if (!f || !m) {
          N = !0;
          var i = t.deltaX,
              s = t.previousDeltaX;
          if (i < 0 && Math.abs(i) > 3 && s <= 0) u = u == o - 1 ? 0 : u + 1, a = n.eq(u), l = p, A(!0);else if (i > 0 && Math.abs(i) > 3 && s >= 0) u = 0 == u ? o - 1 : u - 1, a = n.eq(u), l = -p, A(!0);else {
            var r = h;
            h = a, a = r, i > 0 ? l = p : i < 0 && (l = -p), A(!0);
          }
          d = c = 0;
        }
      },
          O = function O(e) {
        clearInterval(q), C = !0;
        var e = e.originalEvent;
        E = !0;
        var t = e.changedTouches ? e.changedTouches[0] : e;
        if (g = k = t.clientX, b = y = t.clientY, v = w = e.timeStamp, T = !1, x = 0, N) return e.preventDefault(), void (E = !1);
      },
          M = function M(e) {
        C = !1;
        var e = e.originalEvent;

        if (E && !N) {
          var t = e.changedTouches ? e.changedTouches[0] : e,
              i = F(t),
              n = i.absDeltaX,
              s = i.absDeltaY;
          0 == x ? (n > s ? (e.preventDefault(), T = !0) : f && (m = !0), x++) : T && j(0, i);
        }
      },
          H = function H(e) {
        var e = e.originalEvent;
        E && (E = !1, N || (T ? L(0, S) : (clearInterval(q), W())));
      };

      AppConfig.Info.deviceSupportTouch && (I = "touchstart", R = "touchmove", D = "touchend", i.on(I, O), i.on(R, M), i.on(D, H), i.on("touchcancel", H));
      var z = s.children();

      if (z.on("click", function (e) {
        e.preventDefault(), N || (clearInterval(q), d = 5, P(z.index(this), !0, 1e3));
      }), f) {
        var U;
        e(window).on("scroll", function () {
          U && clearTimeout(U), U = setTimeout(function () {
            m = !1, N = !1;
          }, 25);
        });
      }

      var q,
          W = function W() {
        q = setInterval(function () {
          N = !0, d = -5, _(!0);
        }, 5e3);
      };

      W(), AppConfig.Info.deviceSupportTouch || (i.on("mouseenter", function () {
        clearInterval(q);
      }), i.on("mouseleave", function () {
        clearInterval(q), W();
      }));
    }
  };
}), define("page/index", ["jquery", "plugin/wyt.slide"], function (e, t) {
  t({
    view: ".banner .left-banner",
    items: ".banner-item",
    controller: ".dot",
    dotHtml: '<span class="dot-item"></span>',
    dotActiveCls: "current"
  });
  var i = document.getElementById("index-video"),
      n = document.createElement("iframe");
  n.src = "//fast.wistia.net/embed/iframe/mkmqtle76q?videoFoam=true&volumeControl=true&controlsVisibleOnLoad=true&volume=0&autoPlay=1", n.allowtransparency = !0, n.frameBorder = 0, n.scrolling = "no", n.className = "wistia_embed", n.name = "wistia_embed", n.width = "100%", n.height = "190", n.allowfullscreen = "allowfullscreen", n.oallowfullscreen = "oallowfullscreen", n.msallowfullscreen = "msallowfullscreen", n.mozallowfullscreen = "mozallowfullscreen", n.webkitallowfullscreen = "webkitallowfullscreen";
  var s = document.createElement("script");
  s.src = "//fast.wistia.com/assets/external/E-v1.js", s.aysnc = !0, s.charset = "ISO-8859-1", i.appendChild(n), i.appendChild(s);
}), function (e) {
  define("plugin/jquery.validate.min", ["jquery"], function () {
    return function () {
      return function (e) {
        e.extend(e.fn, {
          validate: function validate(t) {
            if (!this.length) return void (t && t.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing."));
            var i = e.data(this[0], "validator");
            return i || (this.attr("novalidate", "novalidate"), i = new e.validator(t, this[0]), e.data(this[0], "validator", i), i.settings.onsubmit && (this.validateDelegate(":submit", "click", function (t) {
              i.settings.submitHandler && (i.submitButton = t.target), e(t.target).hasClass("cancel") && (i.cancelSubmit = !0), void 0 !== e(t.target).attr("formnovalidate") && (i.cancelSubmit = !0);
            }), this.submit(function (t) {
              function n() {
                var n;
                return !i.settings.submitHandler || (i.submitButton && (n = e("<input type='hidden'/>").attr("name", i.submitButton.name).val(e(i.submitButton).val()).appendTo(i.currentForm)), i.settings.submitHandler.call(i, i.currentForm, t), i.submitButton && n.remove(), !1);
              }

              return i.settings.debug && t.preventDefault(), i.cancelSubmit ? (i.cancelSubmit = !1, n()) : i.form() ? i.pendingRequest ? (i.formSubmitted = !0, !1) : n() : (i.focusInvalid(), !1);
            })), i);
          },
          valid: function valid() {
            if (e(this[0]).is("form")) return this.validate().form();
            var t = !0,
                i = e(this[0].form).validate();
            return this.each(function () {
              t = t && i.element(this);
            }), t;
          },
          removeAttrs: function removeAttrs(t) {
            var i = {},
                n = this;
            return e.each(t.split(/\s/), function (e, t) {
              i[t] = n.attr(t), n.removeAttr(t);
            }), i;
          },
          rules: function rules(t, i) {
            var n = this[0];

            if (t) {
              var s = e.data(n.form, "validator").settings,
                  r = s.rules,
                  o = e.validator.staticRules(n);

              switch (t) {
                case "add":
                  e.extend(o, e.validator.normalizeRule(i)), delete o.messages, r[n.name] = o, i.messages && (s.messages[n.name] = e.extend(s.messages[n.name], i.messages));
                  break;

                case "remove":
                  if (!i) return delete r[n.name], o;
                  var a = {};
                  return e.each(i.split(/\s/), function (e, t) {
                    a[t] = o[t], delete o[t];
                  }), a;
              }
            }

            var l = e.validator.normalizeRules(e.extend({}, e.validator.classRules(n), e.validator.attributeRules(n), e.validator.dataRules(n), e.validator.staticRules(n)), n);

            if (l.required) {
              var u = l.required;
              delete l.required, l = e.extend({
                required: u
              }, l);
            }

            return l;
          }
        }), e.extend(e.expr[":"], {
          blank: function blank(t) {
            return !e.trim("" + e(t).val());
          },
          filled: function filled(t) {
            return !!e.trim("" + e(t).val());
          },
          unchecked: function unchecked(t) {
            return !e(t).prop("checked");
          }
        }), e.validator = function (t, i) {
          this.settings = e.extend(!0, {}, e.validator.defaults, t), this.currentForm = i, this.init();
        }, e.validator.format = function (t, i) {
          return 1 === arguments.length ? function () {
            var i = e.makeArray(arguments);
            return i.unshift(t), e.validator.format.apply(this, i);
          } : (arguments.length > 2 && i.constructor !== Array && (i = e.makeArray(arguments).slice(1)), i.constructor !== Array && (i = [i]), e.each(i, function (e, i) {
            t = t.replace(RegExp("\\{" + e + "\\}", "g"), function () {
              return i;
            });
          }), t);
        }, e.extend(e.validator, {
          defaults: {
            messages: {},
            groups: {},
            rules: {},
            errorClass: "error",
            validClass: "valid",
            errorElement: "label",
            focusInvalid: !0,
            errorContainer: e([]),
            errorLabelContainer: e([]),
            onsubmit: !0,
            ignore: ":hidden",
            ignoreTitle: !1,
            onfocusin: function onfocusin(e) {
              this.lastActive = e, this.settings.focusCleanup && !this.blockFocusCleanup && (this.settings.unhighlight && this.settings.unhighlight.call(this, e, this.settings.errorClass, this.settings.validClass), this.addWrapper(this.errorsFor(e)).hide());
            },
            onfocusout: function onfocusout(e) {
              this.checkable(e) || !(e.name in this.submitted) && this.optional(e) || this.element(e);
            },
            onkeyup: function onkeyup(e, t) {
              (9 !== t.which || "" !== this.elementValue(e)) && (e.name in this.submitted || e === this.lastElement) && this.element(e);
            },
            onclick: function onclick(e) {
              e.name in this.submitted ? this.element(e) : e.parentNode.name in this.submitted && this.element(e.parentNode);
            },
            highlight: function highlight(t, i, n) {
              "radio" === t.type ? this.findByName(t.name).addClass(i).removeClass(n) : e(t).addClass(i).removeClass(n);
            },
            unhighlight: function unhighlight(t, i, n) {
              "radio" === t.type ? this.findByName(t.name).removeClass(i).addClass(n) : e(t).removeClass(i).addClass(n);
            }
          },
          setDefaults: function setDefaults(t) {
            e.extend(e.validator.defaults, t);
          },
          messages: {
            required: "This field is required.",
            remote: "Please fix this field.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            creditcard: "Please enter a valid credit card number.",
            equalTo: "Please enter the same value again.",
            maxlength: e.validator.format("Please enter no more than {0} characters."),
            minlength: e.validator.format("Please enter at least {0} characters."),
            rangelength: e.validator.format("Please enter a value between {0} and {1} characters long."),
            range: e.validator.format("Please enter a value between {0} and {1}."),
            max: e.validator.format("Please enter a value less than or equal to {0}."),
            min: e.validator.format("Please enter a value greater than or equal to {0}.")
          },
          autoCreateRanges: !1,
          prototype: {
            init: function init() {
              function t(t) {
                var i = e.data(this[0].form, "validator"),
                    n = "on" + t.type.replace(/^validate/, "");
                i.settings[n] && i.settings[n].call(i, this[0], t);
              }

              this.labelContainer = e(this.settings.errorLabelContainer), this.errorContext = this.labelContainer.length && this.labelContainer || e(this.currentForm), this.containers = e(this.settings.errorContainer).add(this.settings.errorLabelContainer), this.submitted = {}, this.valueCache = {}, this.pendingRequest = 0, this.pending = {}, this.invalid = {}, this.reset();
              var i = this.groups = {};
              e.each(this.settings.groups, function (t, n) {
                "string" == typeof n && (n = n.split(/\s/)), e.each(n, function (e, n) {
                  i[n] = t;
                });
              });
              var n = this.settings.rules;
              e.each(n, function (t, i) {
                n[t] = e.validator.normalizeRule(i);
              }), e(this.currentForm).validateDelegate(":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'] ,[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'] ", "focusin focusout keyup", t).validateDelegate("[type='radio'], [type='checkbox'], select, option", "click", t), this.settings.invalidHandler && e(this.currentForm).bind("invalid-form.validate", this.settings.invalidHandler);
            },
            form: function form() {
              return this.checkForm(), e.extend(this.submitted, this.errorMap), this.invalid = e.extend({}, this.errorMap), this.valid() || e(this.currentForm).triggerHandler("invalid-form", [this]), this.showErrors(), this.valid();
            },
            checkForm: function checkForm() {
              this.prepareForm();

              for (var e = 0, t = this.currentElements = this.elements(); t[e]; e++) {
                this.check(t[e]);
              }

              return this.valid();
            },
            element: function element(t) {
              t = this.validationTargetFor(this.clean(t)), this.lastElement = t, this.prepareElement(t), this.currentElements = e(t);
              var i = !1 !== this.check(t);
              return i ? delete this.invalid[t.name] : this.invalid[t.name] = !0, this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)), this.showErrors(), i;
            },
            showErrors: function showErrors(t) {
              if (t) {
                e.extend(this.errorMap, t), this.errorList = [];

                for (var i in t) {
                  this.errorList.push({
                    message: t[i],
                    element: this.findByName(i)[0]
                  });
                }

                this.successList = e.grep(this.successList, function (e) {
                  return !(e.name in t);
                });
              }

              this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors();
            },
            resetForm: function resetForm() {
              e.fn.resetForm && e(this.currentForm).resetForm(), this.submitted = {}, this.lastElement = null, this.prepareForm(), this.hideErrors(), this.elements().removeClass(this.settings.errorClass).removeData("previousValue");
            },
            numberOfInvalids: function numberOfInvalids() {
              return this.objectLength(this.invalid);
            },
            objectLength: function objectLength(e) {
              var t = 0;

              for (var i in e) {
                t++;
              }

              return t;
            },
            hideErrors: function hideErrors() {
              this.addWrapper(this.toHide).hide();
            },
            valid: function valid() {
              return 0 === this.size();
            },
            size: function size() {
              return this.errorList.length;
            },
            focusInvalid: function focusInvalid() {
              if (this.settings.focusInvalid) try {
                e(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus().trigger("focusin");
              } catch (e) {}
            },
            findLastActive: function findLastActive() {
              var t = this.lastActive;
              return t && 1 === e.grep(this.errorList, function (e) {
                return e.element.name === t.name;
              }).length && t;
            },
            elements: function elements() {
              var t = this,
                  i = {};
              return e(this.currentForm).find("input, select, textarea").not(":submit, :reset, :image, [disabled]").not(this.settings.ignore).filter(function () {
                return !this.name && t.settings.debug && window.console && console.error("%o has no name assigned", this), !(this.name in i || !t.objectLength(e(this).rules())) && (i[this.name] = !0, !0);
              });
            },
            clean: function clean(t) {
              return e(t)[0];
            },
            errors: function errors() {
              var t = this.settings.errorClass.replace(" ", ".");
              return e(this.settings.errorElement + "." + t, this.errorContext);
            },
            reset: function reset() {
              this.successList = [], this.errorList = [], this.errorMap = {}, this.toShow = e([]), this.toHide = e([]), this.currentElements = e([]);
            },
            prepareForm: function prepareForm() {
              this.reset(), this.toHide = this.errors().add(this.containers);
            },
            prepareElement: function prepareElement(e) {
              this.reset(), this.toHide = this.errorsFor(e);
            },
            elementValue: function elementValue(t) {
              var i = e(t).attr("type"),
                  n = e(t).val();
              return "radio" === i || "checkbox" === i ? e("input[name='" + e(t).attr("name") + "']:checked").val() : "string" == typeof n ? n.replace(/\r/g, "") : n;
            },
            check: function check(t) {
              t = this.validationTargetFor(this.clean(t));
              var i,
                  n = e(t).rules(),
                  s = !1,
                  r = this.elementValue(t);

              for (var o in n) {
                var a = {
                  method: o,
                  parameters: n[o]
                };

                try {
                  if ("dependency-mismatch" === (i = e.validator.methods[o].call(this, r, t, a.parameters))) {
                    s = !0;
                    continue;
                  }

                  if (s = !1, "pending" === i) return void (this.toHide = this.toHide.not(this.errorsFor(t)));
                  if (!i) return this.formatAndAdd(t, a), !1;
                } catch (e) {
                  throw this.settings.debug && window.console && console.log("Exception occurred when checking element " + t.id + ", check the '" + a.method + "' method.", e), e;
                }
              }

              return s ? void 0 : (this.objectLength(n) && this.successList.push(t), !0);
            },
            customDataMessage: function customDataMessage(t, i) {
              return e(t).data("msg-" + i.toLowerCase()) || t.attributes && e(t).attr("data-msg-" + i.toLowerCase());
            },
            customMessage: function customMessage(e, t) {
              var i = this.settings.messages[e];
              return i && (i.constructor === String ? i : i[t]);
            },
            findDefined: function findDefined() {
              for (var e = 0; arguments.length > e; e++) {
                if (void 0 !== arguments[e]) return arguments[e];
              }
            },
            defaultMessage: function defaultMessage(t, i) {
              return this.findDefined(this.customMessage(t.name, i), this.customDataMessage(t, i), !this.settings.ignoreTitle && t.title || void 0, e.validator.messages[i], "<strong>Warning: No message defined for " + t.name + "</strong>");
            },
            formatAndAdd: function formatAndAdd(t, i) {
              var n = this.defaultMessage(t, i.method),
                  s = /\$?\{(\d+)\}/g;
              "function" == typeof n ? n = n.call(this, i.parameters, t) : s.test(n) && (n = e.validator.format(n.replace(s, "{$1}"), i.parameters)), this.errorList.push({
                message: n,
                element: t
              }), this.errorMap[t.name] = n, this.submitted[t.name] = n;
            },
            addWrapper: function addWrapper(e) {
              return this.settings.wrapper && (e = e.add(e.parent(this.settings.wrapper))), e;
            },
            defaultShowErrors: function defaultShowErrors() {
              var e, t;

              for (e = 0; this.errorList[e]; e++) {
                var i = this.errorList[e];
                this.settings.highlight && this.settings.highlight.call(this, i.element, this.settings.errorClass, this.settings.validClass), this.showLabel(i.element, i.message);
              }

              if (this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success) for (e = 0; this.successList[e]; e++) {
                this.showLabel(this.successList[e]);
              }
              if (this.settings.unhighlight) for (e = 0, t = this.validElements(); t[e]; e++) {
                this.settings.unhighlight.call(this, t[e], this.settings.errorClass, this.settings.validClass);
              }
              this.toHide = this.toHide.not(this.toShow), this.hideErrors(), this.addWrapper(this.toShow).show();
            },
            validElements: function validElements() {
              return this.currentElements.not(this.invalidElements());
            },
            invalidElements: function invalidElements() {
              return e(this.errorList).map(function () {
                return this.element;
              });
            },
            showLabel: function showLabel(t, i) {
              var n = this.errorsFor(t);
              n.length ? (n.removeClass(this.settings.validClass).addClass(this.settings.errorClass), n.html(i)) : (n = e("<" + this.settings.errorElement + ">").attr("for", this.idOrName(t)).addClass(this.settings.errorClass).html(i || ""), this.settings.wrapper && (n = n.hide().show().wrap("<" + this.settings.wrapper + "/>").parent()), this.labelContainer.append(n).length || (this.settings.errorPlacement ? this.settings.errorPlacement(n, e(t)) : n.insertAfter(t))), !i && this.settings.success && (n.text(""), "string" == typeof this.settings.success ? n.addClass(this.settings.success) : this.settings.success(n, t)), this.toShow = this.toShow.add(n);
            },
            errorsFor: function errorsFor(t) {
              var i = this.idOrName(t);
              return this.errors().filter(function () {
                return e(this).attr("for") === i;
              });
            },
            idOrName: function idOrName(e) {
              return this.groups[e.name] || (this.checkable(e) ? e.name : e.id || e.name);
            },
            validationTargetFor: function validationTargetFor(e) {
              return this.checkable(e) && (e = this.findByName(e.name).not(this.settings.ignore)[0]), e;
            },
            checkable: function checkable(e) {
              return /radio|checkbox/i.test(e.type);
            },
            findByName: function findByName(t) {
              return e(this.currentForm).find("[name='" + t + "']");
            },
            getLength: function getLength(t, i) {
              switch (i.nodeName.toLowerCase()) {
                case "select":
                  return e("option:selected", i).length;

                case "input":
                  if (this.checkable(i)) return this.findByName(i.name).filter(":checked").length;
              }

              return t.length;
            },
            depend: function depend(e, t) {
              return !this.dependTypes[(0, _typeof2["default"])(e)] || this.dependTypes[(0, _typeof2["default"])(e)](e, t);
            },
            dependTypes: {
              "boolean": function boolean(e) {
                return e;
              },
              string: function string(t, i) {
                return !!e(t, i.form).length;
              },
              "function": function _function(e, t) {
                return e(t);
              }
            },
            optional: function optional(t) {
              var i = this.elementValue(t);
              return !e.validator.methods.required.call(this, i, t) && "dependency-mismatch";
            },
            startRequest: function startRequest(e) {
              this.pending[e.name] || (this.pendingRequest++, this.pending[e.name] = !0);
            },
            stopRequest: function stopRequest(t, i) {
              this.pendingRequest--, 0 > this.pendingRequest && (this.pendingRequest = 0), delete this.pending[t.name], i && 0 === this.pendingRequest && this.formSubmitted && this.form() ? (e(this.currentForm).submit(), this.formSubmitted = !1) : !i && 0 === this.pendingRequest && this.formSubmitted && (e(this.currentForm).triggerHandler("invalid-form", [this]), this.formSubmitted = !1);
            },
            previousValue: function previousValue(t) {
              return e.data(t, "previousValue") || e.data(t, "previousValue", {
                old: null,
                valid: !0,
                message: this.defaultMessage(t, "remote")
              });
            }
          },
          classRuleSettings: {
            required: {
              required: !0
            },
            email: {
              email: !0
            },
            url: {
              url: !0
            },
            date: {
              date: !0
            },
            dateISO: {
              dateISO: !0
            },
            number: {
              number: !0
            },
            digits: {
              digits: !0
            },
            creditcard: {
              creditcard: !0
            }
          },
          addClassRules: function addClassRules(t, i) {
            t.constructor === String ? this.classRuleSettings[t] = i : e.extend(this.classRuleSettings, t);
          },
          classRules: function classRules(t) {
            var i = {},
                n = e(t).attr("class");
            return n && e.each(n.split(" "), function () {
              this in e.validator.classRuleSettings && e.extend(i, e.validator.classRuleSettings[this]);
            }), i;
          },
          attributeRules: function attributeRules(t) {
            var i = {},
                n = e(t),
                s = n[0].getAttribute("type");

            for (var r in e.validator.methods) {
              var o;
              "required" === r ? (o = n.get(0).getAttribute(r), "" === o && (o = !0), o = !!o) : o = n.attr(r), /min|max/.test(r) && (null === s || /number|range|text/.test(s)) && (o = Number(o)), o ? i[r] = o : s === r && "range" !== s && (i[r] = !0);
            }

            return i.maxlength && /-1|2147483647|524288/.test(i.maxlength) && delete i.maxlength, i;
          },
          dataRules: function dataRules(t) {
            var i,
                n,
                s = {},
                r = e(t);

            for (i in e.validator.methods) {
              void 0 !== (n = r.data("rule-" + i.toLowerCase())) && (s[i] = n);
            }

            return s;
          },
          staticRules: function staticRules(t) {
            var i = {},
                n = e.data(t.form, "validator");
            return n.settings.rules && (i = e.validator.normalizeRule(n.settings.rules[t.name]) || {}), i;
          },
          normalizeRules: function normalizeRules(t, i) {
            return e.each(t, function (n, s) {
              if (!1 === s) return void delete t[n];

              if (s.param || s.depends) {
                var r = !0;

                switch ((0, _typeof2["default"])(s.depends)) {
                  case "string":
                    r = !!e(s.depends, i.form).length;
                    break;

                  case "function":
                    r = s.depends.call(i, i);
                }

                r ? t[n] = void 0 === s.param || s.param : delete t[n];
              }
            }), e.each(t, function (n, s) {
              t[n] = e.isFunction(s) ? s(i) : s;
            }), e.each(["minlength", "maxlength"], function () {
              t[this] && (t[this] = Number(t[this]));
            }), e.each(["rangelength", "range"], function () {
              var i;
              t[this] && (e.isArray(t[this]) ? t[this] = [Number(t[this][0]), Number(t[this][1])] : "string" == typeof t[this] && (i = t[this].split(/[\s,]+/), t[this] = [Number(i[0]), Number(i[1])]));
            }), e.validator.autoCreateRanges && (t.min && t.max && (t.range = [t.min, t.max], delete t.min, delete t.max), t.minlength && t.maxlength && (t.rangelength = [t.minlength, t.maxlength], delete t.minlength, delete t.maxlength)), t;
          },
          normalizeRule: function normalizeRule(t) {
            if ("string" == typeof t) {
              var i = {};
              e.each(t.split(/\s/), function () {
                i[this] = !0;
              }), t = i;
            }

            return t;
          },
          addMethod: function addMethod(t, i, n) {
            e.validator.methods[t] = i, e.validator.messages[t] = void 0 !== n ? n : e.validator.messages[t], 3 > i.length && e.validator.addClassRules(t, e.validator.normalizeRule(t));
          },
          methods: {
            required: function required(t, i, n) {
              if (!this.depend(n, i)) return "dependency-mismatch";

              if ("select" === i.nodeName.toLowerCase()) {
                var s = e(i).val();
                return s && s.length > 0;
              }

              return this.checkable(i) ? this.getLength(t, i) > 0 : e.trim(t).length > 0;
            },
            email: function email(e, t) {
              return this.optional(t) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(e);
            },
            url: function url(e, t) {
              return this.optional(t) || /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(e);
            },
            date: function date(e, t) {
              return this.optional(t) || !/Invalid|NaN/.test("" + new Date(e));
            },
            dateISO: function dateISO(e, t) {
              return this.optional(t) || /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/.test(e);
            },
            number: function number(e, t) {
              return this.optional(t) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(e);
            },
            digits: function digits(e, t) {
              return this.optional(t) || /^\d+$/.test(e);
            },
            creditcard: function creditcard(e, t) {
              if (this.optional(t)) return "dependency-mismatch";
              if (/[^0-9 \-]+/.test(e)) return !1;
              var i = 0,
                  n = 0,
                  s = !1;
              e = e.replace(/\D/g, "");

              for (var r = e.length - 1; r >= 0; r--) {
                var o = e.charAt(r);
                n = parseInt(o, 10), s && (n *= 2) > 9 && (n -= 9), i += n, s = !s;
              }

              return 0 == i % 10;
            },
            minlength: function minlength(t, i, n) {
              var s = e.isArray(t) ? t.length : this.getLength(e.trim(t), i);
              return this.optional(i) || s >= n;
            },
            maxlength: function maxlength(t, i, n) {
              var s = e.isArray(t) ? t.length : this.getLength(e.trim(t), i);
              return this.optional(i) || n >= s;
            },
            rangelength: function rangelength(t, i, n) {
              var s = e.isArray(t) ? t.length : this.getLength(e.trim(t), i);
              return this.optional(i) || s >= n[0] && n[1] >= s;
            },
            min: function min(e, t, i) {
              return this.optional(t) || e >= i;
            },
            max: function max(e, t, i) {
              return this.optional(t) || i >= e;
            },
            range: function range(e, t, i) {
              return this.optional(t) || e >= i[0] && i[1] >= e;
            },
            equalTo: function equalTo(t, i, n) {
              var s = e(n);
              return this.settings.onfocusout && s.unbind(".validate-equalTo").bind("blur.validate-equalTo", function () {
                e(i).valid();
              }), t === s.val();
            },
            remote: function remote(t, i, n) {
              if (this.optional(i)) return "dependency-mismatch";
              var s = this.previousValue(i);
              if (this.settings.messages[i.name] || (this.settings.messages[i.name] = {}), s.originalMessage = this.settings.messages[i.name].remote, this.settings.messages[i.name].remote = s.message, n = "string" == typeof n && {
                url: n
              } || n, s.old === t) return s.valid;
              s.old = t;
              var r = this;
              this.startRequest(i);
              var o = {};
              return o[i.name] = t, e.ajax(e.extend(!0, {
                url: n,
                mode: "abort",
                port: "validate" + i.name,
                dataType: "json",
                data: o,
                success: function success(n) {
                  r.settings.messages[i.name].remote = s.originalMessage;
                  var o = !0 === n || "true" === n;

                  if (o) {
                    var a = r.formSubmitted;
                    r.prepareElement(i), r.formSubmitted = a, r.successList.push(i), delete r.invalid[i.name], r.showErrors();
                  } else {
                    var l = {},
                        u = n || r.defaultMessage(i, "remote");
                    l[i.name] = s.message = e.isFunction(u) ? u(t) : u, r.invalid[i.name] = !0, r.showErrors(l);
                  }

                  s.valid = o, r.stopRequest(i, o);
                }
              }, n)), "pending";
            }
          }
        }), e.format = e.validator.format;
      }(jQuery), function (e) {
        var t = {};
        if (e.ajaxPrefilter) e.ajaxPrefilter(function (e, i, n) {
          var s = e.port;
          "abort" === e.mode && (t[s] && t[s].abort(), t[s] = n);
        });else {
          var i = e.ajax;

          e.ajax = function (n) {
            var s = ("mode" in n ? n : e.ajaxSettings).mode,
                r = ("port" in n ? n : e.ajaxSettings).port;
            return "abort" === s ? (t[r] && t[r].abort(), t[r] = i.apply(this, arguments), t[r]) : i.apply(this, arguments);
          };
        }
      }(jQuery), function (e) {
        e.extend(e.fn, {
          validateDelegate: function validateDelegate(t, i, n) {
            return this.bind(i, function (i) {
              var s = e(i.target);
              return s.is(t) ? n.apply(s, arguments) : void 0;
            });
          }
        });
      }(jQuery), jQuery.fn.validate;
    }.apply(e, arguments);
  });
}(void 0), define("page/member", ["jquery", "plugin/jquery.validate.min"], function (e) {
  jQuery.validator.addMethod("format", function (t, i) {
    var n = e(i).attr("format");
    return n = n.replace(/\//g, ""), !e.trim(t) || new RegExp(n).test(t);
  });

  var t = function t(_t4) {
    var i = e(_t4),
        n = i.find("input"),
        s = {};
    n.each(function (t, i) {
      var n = e(i),
          r = n.attr("name"),
          o = n.attr("data-required-msg"),
          a = n.attr("data-equal-msg"),
          l = n.attr("data-email-msg");
      s[r] = {
        required: o,
        equalTo: a,
        email: l
      };
    }), i.validate({
      messages: s,
      submitHandler: function submitHandler(e) {
        e.submit();
      },
      errorPlacement: function errorPlacement(e, t) {
        t.parents("td").find(".error-tip").html(e).css("display", "block");
      }
    });
  };

  t("#first_login"), t("#member_login"), t("#member_register");
}), define("page/products-home", ["jquery"], function (e) {
  var t = e(".search-title"),
      i = e(".product-search-inner");
  t.on("click", function () {
    i.toggleClass("product-search-open");
  });
}), define("page/shops-contact", ["jquery", "plugin/jquery.validate.min"], function (e) {
  var t = e("input,select"),
      i = {};
  t.each(function (t, n) {
    var s = e(n),
        r = s.attr("name"),
        o = s.attr("data-required-msg"),
        a = s.attr("data-email-msg");
    i[r] = {
      required: o,
      email: a
    };
  }), e(".shops-contact-form").validate({
    messages: i,
    submitHandler: function submitHandler(t) {
      var i = e(t);
      e.post(i.attr("ajax-url"), i.serialize() + "&action=contact", function (e) {
        alert(e.message);
      }, "json"), t.reset();
    },
    errorPlacement: function errorPlacement(e, t) {
      t.parents("td").find(".error-tip").html(e).css("display", "block");
    }
  });
}), define("page/shops-map", ["jquery"], function (e) {
  var t = e(".shops-item"),
      i = e(".map-more"),
      n = e(".shops-left"),
      s = e(".shops-right"),
      r = e(".shops-map-back"),
      o = !1,
      a = !1,
      l = e(".shops-check"),
      u = l.find("input");
  u.attr("checked") ? l.addClass("checked") : l.removeClass("checked"), t.length < 5 && i.css({
    backgroundImage: "none",
    cursor: "default"
  }), u.on("click", function () {
    var t = e(this).parent();
    e(this).attr("checked") ? t.removeClass("checked") : t.addClass("checked");
  }), e("html").hasClass("ie8") && t.each(function (t, i) {
    t % 2 != 0 && e(i).css("backgroundColor", "#f3eddc");
  }), r.on("click", function (i) {
    i.preventDefault(), t.slideDown(), e(".shops-right").hide(), o = !1, e(this).css("display", "none");
  }), t.each(function (i, n) {
    var l = e(n);
    i > 3 && l.addClass("hidden"), l.on("click", function () {
      l.hasClass("current") || (t.not(this).removeClass("current"), l.addClass("current")), a && (t.slideUp(), s.show(), s.trigger("slider.down", [l]), r.css("display", "block"), o = !0);
    });
  });
  var c = e(".shops-item.hidden");
  i.on("click", function (t) {
    t.preventDefault();
    var i = e(this);
    i.hasClass("up") ? (c.slideUp(function () {
      var t = n.height(),
          i = e(window).height();
      t > i ? s.css("height", i) : s.css("height", t);
    }), i.removeClass("up")) : (c.slideDown(), i.addClass("up"));
  });

  var d = function d() {
    if (e(window).width() < 768) e(window).unbind("scroll"), a = !0, s.css({
      position: "",
      top: "",
      right: ""
    }), s.css({
      marginTop: "1.56vw",
      height: "100vw"
    }), o ? s.css("display", "block") : s.css({
      display: "none"
    });else {
      var i = n.height(),
          l = e(window).height();
      i > l ? s.css("height", l) : s.css("height", i), o = !1, a = !1, s.css({
        display: "block",
        marginTop: ""
      }), t.css("display", ""), r.css({
        display: "none"
      }), e(window).bind("scroll", function () {
        var t = e(window).scrollTop() - n.offset().top,
            i = n.height(),
            r = i - s.height();
        r > 0 ? (t = t > r ? r : t, t = t < 0 ? 0 : t, s.css({
          position: "absolute",
          top: t,
          right: 0
        })) : s.css({
          top: 0
        });
      });
    }
  };

  d();
  var p = e("#shops_select"),
      h = p.css("display");
  e(window).on("resize", function () {
    var t = p.css("display");

    if ("none" == h) {
      var i = n.height(),
          r = e(window).height();
      i > r ? s.css("height", r) : s.css("height", i);
    }

    t != h && (h = t, d());
  }), require(["common/map/filter", "common/map/init"]);
}), function (e, t) {
  function i(e, t) {
    var i = e.createElement("p"),
        n = e.getElementsByTagName("head")[0] || e.documentElement;
    return i.innerHTML = "x<style>" + t + "</style>", n.insertBefore(i.lastChild, n.firstChild);
  }

  function n() {
    var e = v.elements;
    return "string" == typeof e ? e.split(" ") : e;
  }

  function s(e, t) {
    var i = v.elements;
    "string" != typeof i && (i = i.join(" ")), "string" != typeof e && (e = e.join(" ")), v.elements = i + " " + e, u(t);
  }

  function r(e) {
    var t = b[e[m]];
    return t || (t = {}, g++, e[m] = g, b[g] = t), t;
  }

  function o(e, i, n) {
    if (i || (i = t), d) return i.createElement(e);
    n || (n = r(i));
    var s;
    return s = n.cache[e] ? n.cache[e].cloneNode() : f.test(e) ? (n.cache[e] = n.createElem(e)).cloneNode() : n.createElem(e), !s.canHaveChildren || h.test(e) || s.tagUrn ? s : n.frag.appendChild(s);
  }

  function a(e, i) {
    if (e || (e = t), d) return e.createDocumentFragment();
    i = i || r(e);

    for (var s = i.frag.cloneNode(), o = 0, a = n(), l = a.length; l > o; o++) {
      s.createElement(a[o]);
    }

    return s;
  }

  function l(e, t) {
    t.cache || (t.cache = {}, t.createElem = e.createElement, t.createFrag = e.createDocumentFragment, t.frag = t.createFrag()), e.createElement = function (i) {
      return v.shivMethods ? o(i, e, t) : t.createElem(i);
    }, e.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + n().join().replace(/[\w\-:]+/g, function (e) {
      return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")';
    }) + ");return n}")(v, t.frag);
  }

  function u(e) {
    e || (e = t);
    var n = r(e);
    return !v.shivCSS || c || n.hasCSS || (n.hasCSS = !!i(e, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), d || l(e, n), e;
  }

  var c,
      d,
      p = e.html5 || {},
      h = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
      f = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
      m = "_html5shiv",
      g = 0,
      b = {};
  !function () {
    try {
      var e = t.createElement("a");
      e.innerHTML = "<xyz></xyz>", c = "hidden" in e, d = 1 == e.childNodes.length || function () {
        t.createElement("a");
        var e = t.createDocumentFragment();
        return void 0 === e.cloneNode || void 0 === e.createDocumentFragment || void 0 === e.createElement;
      }();
    } catch (e) {
      c = !0, d = !0;
    }
  }();
  var v = {
    elements: p.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",
    version: "3.7.3-pre",
    shivCSS: !1 !== p.shivCSS,
    supportsUnknownElements: d,
    shivMethods: !1 !== p.shivMethods,
    type: "default",
    shivDocument: u,
    createElement: o,
    createDocumentFragment: a,
    addElements: s
  };
  e.html5 = v, u(t), "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof2["default"])(module)) && module.exports && (module.exports = v);
}("undefined" != typeof window ? window : void 0, document), define("patch/html5shiv.min", function () {}), function () {
  "use strict";

  var e = Array.prototype.slice;

  try {
    e.call(document.documentElement);
  } catch (t) {
    Array.prototype.slice = function (t, i) {
      if (i = void 0 !== i ? i : this.length, "[object Array]" === Object.prototype.toString.call(this)) return e.call(this, t, i);
      var n,
          s,
          r = [],
          o = this.length,
          a = t || 0;
      a = a >= 0 ? a : Math.max(0, o + a);
      var l = "number" == typeof i ? Math.min(i, o) : o;
      if (i < 0 && (l = o + i), (s = l - a) > 0) if (r = new Array(s), this.charAt) for (n = 0; n < s; n++) {
        r[n] = this.charAt(a + n);
      } else for (n = 0; n < s; n++) {
        r[n] = this[a + n];
      }
      return r;
    };
  }
}(), Array.prototype.indexOf || (Array.prototype.indexOf = function (e, t) {
  var i;
  if (null == this) throw new TypeError('"this" is null or not defined');
  var n = Object(this),
      s = n.length >>> 0;
  if (0 === s) return -1;
  var r = +t || 0;
  if (Math.abs(r) === 1 / 0 && (r = 0), r >= s) return -1;

  for (i = Math.max(r >= 0 ? r : s - Math.abs(r), 0); i < s;) {
    if (i in n && n[i] === e) return i;
    i++;
  }

  return -1;
}), define("patch/ie", function () {}), function (e) {
  "use strict";

  e.matchMedia = e.matchMedia || function (e) {
    var t,
        i = e.documentElement,
        n = i.firstElementChild || i.firstChild,
        s = e.createElement("body"),
        r = e.createElement("div");
    return r.id = "mq-test-1", r.style.cssText = "position:absolute;top:-100em", s.style.background = "none", s.appendChild(r), function (e) {
      return r.innerHTML = '&shy;<style media="' + e + '"> #mq-test-1 { width: 42px; }</style>', i.insertBefore(s, n), t = 42 === r.offsetWidth, i.removeChild(s), {
        matches: t,
        media: e
      };
    };
  }(e.document);
}(void 0), function (e) {
  "use strict";

  function t() {
    y(!0);
  }

  var i = {};
  e.respond = i, i.update = function () {};

  var n = [],
      s = function () {
    var t = !1;

    try {
      t = new e.XMLHttpRequest();
    } catch (i) {
      t = new e.ActiveXObject("Microsoft.XMLHTTP");
    }

    return function () {
      return t;
    };
  }(),
      r = function r(e, t) {
    var i = s();
    i && (i.open("GET", e, !0), i.onreadystatechange = function () {
      4 !== i.readyState || 200 !== i.status && 304 !== i.status || t(i.responseText);
    }, 4 !== i.readyState && i.send(null));
  },
      o = function o(e) {
    return e.replace(i.regex.minmaxwh, "").match(i.regex.other);
  };

  if (i.ajax = r, i.queue = n, i.unsupportedmq = o, i.regex = {
    media: /@media[^\{]+\{([^\{\}]*\{[^\}\{]*\})+/gi,
    keyframes: /@(?:\-(?:o|moz|webkit)\-)?keyframes[^\{]+\{(?:[^\{\}]*\{[^\}\{]*\})+[^\}]*\}/gi,
    comments: /\/\*[^*]*\*+([^/][^*]*\*+)*\//gi,
    urls: /(url\()['"]?([^\/\)'"][^:\)'"]+)['"]?(\))/g,
    findStyles: /@media *([^\{]+)\{([\S\s]+?)$/,
    only: /(only\s+)?([a-zA-Z]+)\s?/,
    minw: /\(\s*min\-width\s*:\s*(\s*[0-9\.]+)(px|em)\s*\)/,
    maxw: /\(\s*max\-width\s*:\s*(\s*[0-9\.]+)(px|em)\s*\)/,
    minmaxwh: /\(\s*m(in|ax)\-(height|width)\s*:\s*(\s*[0-9\.]+)(px|em)\s*\)/gi,
    other: /\([^\)]*\)/g
  }, i.mediaQueriesSupported = e.matchMedia && null !== e.matchMedia("only all") && e.matchMedia("only all").matches, !i.mediaQueriesSupported) {
    var a,
        l,
        u,
        c = e.document,
        d = c.documentElement,
        p = [],
        h = [],
        f = [],
        m = {},
        g = c.getElementsByTagName("head")[0] || d,
        b = c.getElementsByTagName("base")[0],
        v = g.getElementsByTagName("link"),
        k = function k() {
      var e,
          t = c.createElement("div"),
          i = c.body,
          n = d.style.fontSize,
          s = i && i.style.fontSize,
          r = !1;
      return t.style.cssText = "position:absolute;font-size:1em;width:1em", i || (i = r = c.createElement("body"), i.style.background = "none"), d.style.fontSize = "100%", i.style.fontSize = "100%", i.appendChild(t), r && d.insertBefore(i, d.firstChild), e = t.offsetWidth, r ? d.removeChild(i) : i.removeChild(t), d.style.fontSize = n, s && (i.style.fontSize = s), e = u = parseFloat(e);
    },
        y = function y(t) {
      var i = "clientWidth",
          n = d[i],
          s = "CSS1Compat" === c.compatMode && n || c.body[i] || n,
          r = {},
          o = v[v.length - 1],
          m = new Date().getTime();
      if (t && a && 30 > m - a) return e.clearTimeout(l), void (l = e.setTimeout(y, 30));
      a = m;

      for (var b in p) {
        if (p.hasOwnProperty(b)) {
          var w = p[b],
              S = w.minw,
              T = w.maxw,
              x = null === S,
              E = null === T;
          S && (S = parseFloat(S) * (S.indexOf("em") > -1 ? u || k() : 1)), T && (T = parseFloat(T) * (T.indexOf("em") > -1 ? u || k() : 1)), w.hasquery && (x && E || !(x || s >= S) || !(E || T >= s)) || (r[w.media] || (r[w.media] = []), r[w.media].push(h[w.rules]));
        }
      }

      for (var C in f) {
        f.hasOwnProperty(C) && f[C] && f[C].parentNode === g && g.removeChild(f[C]);
      }

      f.length = 0;

      for (var I in r) {
        if (r.hasOwnProperty(I)) {
          var R = c.createElement("style"),
              D = r[I].join("\n");
          R.type = "text/css", R.media = I, g.insertBefore(R, o.nextSibling), R.styleSheet ? R.styleSheet.cssText = D : R.appendChild(c.createTextNode(D)), f.push(R);
        }
      }
    },
        w = function w(e, t, n) {
      var s = e.replace(i.regex.comments, "").replace(i.regex.keyframes, "").match(i.regex.media),
          r = s && s.length || 0;
      t = t.substring(0, t.lastIndexOf("/"));

      var a = function a(e) {
        return e.replace(i.regex.urls, "$1" + t + "$2$3");
      },
          l = !r && n;

      t.length && (t += "/"), l && (r = 1);

      for (var u = 0; r > u; u++) {
        var c, d, f, m;
        l ? (c = n, h.push(a(e))) : (c = s[u].match(i.regex.findStyles) && RegExp.$1, h.push(RegExp.$2 && a(RegExp.$2))), f = c.split(","), m = f.length;

        for (var g = 0; m > g; g++) {
          d = f[g], o(d) || p.push({
            media: d.split("(")[0].match(i.regex.only) && RegExp.$2 || "all",
            rules: h.length - 1,
            hasquery: d.indexOf("(") > -1,
            minw: d.match(i.regex.minw) && parseFloat(RegExp.$1) + (RegExp.$2 || ""),
            maxw: d.match(i.regex.maxw) && parseFloat(RegExp.$1) + (RegExp.$2 || "")
          });
        }
      }

      y();
    },
        S = function S() {
      if (n.length) {
        var t = n.shift();
        r(t.href, function (i) {
          w(i, t.href, t.media), m[t.href] = !0, e.setTimeout(function () {
            S();
          }, 0);
        });
      }
    },
        T = function T() {
      for (var t = 0; t < v.length; t++) {
        var i = v[t],
            s = i.href,
            r = i.media,
            o = i.rel && "stylesheet" === i.rel.toLowerCase();
        s && o && !m[s] && (i.styleSheet && i.styleSheet.rawCssText ? (w(i.styleSheet.rawCssText, s, r), m[s] = !0) : (!/^([a-zA-Z:]*\/\/)/.test(s) && !b || s.replace(RegExp.$1, "").split("/")[0] === e.location.host) && ("//" === s.substring(0, 2) && (s = e.location.protocol + s), n.push({
          href: s,
          media: r
        })));
      }

      S();
    };

    T(), i.update = T, i.getEmValue = k, e.addEventListener ? e.addEventListener("resize", t, !1) : e.attachEvent && e.attachEvent("onresize", t);
  }
}(void 0), define("patch/respond.min", function () {}), function (e, t) {
  "function" == typeof define && define.amd ? define("cssua", ["cssua"], t) : e.amdWeb = t(e.b);
}(void 0, function (e) {
  return function (e, t, i) {
    var n = /\s*([\-\w ]+)[\s\/\:]([\d_]+\b(?:[\-\._\/]\w+)*)/,
        s = /([\w\-\.]+[\s\/][v]?[\d_]+\b(?:[\-\._\/]\w+)*)/g,
        r = /\b(?:(blackberry\w*|bb10)|(rim tablet os))(?:\/(\d+\.\d+(?:\.\w+)*))?/,
        o = /\bsilk-accelerated=true\b/,
        a = /\bfluidapp\b/,
        l = /(\bwindows\b|\bmacintosh\b|\blinux\b|\bunix\b)/,
        u = /(\bandroid\b|\bipad\b|\bipod\b|\bwindows phone\b|\bwpdesktop\b|\bxblwp7\b|\bzunewp7\b|\bwindows ce\b|\bblackberry\w*|\bbb10\b|\brim tablet os\b|\bmeego|\bwebos\b|\bpalm|\bsymbian|\bj2me\b|\bdocomo\b|\bpda\b|\bchtml\b|\bmidp\b|\bcldc\b|\w*?mobile\w*?|\w*?phone\w*?)/,
        c = /(\bxbox\b|\bplaystation\b|\bnintendo\s+\w+)/,
        d = {
      parse: function parse(e, t) {
        var i = {};
        if (t && (i.standalone = t), !(e = ("" + e).toLowerCase())) return i;

        for (var d, p, h = e.split(/[()]/), f = 0, m = h.length; f < m; f++) {
          if (f % 2) {
            var g = h[f].split(";");

            for (d = 0, p = g.length; d < p; d++) {
              if (n.exec(g[d])) {
                var b = RegExp.$1.split(" ").join("_"),
                    v = RegExp.$2;
                (!i[b] || parseFloat(i[b]) < parseFloat(v)) && (i[b] = v);
              }
            }
          } else if (g = h[f].match(s)) for (d = 0, p = g.length; d < p; d++) {
            b = g[d].split(/[\/\s]+/), b.length && "mozilla" !== b[0] && (i[b[0].split(" ").join("_")] = b.slice(1).join("-"));
          }
        }

        return u.exec(e) ? (i.mobile = RegExp.$1, r.exec(e) && (delete i[i.mobile], i.blackberry = i.version || RegExp.$3 || RegExp.$2 || RegExp.$1, RegExp.$1 ? i.mobile = "blackberry" : "0.0.1" === i.version && (i.blackberry = "7.1.0.0"))) : l.exec(e) ? i.desktop = RegExp.$1 : c.exec(e) && (i.game = RegExp.$1, d = i.game.split(" ").join("_"), i.version && !i[d] && (i[d] = i.version)), i.intel_mac_os_x ? (i.mac_os_x = i.intel_mac_os_x.split("_").join("."), delete i.intel_mac_os_x) : i.cpu_iphone_os ? (i.ios = i.cpu_iphone_os.split("_").join("."), delete i.cpu_iphone_os) : i.cpu_os ? (i.ios = i.cpu_os.split("_").join("."), delete i.cpu_os) : "iphone" !== i.mobile || i.ios || (i.ios = "1"), i.opera && i.version ? (i.opera = i.version, delete i.blackberry) : o.exec(e) ? i.silk_accelerated = !0 : a.exec(e) && (i.fluidapp = i.version), i.applewebkit ? (i.webkit = i.applewebkit, delete i.applewebkit, i.opr && (i.opera = i.opr, delete i.opr, delete i.chrome), i.safari && (i.chrome || i.crios || i.opera || i.silk || i.fluidapp || i.phantomjs || i.mobile && !i.ios ? delete i.safari : i.safari = i.version && !i.rim_tablet_os ? i.version : {
          419: "2.0.4",
          417: "2.0.3",
          416: "2.0.2",
          412: "2.0",
          312: "1.3",
          125: "1.2",
          85: "1.0"
        }[parseInt(i.safari, 10)] || i.safari)) : i.msie || i.trident ? (i.opera || (i.ie = i.msie || i.rv), delete i.msie, i.windows_phone_os ? (i.windows_phone = i.windows_phone_os, delete i.windows_phone_os) : "wpdesktop" !== i.mobile && "xblwp7" !== i.mobile && "zunewp7" !== i.mobile || (i.mobile = "windows desktop", i.windows_phone = 9 > +i.ie ? "7.0" : 10 > +i.ie ? "7.5" : "8.0", delete i.windows_nt)) : (i.gecko || i.firefox) && (i.gecko = i.rv), i.rv && delete i.rv, i.version && delete i.version, i;
      },
      format: function format(e) {
        var t,
            i = "";

        for (t in e) {
          if (t && e.hasOwnProperty(t)) {
            var n = t,
                s = e[t],
                n = n.split(".").join("-"),
                r = " ua-" + n;

            if ("string" == typeof s) {
              for (var s = s.split(" ").join("_").split(".").join("-"), o = s.indexOf("-"); 0 < o;) {
                r += " ua-" + n + "-" + s.substring(0, o), o = s.indexOf("-", o + 1);
              }

              r += " ua-" + n + "-" + s;
            }

            i += r;
          }
        }

        return i;
      },
      encode: function encode(e) {
        var t,
            i = "";

        for (t in e) {
          t && e.hasOwnProperty(t) && (i && (i += "&"), i += encodeURIComponent(t) + "=" + encodeURIComponent(e[t]));
        }

        return i;
      }
    };
    return d.userAgent = d.ua = d.parse(t, i), t = d.format(d.ua) + " js", e.className = e.className ? e.className.replace(/\bno-js\b/g, "") + t : t.substr(1), d;
  }(document.documentElement, navigator.userAgent, navigator.standalone);
}), window.Modernizr = function (e, t, i) {
  function n(e) {
    g.cssText = e;
  }

  function s(e, t) {
    return n(b.join(e + ";") + (t || ""));
  }

  function r(e, t) {
    return (0, _typeof2["default"])(e) === t;
  }

  function o(e, t) {
    return !!~("" + e).indexOf(t);
  }

  function a(e, t) {
    for (var n in e) {
      var s = e[n];
      if (!o(s, "-") && g[s] !== i) return "pfx" != t || s;
    }

    return !1;
  }

  function l(e, t, n) {
    for (var s in e) {
      var o = t[e[s]];
      if (o !== i) return !1 === n ? e[s] : r(o, "function") ? o.bind(n || t) : o;
    }

    return !1;
  }

  function u(e, t, i) {
    var n = e.charAt(0).toUpperCase() + e.slice(1),
        s = (e + " " + k.join(n + " ") + n).split(" ");
    return r(t, "string") || r(t, "undefined") ? a(s, t) : (s = (e + " " + y.join(n + " ") + n).split(" "), l(s, t, i));
  }

  var c,
      d,
      p = {},
      h = t.documentElement,
      f = "modernizr",
      m = t.createElement(f),
      g = m.style,
      b = " -webkit- -moz- -o- -ms- ".split(" "),
      v = "Webkit Moz O ms",
      k = v.split(" "),
      y = v.toLowerCase().split(" "),
      w = {},
      S = [],
      T = S.slice,
      x = function x(e, i, n, s) {
    var r,
        o,
        a,
        l,
        u = t.createElement("div"),
        c = t.body,
        d = c || t.createElement("body");
    if (parseInt(n, 10)) for (; n--;) {
      a = t.createElement("div"), a.id = s ? s[n] : f + (n + 1), u.appendChild(a);
    }
    return r = ["&#173;", '<style id="s', f, '">', e, "</style>"].join(""), u.id = f, (c ? u : d).innerHTML += r, d.appendChild(u), c || (d.style.background = "", d.style.overflow = "hidden", l = h.style.overflow, h.style.overflow = "hidden", h.appendChild(d)), o = i(u, e), c ? u.parentNode.removeChild(u) : (d.parentNode.removeChild(d), h.style.overflow = l), !!o;
  },
      E = {}.hasOwnProperty;

  d = r(E, "undefined") || r(E.call, "undefined") ? function (e, t) {
    return t in e && r(e.constructor.prototype[t], "undefined");
  } : function (e, t) {
    return E.call(e, t);
  }, Function.prototype.bind || (Function.prototype.bind = function (e) {
    var t = this;
    if ("function" != typeof t) throw new TypeError();

    var i = T.call(arguments, 1),
        n = function n() {
      if (this instanceof n) {
        var s = function s() {};

        s.prototype = t.prototype;
        var r = new s(),
            o = t.apply(r, i.concat(T.call(arguments)));
        return Object(o) === o ? o : r;
      }

      return t.apply(e, i.concat(T.call(arguments)));
    };

    return n;
  }), w.opacity = function () {
    return s("opacity:.55"), /^0.55$/.test(g.opacity);
  }, w.cssanimations = function () {
    return u("animationName");
  }, w.csstransitions = function () {
    return u("transition");
  };

  for (var C in w) {
    d(w, C) && (c = C.toLowerCase(), p[c] = w[C](), S.push((p[c] ? "" : "no-") + c));
  }

  return p.addTest = function (e, t) {
    if ("object" == (0, _typeof2["default"])(e)) for (var n in e) {
      d(e, n) && p.addTest(n, e[n]);
    } else {
      if (e = e.toLowerCase(), p[e] !== i) return p;
      t = "function" == typeof t ? t() : t, h.className += " " + (t ? "" : "no-") + e, p[e] = t;
    }
    return p;
  }, n(""), m = null, p._version = "2.8.3", p._prefixes = b, p._domPrefixes = y, p._cssomPrefixes = k, p.testProp = function (e) {
    return a([e]);
  }, p.testAllProps = u, p.testStyles = x, h.className = h.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + " js " + S.join(" "), p;
}(0, (void 0).document), function (e, t, i) {
  function n(e) {
    return "[object Function]" == g.call(e);
  }

  function s(e) {
    return "string" == typeof e;
  }

  function r() {}

  function o(e) {
    return !e || "loaded" == e || "complete" == e || "uninitialized" == e;
  }

  function a() {
    var e = b.shift();
    v = 1, e ? e.t ? f(function () {
      ("c" == e.t ? _p.injectCss : _p.injectJs)(e.s, 0, e.a, e.x, e.e, 1);
    }, 0) : (e(), a()) : v = 0;
  }

  function l(e, i, n, s, r, l, u) {
    function c(t) {
      if (!h && o(d.readyState) && (k.r = h = 1, !v && a(), d.onload = d.onreadystatechange = null, t)) {
        "img" != e && f(function () {
          w.removeChild(d);
        }, 50);

        for (var n in C[i]) {
          C[i].hasOwnProperty(n) && C[i][n].onload();
        }
      }
    }

    var u = u || _p.errorTimeout,
        d = t.createElement(e),
        h = 0,
        g = 0,
        k = {
      t: n,
      s: i,
      e: r,
      a: l,
      x: u
    };
    1 === C[i] && (g = 1, C[i] = []), "object" == e ? d.data = i : (d.src = i, d.type = e), d.width = d.height = "0", d.onerror = d.onload = d.onreadystatechange = function () {
      c.call(this, g);
    }, b.splice(s, 0, k), "img" != e && (g || 2 === C[i] ? (w.insertBefore(d, y ? null : m), f(c, u)) : C[i].push(d));
  }

  function u(e, t, i, n, r) {
    return v = 0, t = t || "j", s(e) ? l("c" == t ? T : S, e, t, this.i++, i, n, r) : (b.splice(this.i++, 0, e), 1 == b.length && a()), this;
  }

  function c() {
    var e = _p;
    return e.loader = {
      load: u,
      i: 0
    }, e;
  }

  var d,
      _p,
      h = t.documentElement,
      f = e.setTimeout,
      m = t.getElementsByTagName("script")[0],
      g = {}.toString,
      b = [],
      v = 0,
      k = ("MozAppearance" in h.style),
      y = k && !!t.createRange().compareNode,
      w = y ? h : m.parentNode,
      h = e.opera && "[object Opera]" == g.call(e.opera),
      h = !!t.attachEvent && !h,
      S = k ? "object" : h ? "script" : "img",
      T = h ? "script" : S,
      x = Array.isArray || function (e) {
    return "[object Array]" == g.call(e);
  },
      E = [],
      C = {},
      I = {
    timeout: function timeout(e, t) {
      return t.length && (e.timeout = t[0]), e;
    }
  };

  _p = function p(e) {
    function t(e) {
      var t,
          i,
          n,
          e = e.split("!"),
          s = E.length,
          r = e.pop(),
          o = e.length,
          r = {
        url: r,
        origUrl: r,
        prefixes: e
      };

      for (i = 0; i < o; i++) {
        n = e[i].split("="), (t = I[n.shift()]) && (r = t(r, n));
      }

      for (i = 0; i < s; i++) {
        r = E[i](r);
      }

      return r;
    }

    function o(e, s, r, o, a) {
      var l = t(e),
          u = l.autoCallback;
      l.url.split(".").pop().split("?").shift(), l.bypass || (s && (s = n(s) ? s : s[e] || s[o] || s[e.split("/").pop().split("?")[0]]), l.instead ? l.instead(e, s, r, o, a) : (C[l.url] ? l.noexec = !0 : C[l.url] = 1, r.load(l.url, l.forceCSS || !l.forceJS && "css" == l.url.split(".").pop().split("?").shift() ? "c" : i, l.noexec, l.attrs, l.timeout), (n(s) || n(u)) && r.load(function () {
        c(), s && s(l.origUrl, a, o), u && u(l.origUrl, a, o), C[l.url] = 2;
      })));
    }

    function a(e, t) {
      function i(e, i) {
        if (e) {
          if (s(e)) i || (d = function d() {
            var e = [].slice.call(arguments);
            p.apply(this, e), h();
          }), o(e, d, t, 0, u);else if (Object(e) === e) for (l in a = function () {
            var t,
                i = 0;

            for (t in e) {
              e.hasOwnProperty(t) && i++;
            }

            return i;
          }(), e) {
            e.hasOwnProperty(l) && (!i && ! --a && (n(d) ? d = function d() {
              var e = [].slice.call(arguments);
              p.apply(this, e), h();
            } : d[l] = function (e) {
              return function () {
                var t = [].slice.call(arguments);
                e && e.apply(this, t), h();
              };
            }(p[l])), o(e[l], d, t, l, u));
          }
        } else !i && h();
      }

      var a,
          l,
          u = !!e.test,
          c = e.load || e.both,
          d = e.callback || r,
          p = d,
          h = e.complete || r;
      i(u ? e.yep : e.nope, !!c), c && i(c);
    }

    var l,
        u,
        d = this.yepnope.loader;
    if (s(e)) o(e, 0, d, 0);else if (x(e)) for (l = 0; l < e.length; l++) {
      u = e[l], s(u) ? o(u, 0, d, 0) : x(u) ? _p(u) : Object(u) === u && a(u, d);
    } else Object(e) === e && a(e, d);
  }, _p.addPrefix = function (e, t) {
    I[e] = t;
  }, _p.addFilter = function (e) {
    E.push(e);
  }, _p.errorTimeout = 1e4, null == t.readyState && t.addEventListener && (t.readyState = "loading", t.addEventListener("DOMContentLoaded", d = function (_d) {
    function d() {
      return _d.apply(this, arguments);
    }

    d.toString = function () {
      return _d.toString();
    };

    return d;
  }(function () {
    t.removeEventListener("DOMContentLoaded", d, 0), t.readyState = "complete";
  }), 0)), e.yepnope = c(), e.yepnope.executeStack = a, e.yepnope.injectJs = function (e, i, n, s, l, u) {
    var c,
        d,
        h = t.createElement("script"),
        s = s || _p.errorTimeout;
    h.src = e;

    for (d in n) {
      h.setAttribute(d, n[d]);
    }

    i = u ? a : i || r, h.onreadystatechange = h.onload = function () {
      !c && o(h.readyState) && (c = 1, i(), h.onload = h.onreadystatechange = null);
    }, f(function () {
      c || (c = 1, i(1));
    }, s), l ? h.onload() : m.parentNode.insertBefore(h, m);
  }, e.yepnope.injectCss = function (e, i, n, s, o, l) {
    var u,
        s = t.createElement("link"),
        i = l ? a : i || r;
    s.href = e, s.rel = "stylesheet", s.type = "text/css";

    for (u in n) {
      s.setAttribute(u, n[u]);
    }

    o || (m.parentNode.insertBefore(s, m), f(i, 0));
  };
}(void 0, document), Modernizr.load = function () {
  yepnope.apply(window, [].slice.call(arguments, 0));
}, Modernizr.addTest("cssvwunit", function () {
  var e;
  return Modernizr.testStyles("#modernizr { width: 50vw; }", function (t, i) {
    var n = parseInt(window.innerWidth / 2, 10),
        s = parseInt((window.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).width, 10);
    e = s == n;
  }), e;
}), define("modernizr", function () {});
var kCHARSET_RULE_MISSING_SEMICOLON = "Missing semicolon at the end of @charset rule",
    kCHARSET_RULE_CHARSET_IS_STRING = "The charset in the @charset rule should be a string",
    kCHARSET_RULE_MISSING_WS = "Missing mandatory whitespace after @charset",
    kIMPORT_RULE_MISSING_URL = "Missing URL in @import rule",
    kURL_EOF = "Unexpected end of stylesheet",
    kURL_WS_INSIDE = "Multiple tokens inside a url() notation",
    kVARIABLES_RULE_POSITION = "@variables rule invalid at this position in the stylesheet",
    kIMPORT_RULE_POSITION = "@import rule invalid at this position in the stylesheet",
    kNAMESPACE_RULE_POSITION = "@namespace rule invalid at this position in the stylesheet",
    kCHARSET_RULE_CHARSET_SOF = "@charset rule invalid at this position in the stylesheet",
    kUNKNOWN_AT_RULE = "Unknow @-rule",
    kCSS_VENDOR_VALUES = {
  "-moz-box": {
    webkit: "-webkit-box",
    presto: "",
    trident: "",
    generic: "box"
  },
  "-moz-inline-box": {
    webkit: "-webkit-inline-box",
    presto: "",
    trident: "",
    generic: "inline-box"
  },
  "-moz-initial": {
    webkit: "",
    presto: "",
    trident: "",
    generic: "initial"
  },
  flex: {
    webkit: "-webkit-flex",
    presto: "",
    trident: "",
    generic: ""
  },
  "inline-flex": {
    webkit: "-webkit-inline-flex",
    presto: "",
    trident: "",
    generic: ""
  },
  "linear-gradient": {
    webkit20110101: FilterLinearGradient,
    webkit: FilterLinearGradient,
    presto: FilterLinearGradient,
    trident: FilterLinearGradient,
    "gecko1.9.2": FilterLinearGradient
  },
  "repeating-linear-gradient": {
    webkit20110101: FilterLinearGradient,
    webkit: FilterLinearGradient,
    presto: FilterLinearGradient,
    trident: FilterLinearGradient,
    "gecko1.9.2": FilterLinearGradient
  },
  "radial-gradient": {
    webkit20110101: FilterRadialGradient,
    webkit: FilterRadialGradient,
    presto: FilterRadialGradient,
    trident: FilterRadialGradient,
    "gecko1.9.2": FilterRadialGradient
  },
  "repeating-radial-gradient": {
    webkit20110101: FilterRadialGradient,
    webkit: FilterRadialGradient,
    presto: FilterRadialGradient,
    trident: FilterRadialGradient,
    "gecko1.9.2": FilterRadialGradient
  }
},
    kCSS_VENDOR_PREFIXES = {
  lastUpdate: 1374591005,
  properties: [{
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-accelerator",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "-wap-accesskey",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-align-content",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "align-items",
    webkit: "-webkit-align-items",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "align-self",
    webkit: "-webkit-align-self",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "animation",
    webkit: "-webkit-animation",
    presto: "",
    trident: "animation",
    status: "WD"
  }, {
    gecko: "animation-delay",
    webkit: "-webkit-animation-delay",
    presto: "",
    trident: "animation-delay",
    status: "WD"
  }, {
    gecko: "animation-direction",
    webkit: "-webkit-animation-direction",
    presto: "",
    trident: "animation-direction",
    status: "WD"
  }, {
    gecko: "animation-duration",
    webkit: "-webkit-animation-duration",
    presto: "",
    trident: "animation-duration",
    status: "WD"
  }, {
    gecko: "animation-fill-mode",
    webkit: "-webkit-animation-fill-mode",
    presto: "",
    trident: "animation-fill-mode",
    status: "ED"
  }, {
    gecko: "animation-iteration-count",
    webkit: "-webkit-animation-iteration-count",
    presto: "",
    trident: "animation-iteration-count",
    status: "WD"
  }, {
    gecko: "animation-name",
    webkit: "-webkit-animation-name",
    presto: "",
    trident: "animation-name",
    status: "WD"
  }, {
    gecko: "animation-play-state",
    webkit: "-webkit-animation-play-state",
    presto: "",
    trident: "animation-play-state",
    status: "WD"
  }, {
    gecko: "animation-timing-function",
    webkit: "-webkit-animation-timing-function",
    presto: "",
    trident: "animation-timing-function",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-app-region",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-appearance",
    webkit: "-webkit-appearance",
    presto: "",
    trident: "",
    status: "CR"
  }, {
    gecko: "",
    webkit: "-webkit-aspect-ratio",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "backface-visibility",
    webkit: "-webkit-backface-visibility",
    presto: "",
    trident: "backface-visibility",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-background-blend-mode",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "background-clip",
    webkit: "-webkit-background-clip",
    presto: "background-clip",
    trident: "background-clip",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-background-composite",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-background-inline-policy",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "background-origin",
    webkit: "-webkit-background-origin",
    presto: "background-origin",
    trident: "background-origin",
    status: "WD"
  }, {
    gecko: "",
    webkit: "background-position-x",
    presto: "",
    trident: "-ms-background-position-x",
    status: ""
  }, {
    gecko: "",
    webkit: "background-position-y",
    presto: "",
    trident: "-ms-background-position-y",
    status: ""
  }, {
    gecko: "background-size",
    webkit: "-webkit-background-size",
    presto: "background-size",
    trident: "background-size",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-behavior",
    status: ""
  }, {
    gecko: "-moz-binding",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-blend-mode",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-block-progression",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-border-after",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-after-color",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-after-style",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-after-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-before",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-before-color",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-before-style",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-before-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-bottom-colors",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "border-bottom-left-radius",
    webkit: "-webkit-border-bottom-left-radius",
    presto: "border-bottom-left-radius",
    trident: "border-bottom-left-radius",
    status: "WD"
  }, {
    gecko: "border-bottom-right-radius",
    webkit: "-webkit-border-bottom-right-radius",
    presto: "border-bottom-right-radius",
    trident: "border-bottom-right-radius",
    status: "WD"
  }, {
    gecko: "-moz-border-end",
    webkit: "-webkit-border-end",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-end-color",
    webkit: "-webkit-border-end-color",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-end-style",
    webkit: "-webkit-border-end-style",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-end-width",
    webkit: "-webkit-border-end-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-border-fit",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-border-horizontal-spacing",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "border-image",
    webkit: "-webkit-border-image",
    presto: "-o-border-image",
    trident: "",
    status: "WD"
  }, {
    gecko: "-moz-border-left-colors",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "border-radius",
    webkit: "-webkit-border-radius",
    presto: "border-radius",
    trident: "border-radius",
    status: "WD"
  }, {
    gecko: "-moz-border-right-colors",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-border-start",
    webkit: "-webkit-border-start",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-start-color",
    webkit: "-webkit-border-start-color",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-start-style",
    webkit: "-webkit-border-start-style",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-start-width",
    webkit: "-webkit-border-start-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-border-top-colors",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "border-top-left-radius",
    webkit: "-webkit-border-top-left-radius",
    presto: "border-top-left-radius",
    trident: "border-top-left-radius",
    status: "WD"
  }, {
    gecko: "border-top-right-radius",
    webkit: "-webkit-border-top-right-radius",
    presto: "border-top-right-radius",
    trident: "border-top-right-radius",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-border-vertical-spacing",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-box-align",
    webkit: "-webkit-box-align",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-box-decoration-break",
    presto: "box-decoration-break",
    trident: "",
    status: "WD"
  }, {
    gecko: "-moz-box-direction",
    webkit: "-webkit-box-direction",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "-moz-box-flex",
    webkit: "-webkit-box-flex",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-box-flex-group",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-box-lines",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "-moz-box-ordinal-group",
    webkit: "-webkit-box-ordinal-group",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "-moz-box-orient",
    webkit: "-webkit-box-orient",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "-moz-box-pack",
    webkit: "-webkit-box-pack",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-box-reflect",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "box-shadow",
    webkit: "-webkit-box-shadow",
    presto: "box-shadow",
    trident: "box-shadow",
    status: "WD"
  }, {
    gecko: "-moz-box-sizing",
    webkit: "-webkit-box-sizing",
    presto: "box-sizing",
    trident: "box-sizing",
    status: "CR"
  }, {
    gecko: "caption-side",
    webkit: "-epub-caption-side",
    presto: "caption-side",
    trident: "caption-side",
    status: ""
  }, {
    gecko: "clip-path",
    webkit: "-webkit-clip-path",
    presto: "clip-path",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-color-correction",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-column-axis",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-column-break-after",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-column-break-before",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-column-break-inside",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-column-count",
    webkit: "-webkit-column-count",
    presto: "column-count",
    trident: "column-count",
    status: "CR"
  }, {
    gecko: "-moz-column-fill",
    webkit: "",
    presto: "column-fill",
    trident: "column-fill",
    status: "CR"
  }, {
    gecko: "-moz-column-gap",
    webkit: "-webkit-column-gap",
    presto: "column-gap",
    trident: "column-gap",
    status: "CR"
  }, {
    gecko: "",
    webkit: "-webkit-column-progression",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-column-rule",
    webkit: "-webkit-column-rule",
    presto: "column-rule",
    trident: "column-rule",
    status: "CR"
  }, {
    gecko: "-moz-column-rule-color",
    webkit: "-webkit-column-rule-color",
    presto: "column-rule-color",
    trident: "column-rule-color",
    status: "CR"
  }, {
    gecko: "-moz-column-rule-style",
    webkit: "-webkit-column-rule-style",
    presto: "column-rule-style",
    trident: "column-rule-style",
    status: "CR"
  }, {
    gecko: "-moz-column-rule-width",
    webkit: "-webkit-column-rule-width",
    presto: "column-rule-width",
    trident: "column-rule-width",
    status: "CR"
  }, {
    gecko: "",
    webkit: "-webkit-column-span",
    presto: "column-span",
    trident: "column-span",
    status: "CR"
  }, {
    gecko: "-moz-column-width",
    webkit: "-webkit-column-width",
    presto: "column-width",
    trident: "column-width",
    status: "CR"
  }, {
    gecko: "-moz-columns",
    webkit: "-webkit-columns",
    presto: "columns",
    trident: "columns",
    status: "CR"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-chaining",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-limit",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-limit-max",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-limit-min",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-snap",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-snap-points",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zoom-snap-type",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-content-zooming",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-cursor-visibility",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-dashboard-region",
    presto: "-apple-dashboard-region",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-device-pixel-ratio",
    trident: "",
    status: ""
  }, {
    gecko: "filter",
    webkit: "-webkit-filter",
    presto: "filter",
    trident: "-ms-filter",
    status: ""
  }, {
    gecko: "flex",
    webkit: "-webkit-flex",
    presto: "",
    trident: "-ms-flex",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-flex-align",
    status: ""
  }, {
    gecko: "flex-basis",
    webkit: "-webkit-flex-basis",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "flex-direction",
    webkit: "-webkit-flex-direction",
    presto: "",
    trident: "-ms-flex-direction",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-flex-flow",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "flex-grow",
    webkit: "-webkit-flex-grow",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-flex-order",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-flex-pack",
    status: ""
  }, {
    gecko: "flex-shrink",
    webkit: "-webkit-flex-shrink",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-flex-wrap",
    presto: "",
    trident: "-ms-flex-wrap",
    status: ""
  }, {
    gecko: "-moz-float-edge",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-flow-from",
    presto: "",
    trident: "-ms-flow-from",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-flow-into",
    presto: "",
    trident: "-ms-flow-into",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-focus-opacity",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-font-feature-settings",
    webkit: "-webkit-font-feature-settings",
    presto: "",
    trident: "font-feature-settings",
    status: ""
  }, {
    gecko: "font-kerning",
    webkit: "-webkit-font-kerning",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-font-language-override",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-font-size-delta",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-font-smoothing",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "font-variant-ligatures",
    webkit: "-webkit-font-variant-ligatures",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-force-broken-image-icon",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-after",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-auto-columns",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-auto-flow",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-auto-rows",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-before",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-column",
    presto: "",
    trident: "-ms-grid-column",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-grid-column-align",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-grid-column-span",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-grid-columns",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-grid-definition-columns",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-definition-rows",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-end",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-grid-row",
    presto: "",
    trident: "-ms-grid-row",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-grid-row-align",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-grid-row-span",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-grid-rows",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-grid-start",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-high-contrast-adjust",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-highlight",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-hyphenate-character",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-hyphenate-limit-after",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-hyphenate-limit-before",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-hyphenate-limit-chars",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-hyphenate-limit-lines",
    presto: "",
    trident: "-ms-hyphenate-limit-lines",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-hyphenate-limit-zone",
    status: ""
  }, {
    gecko: "-moz-hyphens",
    webkit: "-epub-hyphens",
    presto: "",
    trident: "-ms-hyphens",
    status: "WD"
  }, {
    gecko: "-moz-image-region",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "ime-mode",
    webkit: "",
    presto: "",
    trident: "-ms-ime-mode",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-wap-input-format",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-wap-input-required",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-interpolation-mode",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-interpret-as",
    trident: "",
    status: ""
  }, {
    gecko: "justify-content",
    webkit: "-webkit-justify-content",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-layout-flow",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-layout-grid",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-layout-grid-char",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-layout-grid-line",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-layout-grid-mode",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-layout-grid-type",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-line-align",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-line-box-contain",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-line-break",
    presto: "",
    trident: "line-break",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-line-clamp",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-line-grid",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-line-snap",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-link",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-link-source",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-locale",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-logical-height",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-logical-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-margin-after",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-margin-after-collapse",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-margin-before",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-margin-before-collapse",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-margin-bottom-collapse",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-margin-collapse",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-margin-end",
    webkit: "-webkit-margin-end",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-margin-start",
    webkit: "-webkit-margin-start",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-margin-top-collapse",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-marquee",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-wap-marquee-dir",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-marquee-direction",
    presto: "",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-marquee-increment",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-wap-marquee-loop",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-marquee-repetition",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-marquee-speed",
    presto: "-wap-marquee-speed",
    trident: "",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-marquee-style",
    presto: "-wap-marquee-style",
    trident: "",
    status: "WD"
  }, {
    gecko: "mask",
    webkit: "-webkit-mask",
    presto: "mask",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-box-image",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-box-image-outset",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-box-image-repeat",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-box-image-slice",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-box-image-source",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-box-image-width",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-clip",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-composite",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-image",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-origin",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-position",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-position-x",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-position-y",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-repeat",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-repeat-x",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-repeat-y",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-mask-size",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-max-logical-height",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-max-logical-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-min-logical-height",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-min-logical-width",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-mini-fold",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-nbsp-mode",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-object-fit",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-object-position",
    trident: "",
    status: "ED"
  }, {
    gecko: "opacity",
    webkit: "-webkit-opacity",
    presto: "opacity",
    trident: "opacity",
    status: "WD"
  }, {
    gecko: "order",
    webkit: "-webkit-order",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-orient",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-outline-radius",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-outline-radius-bottomleft",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-outline-radius-bottomright",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-outline-radius-topleft",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-outline-radius-topright",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-overflow-scrolling",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-overflow-style",
    status: "CR"
  }, {
    gecko: "overflow-x",
    webkit: "overflow-x",
    presto: "overflow-x",
    trident: "-ms-overflow-x",
    status: "WD"
  }, {
    gecko: "overflow-y",
    webkit: "overflow-y",
    presto: "overflow-y",
    trident: "-ms-overflow-y",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-padding-after",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "",
    webkit: "-webkit-padding-before",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-padding-end",
    webkit: "-webkit-padding-end",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "-moz-padding-start",
    webkit: "-webkit-padding-start",
    presto: "",
    trident: "",
    status: "ED"
  }, {
    gecko: "perspective",
    webkit: "-webkit-perspective",
    presto: "",
    trident: "perspective",
    status: "WD"
  }, {
    gecko: "perspective-origin",
    webkit: "-webkit-perspective-origin",
    presto: "",
    trident: "perspective-origin",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-perspective-origin-x",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-perspective-origin-y",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-phonemes",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-print-color-adjust",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-progress-appearance",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-region-break-after",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-region-break-before",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-region-break-inside",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-region-fragment",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-rtl-ordering",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-ruby-position",
    presto: "",
    trident: "ruby-position",
    status: "CR"
  }, {
    gecko: "-moz-script-level",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-script-min-size",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-script-size-multiplier",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-chaining",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-limit",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-limit-x-max",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-limit-x-min",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-limit-y-max",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-limit-y-min",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-rails",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-snap-points-x",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-snap-points-y",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-snap-type",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-snap-x",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-snap-y",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-scroll-translation",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-arrow-color",
    trident: "-ms-scrollbar-arrow-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-base-color",
    trident: "-ms-scrollbar-base-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-darkshadow-color",
    trident: "-ms-scrollbar-darkshadow-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-face-color",
    trident: "-ms-scrollbar-face-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-highlight-color",
    trident: "-ms-scrollbar-highlight-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-shadow-color",
    trident: "-ms-scrollbar-shadow-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "scrollbar-track-color",
    trident: "-ms-scrollbar-track-color",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-shape-inside",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-shape-margin",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-shape-outside",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-shape-padding",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-stack-sizing",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-svg-shadow",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-tab-size",
    webkit: "tab-size",
    presto: "-o-tab-size",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-o-table-baseline",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-tap-highlight-color",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-text-align-last",
    webkit: "-webkit-text-align-last",
    presto: "",
    trident: "-ms-text-align-last",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-text-autospace",
    status: "WD"
  }, {
    gecko: "-moz-text-blink",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-epub-text-combine",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-text-decoration-color",
    webkit: "-webkit-text-decoration-color",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-text-decoration-line",
    webkit: "-webkit-text-decoration-line",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-text-decoration-style",
    webkit: "-webkit-text-decoration-style",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-text-decorations-in-effect",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-epub-text-emphasis",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-epub-text-emphasis-color",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-text-emphasis-position",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-epub-text-emphasis-style",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-text-fill-color",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-text-justify",
    presto: "",
    trident: "-ms-text-justify",
    status: "WD"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-text-kashida-space",
    status: "P"
  }, {
    gecko: "",
    webkit: "-epub-text-orientation",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "text-overflow",
    webkit: "text-overflow",
    presto: "text-overflow",
    trident: "-ms-text-overflow",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-text-security",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-text-size-adjust",
    webkit: "",
    presto: "",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-text-stroke",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-text-stroke-color",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-text-stroke-width",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "text-transform",
    webkit: "-epub-text-transform",
    presto: "text-transform",
    trident: "text-transform",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-text-underline-position",
    presto: "",
    trident: "-ms-text-underline-position",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-touch-action",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-touch-callout",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-transform",
    webkit: "-webkit-transform",
    presto: "-o-transform",
    trident: "transform",
    status: "WD"
  }, {
    gecko: "transform-origin",
    webkit: "-webkit-transform-origin",
    presto: "-o-transform-origin",
    trident: "transform-origin",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-transform-origin-x",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-transform-origin-y",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "",
    webkit: "-webkit-transform-origin-z",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "transform-style",
    webkit: "-webkit-transform-style",
    presto: "",
    trident: "transform-style",
    status: "WD"
  }, {
    gecko: "transition",
    webkit: "-webkit-transition",
    presto: "-o-transition",
    trident: "transition",
    status: "WD"
  }, {
    gecko: "transition-delay",
    webkit: "-webkit-transition-delay",
    presto: "-o-transition-delay",
    trident: "transition-delay",
    status: "WD"
  }, {
    gecko: "transition-duration",
    webkit: "-webkit-transition-duration",
    presto: "-o-transition-duration",
    trident: "transition-duration",
    status: "WD"
  }, {
    gecko: "transition-property",
    webkit: "-webkit-transition-property",
    presto: "-o-transition-property",
    trident: "transition-property",
    status: "WD"
  }, {
    gecko: "transition-timing-function",
    webkit: "-webkit-transition-timing-function",
    presto: "-o-transition-timing-function",
    trident: "transition-timing-function",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-user-drag",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-user-focus",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-user-input",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-user-modify",
    webkit: "-webkit-user-modify",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "-moz-user-select",
    webkit: "-webkit-user-select",
    presto: "",
    trident: "-ms-user-select",
    status: "P"
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-balance",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-duration",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-pitch",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-pitch-range",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-rate",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-stress",
    trident: "",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "-xv-voice-volume",
    trident: "",
    status: ""
  }, {
    gecko: "-moz-window-shadow",
    webkit: "",
    presto: "",
    trident: "",
    status: "P"
  }, {
    gecko: "word-break",
    webkit: "-epub-word-break",
    presto: "",
    trident: "-ms-word-break",
    status: "WD"
  }, {
    gecko: "word-wrap",
    webkit: "word-wrap",
    presto: "word-wrap",
    trident: "-ms-word-wrap",
    status: "WD"
  }, {
    gecko: "",
    webkit: "-webkit-wrap-flow",
    presto: "",
    trident: "-ms-wrap-flow",
    status: ""
  }, {
    gecko: "",
    webkit: "",
    presto: "",
    trident: "-ms-wrap-margin",
    status: ""
  }, {
    gecko: "",
    webkit: "-webkit-wrap-through",
    presto: "",
    trident: "-ms-wrap-through",
    status: ""
  }, {
    gecko: "writing-mode",
    webkit: "-epub-writing-mode",
    presto: "writing-mode",
    trident: "-ms-writing-mode",
    status: "ED"
  }, {
    gecko: "",
    webkit: "zoom",
    presto: "",
    trident: "-ms-zoom",
    status: ""
  }]
},
    kCSS_PREFIXED_VALUE = [{
  gecko: "-moz-box",
  webkit: "-moz-box",
  presto: "",
  trident: "",
  generic: "box"
}],
    PrefixHelper = {
  mVENDOR_PREFIXES: null,
  kEXPORTS_FOR_GECKO: !0,
  kEXPORTS_FOR_WEBKIT: !0,
  kEXPORTS_FOR_PRESTO: !0,
  kEXPORTS_FOR_TRIDENT: !0,
  cleanPrefixes: function cleanPrefixes() {
    this.mVENDOR_PREFIXES = null;
  },
  prefixesForProperty: function prefixesForProperty(e) {
    if (!this.mVENDOR_PREFIXES) {
      this.mVENDOR_PREFIXES = {};

      for (var t = 0; t < kCSS_VENDOR_PREFIXES.properties.length; t++) {
        var i = kCSS_VENDOR_PREFIXES.properties[t];

        if (i.gecko && (i.webkit || i.presto || i.trident)) {
          var n = {};
          this.kEXPORTS_FOR_GECKO && (n[i.gecko] = !0), this.kEXPORTS_FOR_WEBKIT && i.webkit && (n[i.webkit] = !0), this.kEXPORTS_FOR_PRESTO && i.presto && (n[i.presto] = !0), this.kEXPORTS_FOR_TRIDENT && i.trident && (n[i.trident] = !0), this.mVENDOR_PREFIXES[i.gecko] = [];

          for (var s in n) {
            this.mVENDOR_PREFIXES[i.gecko].push(s);
          }
        }
      }
    }

    return e in this.mVENDOR_PREFIXES ? this.mVENDOR_PREFIXES[e].sort() : null;
  }
},
    CSS_ESCAPE = "\\",
    IS_HEX_DIGIT = 1,
    START_IDENT = 2,
    IS_IDENT = 4,
    IS_WHITESPACE = 8,
    W = IS_WHITESPACE,
    I = IS_IDENT,
    S = START_IDENT,
    SI = IS_IDENT | START_IDENT,
    XI = IS_IDENT | IS_HEX_DIGIT,
    XSI = IS_IDENT | START_IDENT | IS_HEX_DIGIT;
CSSScanner.prototype = {
  kLexTable: [0, 0, 0, 0, 0, 0, 0, 0, 0, W, W, 0, W, W, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, W, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, I, 0, 0, XI, XI, XI, XI, XI, XI, XI, XI, XI, XI, 0, 0, 0, 0, 0, 0, 0, XSI, XSI, XSI, XSI, XSI, XSI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, 0, S, 0, 0, SI, 0, XSI, XSI, XSI, XSI, XSI, XSI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI, SI],
  kHexValues: {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
  },
  mString: "",
  mPos: 0,
  mPreservedPos: [],
  init: function init(e) {
    this.mString = e, this.mPos = 0, this.mPreservedPos = [];
  },
  getCurrentPos: function getCurrentPos() {
    return this.mPos;
  },
  getAlreadyScanned: function getAlreadyScanned() {
    return this.mString.substr(0, this.mPos);
  },
  preserveState: function preserveState() {
    this.mPreservedPos.push(this.mPos);
  },
  restoreState: function restoreState() {
    this.mPreservedPos.length && (this.mPos = this.mPreservedPos.pop());
  },
  forgetState: function forgetState() {
    this.mPreservedPos.length && this.mPreservedPos.pop();
  },
  read: function read() {
    return this.mPos < this.mString.length ? this.mString.charAt(this.mPos++) : -1;
  },
  peek: function peek() {
    return this.mPos < this.mString.length ? this.mString.charAt(this.mPos) : -1;
  },
  isHexDigit: function isHexDigit(e) {
    var t = e.charCodeAt(0);
    return 256 > t && 0 != (this.kLexTable[t] & IS_HEX_DIGIT);
  },
  isIdentStart: function isIdentStart(e) {
    var t = e.charCodeAt(0);
    return t >= 256 || 0 != (this.kLexTable[t] & START_IDENT);
  },
  startsWithIdent: function startsWithIdent(e, t) {
    return e.charCodeAt(0), this.isIdentStart(e) || "-" == e && this.isIdentStart(t);
  },
  isIdent: function isIdent(e) {
    var t = e.charCodeAt(0);
    return t >= 256 || 0 != (this.kLexTable[t] & IS_IDENT);
  },
  pushback: function pushback() {
    this.mPos--;
  },
  nextHexValue: function nextHexValue() {
    var e = this.read();
    if (-1 == e || !this.isHexDigit(e)) return new jscsspToken(jscsspToken.NULL_TYPE, null);
    var t = e;

    for (e = this.read(); -1 != e && this.isHexDigit(e);) {
      t += e, e = this.read();
    }

    return -1 != e && this.pushback(), new jscsspToken(jscsspToken.HEX_TYPE, t);
  },
  gatherEscape: function gatherEscape() {
    var e = this.peek();
    if (-1 == e) return "";

    if (this.isHexDigit(e)) {
      for (var t = 0, i = 0; 6 > i; i++) {
        if (e = this.read(), !this.isHexDigit(e)) {
          if (this.isHexDigit(e) || this.isWhiteSpace(e)) break;
          this.pushback();
          break;
        }

        t = 16 * t + this.kHexValues[e.toLowerCase()];
      }

      return 6 == i && (e = this.peek(), this.isWhiteSpace(e) && this.read()), String.fromCharCode(t);
    }

    return e = this.read(), "\n" != e ? e : "";
  },
  gatherIdent: function gatherIdent(e) {
    var t = "";

    for (t += e == CSS_ESCAPE ? this.gatherEscape() : e, e = this.read(); -1 != e && (this.isIdent(e) || e == CSS_ESCAPE);) {
      t += e == CSS_ESCAPE ? this.gatherEscape() : e, e = this.read();
    }

    return -1 != e && this.pushback(), t;
  },
  parseIdent: function parseIdent(e) {
    var t = this.gatherIdent(e);
    return "(" == this.peek() ? (t += this.read(), new jscsspToken(jscsspToken.FUNCTION_TYPE, t)) : new jscsspToken(jscsspToken.IDENT_TYPE, t);
  },
  isDigit: function isDigit(e) {
    return e >= "0" && "9" >= e;
  },
  parseComment: function parseComment(e) {
    for (var t = e; -1 != (e = this.read());) {
      if (t += e, "*" == e) {
        if (-1 == (e = this.read())) break;

        if ("/" == e) {
          t += e;
          break;
        }

        this.pushback();
      }
    }

    return new jscsspToken(jscsspToken.COMMENT_TYPE, t);
  },
  parseNumber: function parseNumber(e) {
    for (var t = e, i = !1; -1 != (e = this.read());) {
      if ("." == e) {
        if (i) break;
        t += e, i = !0;
      } else {
        if (!this.isDigit(e)) break;
        t += e;
      }
    }

    if (-1 != e && this.startsWithIdent(e, this.peek())) {
      var n = this.gatherIdent(e);
      return t += n, new jscsspToken(jscsspToken.DIMENSION_TYPE, t, n);
    }

    return "%" == e ? (t += "%", new jscsspToken(jscsspToken.PERCENTAGE_TYPE, t)) : (-1 != e && this.pushback(), new jscsspToken(jscsspToken.NUMBER_TYPE, t));
  },
  parseString: function parseString(e) {
    for (var t, i = e, n = e; -1 != (t = this.read());) {
      if (t == e && n != CSS_ESCAPE) {
        i += t;
        break;
      }

      if (t == CSS_ESCAPE) {
        if (-1 == (t = this.peek())) break;
        "\n" == t || "\r" == t || "\f" == t ? (d = t, t = this.read(), "\r" == d && "\n" == (t = this.peek()) && (t = this.read())) : (i += this.gatherEscape(), t = this.peek());
      } else {
        if ("\n" == t || "\r" == t || "\f" == t) break;
        i += t;
      }

      n = t;
    }

    return new jscsspToken(jscsspToken.STRING_TYPE, i);
  },
  isWhiteSpace: function isWhiteSpace(e) {
    var t = e.charCodeAt(0);
    return 256 > t && 0 != (this.kLexTable[t] & IS_WHITESPACE);
  },
  eatWhiteSpace: function eatWhiteSpace(e) {
    for (var t = e; -1 != (e = this.read()) && this.isWhiteSpace(e);) {
      t += e;
    }

    return -1 != e && this.pushback(), t;
  },
  parseAtKeyword: function parseAtKeyword(e) {
    return new jscsspToken(jscsspToken.ATRULE_TYPE, this.gatherIdent(e));
  },
  nextToken: function nextToken() {
    var e = this.read();
    if (-1 == e) return new jscsspToken(jscsspToken.NULL_TYPE, null);
    if (this.startsWithIdent(e, this.peek())) return this.parseIdent(e);

    if ("@" == e) {
      var t = this.read();

      if (-1 != t) {
        var i = this.peek();
        if (this.pushback(), this.startsWithIdent(t, i)) return this.parseAtKeyword(e);
      }
    }

    if ("." == e || "+" == e || "-" == e) {
      var t = this.peek();
      if (this.isDigit(t)) return this.parseNumber(e);

      if ("." == t && "." != e) {
        firstChar = this.read();
        var n = this.peek();
        if (this.pushback(), this.isDigit(n)) return this.parseNumber(e);
      }
    }

    if (this.isDigit(e)) return this.parseNumber(e);
    if ("'" == e || '"' == e) return this.parseString(e);

    if (this.isWhiteSpace(e)) {
      var s = this.eatWhiteSpace(e);
      return new jscsspToken(jscsspToken.WHITESPACE_TYPE, s);
    }

    if ("|" == e || "~" == e || "^" == e || "$" == e || "*" == e) {
      var t = this.read();
      if ("=" == t) switch (e) {
        case "~":
          return new jscsspToken(jscsspToken.INCLUDES_TYPE, "~=");

        case "|":
          return new jscsspToken(jscsspToken.DASHMATCH_TYPE, "|=");

        case "^":
          return new jscsspToken(jscsspToken.BEGINSMATCH_TYPE, "^=");

        case "$":
          return new jscsspToken(jscsspToken.ENDSMATCH_TYPE, "$=");

        case "*":
          return new jscsspToken(jscsspToken.CONTAINSMATCH_TYPE, "*=");
      } else -1 != t && this.pushback();
    }

    return "/" == e && "*" == this.peek() ? this.parseComment(e) : new jscsspToken(jscsspToken.SYMBOL_TYPE, e);
  }
};

var CSSParser = function CSSParser(e) {
  this.mToken = null, this.mLookAhead = null, this.mScanner = new CSSScanner(e), this.mPreserveWS = !0, this.mPreserveComments = !0, this.mPreservedTokens = [], this.mError = null;
};

CSSParser.prototype = {
  _init: function _init() {
    this.mToken = null, this.mLookAhead = null;
  },
  kINHERIT: "inherit",
  kBORDER_WIDTH_NAMES: {
    thin: !0,
    medium: !0,
    thick: !0
  },
  kBORDER_STYLE_NAMES: {
    none: !0,
    hidden: !0,
    dotted: !0,
    dashed: !0,
    solid: !0,
    "double": !0,
    groove: !0,
    ridge: !0,
    inset: !0,
    outset: !0
  },
  kCOLOR_NAMES: {
    transparent: !0,
    black: !0,
    silver: !0,
    gray: !0,
    white: !0,
    maroon: !0,
    red: !0,
    purple: !0,
    fuchsia: !0,
    green: !0,
    lime: !0,
    olive: !0,
    yellow: !0,
    navy: !0,
    blue: !0,
    teal: !0,
    aqua: !0,
    aliceblue: !0,
    antiquewhite: !0,
    aquamarine: !0,
    azure: !0,
    beige: !0,
    bisque: !0,
    blanchedalmond: !0,
    blueviolet: !0,
    brown: !0,
    burlywood: !0,
    cadetblue: !0,
    chartreuse: !0,
    chocolate: !0,
    coral: !0,
    cornflowerblue: !0,
    cornsilk: !0,
    crimson: !0,
    cyan: !0,
    darkblue: !0,
    darkcyan: !0,
    darkgoldenrod: !0,
    darkgray: !0,
    darkgreen: !0,
    darkgrey: !0,
    darkkhaki: !0,
    darkmagenta: !0,
    darkolivegreen: !0,
    darkorange: !0,
    darkorchid: !0,
    darkred: !0,
    darksalmon: !0,
    darkseagreen: !0,
    darkslateblue: !0,
    darkslategray: !0,
    darkslategrey: !0,
    darkturquoise: !0,
    darkviolet: !0,
    deeppink: !0,
    deepskyblue: !0,
    dimgray: !0,
    dimgrey: !0,
    dodgerblue: !0,
    firebrick: !0,
    floralwhite: !0,
    forestgreen: !0,
    gainsboro: !0,
    ghostwhite: !0,
    gold: !0,
    goldenrod: !0,
    greenyellow: !0,
    grey: !0,
    honeydew: !0,
    hotpink: !0,
    indianred: !0,
    indigo: !0,
    ivory: !0,
    khaki: !0,
    lavender: !0,
    lavenderblush: !0,
    lawngreen: !0,
    lemonchiffon: !0,
    lightblue: !0,
    lightcoral: !0,
    lightcyan: !0,
    lightgoldenrodyellow: !0,
    lightgray: !0,
    lightgreen: !0,
    lightgrey: !0,
    lightpink: !0,
    lightsalmon: !0,
    lightseagreen: !0,
    lightskyblue: !0,
    lightslategray: !0,
    lightslategrey: !0,
    lightsteelblue: !0,
    lightyellow: !0,
    limegreen: !0,
    linen: !0,
    magenta: !0,
    mediumaquamarine: !0,
    mediumblue: !0,
    mediumorchid: !0,
    mediumpurple: !0,
    mediumseagreen: !0,
    mediumslateblue: !0,
    mediumspringgreen: !0,
    mediumturquoise: !0,
    mediumvioletred: !0,
    midnightblue: !0,
    mintcream: !0,
    mistyrose: !0,
    moccasin: !0,
    navajowhite: !0,
    oldlace: !0,
    olivedrab: !0,
    orange: !0,
    orangered: !0,
    orchid: !0,
    palegoldenrod: !0,
    palegreen: !0,
    paleturquoise: !0,
    palevioletred: !0,
    papayawhip: !0,
    peachpuff: !0,
    peru: !0,
    pink: !0,
    plum: !0,
    powderblue: !0,
    rosybrown: !0,
    royalblue: !0,
    saddlebrown: !0,
    salmon: !0,
    sandybrown: !0,
    seagreen: !0,
    seashell: !0,
    sienna: !0,
    skyblue: !0,
    slateblue: !0,
    slategray: !0,
    slategrey: !0,
    snow: !0,
    springgreen: !0,
    steelblue: !0,
    tan: !0,
    thistle: !0,
    tomato: !0,
    turquoise: !0,
    violet: !0,
    wheat: !0,
    whitesmoke: !0,
    yellowgreen: !0,
    activeborder: !0,
    activecaption: !0,
    appworkspace: !0,
    background: !0,
    buttonface: !0,
    buttonhighlight: !0,
    buttonshadow: !0,
    buttontext: !0,
    captiontext: !0,
    graytext: !0,
    highlight: !0,
    highlighttext: !0,
    inactiveborder: !0,
    inactivecaption: !0,
    inactivecaptiontext: !0,
    infobackground: !0,
    infotext: !0,
    menu: !0,
    menutext: !0,
    scrollbar: !0,
    threeddarkshadow: !0,
    threedface: !0,
    threedhighlight: !0,
    threedlightshadow: !0,
    threedshadow: !0,
    window: !0,
    windowframe: !0,
    windowtext: !0
  },
  kLIST_STYLE_TYPE_NAMES: {
    decimal: !0,
    "decimal-leading-zero": !0,
    "lower-roman": !0,
    "upper-roman": !0,
    georgian: !0,
    armenian: !0,
    "lower-latin": !0,
    "lower-alpha": !0,
    "upper-latin": !0,
    "upper-alpha": !0,
    "lower-greek": !0,
    disc: !0,
    circle: !0,
    square: !0,
    none: !0,
    box: !0,
    check: !0,
    diamond: !0,
    hyphen: !0,
    "lower-armenian": !0,
    "cjk-ideographic": !0,
    "ethiopic-numeric": !0,
    hebrew: !0,
    "japanese-formal": !0,
    "japanese-informal": !0,
    "simp-chinese-formal": !0,
    "simp-chinese-informal": !0,
    syriac: !0,
    tamil: !0,
    "trad-chinese-formal": !0,
    "trad-chinese-informal": !0,
    "upper-armenian": !0,
    "arabic-indic": !0,
    binary: !0,
    bengali: !0,
    cambodian: !0,
    khmer: !0,
    devanagari: !0,
    gujarati: !0,
    gurmukhi: !0,
    kannada: !0,
    "lower-hexadecimal": !0,
    lao: !0,
    malayalam: !0,
    mongolian: !0,
    myanmar: !0,
    octal: !0,
    oriya: !0,
    persian: !0,
    urdu: !0,
    telugu: !0,
    tibetan: !0,
    "upper-hexadecimal": !0,
    afar: !0,
    "ethiopic-halehame-aa-et": !0,
    "ethiopic-halehame-am-et": !0,
    "amharic-abegede": !0,
    "ehiopic-abegede-am-et": !0,
    "cjk-earthly-branch": !0,
    "cjk-heavenly-stem": !0,
    ethiopic: !0,
    "ethiopic-abegede": !0,
    "ethiopic-abegede-gez": !0,
    "hangul-consonant": !0,
    hangul: !0,
    "hiragana-iroha": !0,
    hiragana: !0,
    "katakana-iroha": !0,
    katakana: !0,
    "lower-norwegian": !0,
    oromo: !0,
    "ethiopic-halehame-om-et": !0,
    sidama: !0,
    "ethiopic-halehame-sid-et": !0,
    somali: !0,
    "ethiopic-halehame-so-et": !0,
    tigre: !0,
    "ethiopic-halehame-tig": !0,
    "tigrinya-er-abegede": !0,
    "ethiopic-abegede-ti-er": !0,
    "tigrinya-et": !0,
    "ethiopic-halehame-ti-et": !0,
    "upper-greek": !0,
    asterisks: !0,
    footnotes: !0,
    "circled-decimal": !0,
    "circled-lower-latin": !0,
    "circled-upper-latin": !0,
    "dotted-decimal": !0,
    "double-circled-decimal": !0,
    "filled-circled-decimal": !0,
    "parenthesised-decimal": !0,
    "parenthesised-lower-latin": !0
  },
  reportError: function reportError(e) {
    this.mError = e;
  },
  consumeError: function consumeError() {
    var e = this.mError;
    return this.mError = null, e;
  },
  currentToken: function currentToken() {
    return this.mToken;
  },
  getHexValue: function getHexValue() {
    return this.mToken = this.mScanner.nextHexValue(), this.mToken;
  },
  getToken: function getToken(e, t) {
    if (this.mLookAhead) return this.mToken = this.mLookAhead, this.mLookAhead = null, this.mToken;

    for (this.mToken = this.mScanner.nextToken(); this.mToken && (e && this.mToken.isWhiteSpace() || t && this.mToken.isComment());) {
      this.mToken = this.mScanner.nextToken();
    }

    return this.mToken;
  },
  lookAhead: function lookAhead(e, t) {
    var i = this.mToken;
    this.mScanner.preserveState();
    var n = this.getToken(e, t);
    return this.mScanner.restoreState(), this.mToken = i, n;
  },
  ungetToken: function ungetToken() {
    this.mLookAhead = this.mToken;
  },
  addUnknownAtRule: function addUnknownAtRule(e, t) {
    for (var i = CountLF(this.mScanner.getAlreadyScanned()), n = [], s = this.getToken(!1, !1); s.isNotNull() && (t += s.value, !s.isSymbol(";") || n.length);) {
      if (s.isSymbol("{") || s.isSymbol("(") || s.isSymbol("[") || "function" == s.type) n.push(s.isFunction() ? "(" : s.value);else if ((s.isSymbol("}") || s.isSymbol(")") || s.isSymbol("]")) && n.length) {
        var r = n[n.length - 1];
        if ((s.isSymbol("}") && "{" == r || s.isSymbol(")") && "(" == r || s.isSymbol("]") && "[" == r) && (n.pop(), !n.length && s.isSymbol("}"))) break;
      }
      s = this.getToken(!1, !1);
    }

    this.addUnknownRule(e, t, i);
  },
  addUnknownRule: function addUnknownRule(e, t, i) {
    var n = this.consumeError(),
        s = new jscsspErrorRule(n);
    s.currentLine = i, s.parsedCssText = t, s.parentStyleSheet = e, e.cssRules.push(s);
  },
  addWhitespace: function addWhitespace(e, t) {
    var i = new jscsspWhitespace();
    i.parsedCssText = t, i.parentStyleSheet = e, e.cssRules.push(i);
  },
  addComment: function addComment(e, t) {
    var i = new jscsspComment();
    i.parsedCssText = t, i.parentStyleSheet = e, e.cssRules.push(i);
  },
  parseCharsetRule: function parseCharsetRule(e) {
    var t = this.getToken(!1, !1);

    if (t.isAtRule("@charset") && "@charset" == t.value) {
      var i = t.value;
      if (t = this.getToken(!1, !1), i += t.value, t.isWhiteSpace(" ")) {
        if (t = this.getToken(!1, !1), i += t.value, t.isString()) {
          var n = t.value;

          if (t = this.getToken(!1, !1), i += t.value, t.isSymbol(";")) {
            var s = new jscsspCharsetRule();
            return s.encoding = n, s.parsedCssText = i, s.parentStyleSheet = e, e.cssRules.push(s), !0;
          }

          this.reportError(kCHARSET_RULE_MISSING_SEMICOLON);
        } else this.reportError(kCHARSET_RULE_CHARSET_IS_STRING);
      } else this.reportError(kCHARSET_RULE_MISSING_WS);
    }

    return this.addUnknownAtRule(e, i), !1;
  },
  parseImportRule: function parseImportRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value;
    this.preserveState();
    var s = this.getToken(!0, !0),
        r = [],
        o = "";
    if (s.isString()) o = s.value, n += " " + o;else if (s.isFunction("url(")) {
      s = this.getToken(!0, !0);
      var a = this.parseURL(s);
      a && (o = "url(" + a, n += " " + o);
    } else this.reportError(kIMPORT_RULE_MISSING_URL);

    if (o) {
      for (s = this.getToken(!0, !0); s.isIdent() && (n += " " + s.value, r.push(s.value), s = this.getToken(!0, !0));) {
        if (!s.isSymbol(",")) {
          if (s.isSymbol(";")) break;
          break;
        }

        n += ",", s = this.getToken(!0, !0);
      }

      if (r.length || r.push("all"), s.isSymbol(";")) {
        n += ";", this.forgetState();
        var l = new jscsspImportRule();
        return l.currentLine = i, l.parsedCssText = n, l.href = o, l.media = r, l.parentStyleSheet = t, t.cssRules.push(l), !0;
      }
    }

    return this.restoreState(), this.addUnknownAtRule(t, "@import"), !1;
  },
  parseVariablesRule: function parseVariablesRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value,
        s = [],
        r = !1;
    this.preserveState(), e = this.getToken(!0, !0);

    for (var o = [], a = !1; e.isNotNull();) {
      if (e.isIdent()) {
        if (a = !0, n += " " + e.value, o.push(e.value), e = this.getToken(!0, !0), e.isSymbol(",")) n += ",";else {
          if (!e.isSymbol("{")) {
            e.type = jscsspToken.NULL_TYPE;
            break;
          }

          this.ungetToken();
        }
      } else {
        if (e.isSymbol("{")) break;

        if (a) {
          e.type = jscsspToken.NULL_TYPE;
          break;
        }
      }
      e = this.getToken(!0, !0);
    }

    if (e.isSymbol("{")) for (n += " {", e = this.getToken(!0, !0);;) {
      if (!e.isNotNull()) {
        r = !0;
        break;
      }

      if (e.isSymbol("}")) {
        n += "}", r = !0;
        break;
      }

      var l = this.parseDeclaration(e, s, !0, !1, t);
      n += (l && s.length ? " " : "") + l, e = this.getToken(!0, !1);
    }

    if (r) {
      this.forgetState();
      var u = new jscsspVariablesRule();
      return u.currentLine = i, u.parsedCssText = n, u.declarations = s, u.media = o, u.parentStyleSheet = t, t.cssRules.push(u), !0;
    }

    return this.restoreState(), !1;
  },
  parseNamespaceRule: function parseNamespaceRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value;
    this.preserveState();
    var s = this.getToken(!0, !0);

    if (s.isNotNull()) {
      var r = "",
          o = "";

      if (s.isIdent() && (r = s.value, n += " " + r, s = this.getToken(!0, !0)), s) {
        var a = !1;
        if (s.isString()) a = !0, o = s.value, n += " " + o;else if (s.isFunction("url(")) {
          s = this.getToken(!0, !0);
          var l = this.parseURL(s);
          l && (o += "url(" + l, a = !0, n += " " + l);
        }
      }

      if (a && (s = this.getToken(!0, !0), s.isSymbol(";"))) {
        n += ";", this.forgetState();
        var u = new jscsspNamespaceRule();
        return u.currentLine = i, u.parsedCssText = n, u.prefix = r, u.url = o, u.parentStyleSheet = t, t.cssRules.push(u), !0;
      }
    }

    return this.restoreState(), this.addUnknownAtRule(t, "@namespace"), !1;
  },
  parseFontFaceRule: function parseFontFaceRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value,
        s = !1,
        r = [];
    this.preserveState();
    var o = this.getToken(!0, !0);

    if (o.isNotNull() && o.isSymbol("{")) {
      n += " " + o.value;

      for (var o = this.getToken(!0, !1);;) {
        if (o.isSymbol("}")) {
          n += "}", s = !0;
          break;
        }

        var a = this.parseDeclaration(o, r, !1, !1, t);
        n += (a && r.length ? " " : "") + a, o = this.getToken(!0, !1);
      }
    }

    if (s) {
      this.forgetState();
      var l = new jscsspFontFaceRule();
      return l.currentLine = i, l.parsedCssText = n, l.descriptors = r, l.parentStyleSheet = t, t.cssRules.push(l), !0;
    }

    return this.restoreState(), !1;
  },
  parsePageRule: function parsePageRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value,
        s = !1,
        r = [];
    this.preserveState();
    var o = this.getToken(!0, !0),
        a = "";

    if ((o.isSymbol(":") || o.isIdent()) && (o.isSymbol(":") && (a = ":", o = this.getToken(!1, !1)), o.isIdent() && (a += o.value, n += " " + a, o = this.getToken(!0, !0))), o.isNotNull() && o.isSymbol("{")) {
      n += " " + o.value;

      for (var o = this.getToken(!0, !1);;) {
        if (o.isSymbol("}")) {
          n += "}", s = !0;
          break;
        }

        var l = this.parseDeclaration(o, r, !0, !0, t);
        n += (l && r.length ? " " : "") + l, o = this.getToken(!0, !1);
      }
    }

    if (s) {
      this.forgetState();
      var u = new jscsspPageRule();
      return u.currentLine = i, u.parsedCssText = n, u.pageSelector = a, u.declarations = r, u.parentStyleSheet = t, t.cssRules.push(u), !0;
    }

    return this.restoreState(), !1;
  },
  parseDefaultPropertyValue: function parseDefaultPropertyValue(e, t, i, n, s) {
    for (var r = "", o = [], a = []; e.isNotNull();) {
      if ((e.isSymbol(";") || e.isSymbol("}") || e.isSymbol("!")) && !o.length) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (e.isIdent(this.kINHERIT)) {
        if (a.length) return "";
        r = this.kINHERIT;
        var l = new jscsspVariable(kJscsspINHERIT_VALUE, s);
        a.push(l), e = this.getToken(!0, !0);
        break;
      }

      if (e.isSymbol("{") || e.isSymbol("(") || e.isSymbol("[")) o.push(e.value);else if ((e.isSymbol("}") || e.isSymbol("]")) && o.length) {
        var u = o[o.length - 1];
        (e.isSymbol("}") && "{" == u || e.isSymbol(")") && "(" == u || e.isSymbol("]") && "[" == u) && o.pop();
      }
      if (e.isFunction()) {
        if (e.isFunction("var(")) {
          if (e = this.getToken(!0, !0), !e.isIdent()) return "";
          var c = e.value;
          if (e = this.getToken(!0, !0), !e.isSymbol(")")) return "";
          var l = new jscsspVariable(kJscsspVARIABLE_VALUE, s);
          r += "var(" + c + ")", l.name = c, a.push(l);
        } else {
          var d = e.value;
          e = this.getToken(!1, !0);
          var p = this.parseFunctionArgument(e);
          if (!p) return "";
          r += d + p;
          var l = new jscsspVariable(kJscsspPRIMITIVE_VALUE, s);
          l.value = d + p, a.push(l);
        }
      } else if (e.isSymbol("#")) {
        var h = this.parseColor(e);
        if (!h) return "";
        r += h;
        var l = new jscsspVariable(kJscsspPRIMITIVE_VALUE, s);
        l.value = h, a.push(l);
      } else if (e.isWhiteSpace() || e.isSymbol(",")) r += e.value;else {
        var l = new jscsspVariable(kJscsspPRIMITIVE_VALUE, s);
        l.value = e.value, a.push(l), r += e.value;
      }
      e = this.getToken(!1, !0);
    }

    return a.length && r ? (this.forgetState(), t.push(this._createJscsspDeclarationFromValuesArray(n, a, r)), r) : "";
  },
  parseMarginOrPaddingShorthand: function parseMarginOrPaddingShorthand(e, t, i, n) {
    for (var s = null, r = null, o = null, a = null, l = []; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (!l.length && e.isIdent(this.kINHERIT)) {
        l.push(e.value), e = this.getToken(!0, !0);
        break;
      }

      if (!(e.isDimension() || e.isNumber("0") || e.isPercentage() || e.isIdent("auto"))) return "";
      l.push(e.value), e = this.getToken(!0, !0);
    }

    switch (l.length) {
      case 1:
        s = l[0], r = s, o = s, a = s;
        break;

      case 2:
        s = l[0], r = s, o = l[1], a = o;
        break;

      case 3:
        s = l[0], o = l[1], a = o, r = l[2];
        break;

      case 4:
        s = l[0], a = l[1], r = l[2], o = l[3];
        break;

      default:
        return "";
    }

    return this.forgetState(), t.push(this._createJscsspDeclarationFromValue(n + "-top", s)), t.push(this._createJscsspDeclarationFromValue(n + "-right", a)), t.push(this._createJscsspDeclarationFromValue(n + "-bottom", r)), t.push(this._createJscsspDeclarationFromValue(n + "-left", o)), s + " " + a + " " + r + " " + o;
  },
  parseBorderColorShorthand: function parseBorderColorShorthand(e, t, i) {
    for (var n = null, s = null, r = null, o = null, a = []; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (!a.length && e.isIdent(this.kINHERIT)) {
        a.push(e.value), e = this.getToken(!0, !0);
        break;
      }

      var l = this.parseColor(e);
      if (!l) return "";
      a.push(l), e = this.getToken(!0, !0);
    }

    switch (a.length) {
      case 1:
        n = a[0], s = n, r = n, o = n;
        break;

      case 2:
        n = a[0], s = n, r = a[1], o = r;
        break;

      case 3:
        n = a[0], r = a[1], o = r, s = a[2];
        break;

      case 4:
        n = a[0], o = a[1], s = a[2], r = a[3];
        break;

      default:
        return "";
    }

    return this.forgetState(), t.push(this._createJscsspDeclarationFromValue("border-top-color", n)), t.push(this._createJscsspDeclarationFromValue("border-right-color", o)), t.push(this._createJscsspDeclarationFromValue("border-bottom-color", s)), t.push(this._createJscsspDeclarationFromValue("border-left-color", r)), n + " " + o + " " + s + " " + r;
  },
  parseCueShorthand: function parseCueShorthand(e, t, i) {
    for (var n = "", s = "", r = [], r = []; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (!r.length && e.isIdent(this.kINHERIT)) r.push(e.value);else if (e.isIdent("none")) r.push(e.value);else {
        if (!e.isFunction("url(")) return "";
        e = this.getToken(!0, !0);
        var o = this.parseURL(e);
        if (!o) return "";
        r.push("url(" + o);
      }
      e = this.getToken(!0, !0);
    }

    switch (r.length) {
      case 1:
        n = r[0], s = n;
        break;

      case 2:
        n = r[0], s = r[1];
        break;

      default:
        return "";
    }

    return this.forgetState(), aDecl.push(this._createJscsspDeclarationFromValue("cue-before", n)), aDecl.push(this._createJscsspDeclarationFromValue("cue-after", s)), n + " " + s;
  },
  parsePauseShorthand: function parsePauseShorthand(e, t, i) {
    for (var n = "", s = "", r = [], r = []; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (!r.length && e.isIdent(this.kINHERIT)) r.push(e.value);else {
        if (!(e.isDimensionOfUnit("ms") || e.isDimensionOfUnit("s") || e.isPercentage() || e.isNumber("0"))) return "";
        r.push(e.value);
      }
      e = this.getToken(!0, !0);
    }

    switch (r.length) {
      case 1:
        n = r[0], s = n;
        break;

      case 2:
        n = r[0], s = r[1];
        break;

      default:
        return "";
    }

    return this.forgetState(), aDecl.push(this._createJscsspDeclarationFromValue("pause-before", n)), aDecl.push(this._createJscsspDeclarationFromValue("pause-after", s)), n + " " + s;
  },
  parseBorderWidthShorthand: function parseBorderWidthShorthand(e, t, i) {
    for (var n = null, s = null, r = null, o = null, a = []; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (!a.length && e.isIdent(this.kINHERIT)) a.push(e.value);else {
        if (!(e.isDimension() || e.isNumber("0") || e.isIdent() && e.value in this.kBORDER_WIDTH_NAMES)) return "";
        a.push(e.value);
      }
      e = this.getToken(!0, !0);
    }

    switch (a.length) {
      case 1:
        n = a[0], s = n, r = n, o = n;
        break;

      case 2:
        n = a[0], s = n, r = a[1], o = r;
        break;

      case 3:
        n = a[0], r = a[1], o = r, s = a[2];
        break;

      case 4:
        n = a[0], o = a[1], s = a[2], r = a[3];
        break;

      default:
        return "";
    }

    return this.forgetState(), t.push(this._createJscsspDeclarationFromValue("border-top-width", n)), t.push(this._createJscsspDeclarationFromValue("border-right-width", o)), t.push(this._createJscsspDeclarationFromValue("border-bottom-width", s)), t.push(this._createJscsspDeclarationFromValue("border-left-width", r)), n + " " + o + " " + s + " " + r;
  },
  parseBorderStyleShorthand: function parseBorderStyleShorthand(e, t, i) {
    for (var n = null, s = null, r = null, o = null, a = []; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (!a.length && e.isIdent(this.kINHERIT)) a.push(e.value);else {
        if (!(e.isIdent() && e.value in this.kBORDER_STYLE_NAMES)) return "";
        a.push(e.value);
      }
      e = this.getToken(!0, !0);
    }

    switch (a.length) {
      case 1:
        n = a[0], s = n, r = n, o = n;
        break;

      case 2:
        n = a[0], s = n, r = a[1], o = r;
        break;

      case 3:
        n = a[0], r = a[1], o = r, s = a[2];
        break;

      case 4:
        n = a[0], o = a[1], s = a[2], r = a[3];
        break;

      default:
        return "";
    }

    return this.forgetState(), t.push(this._createJscsspDeclarationFromValue("border-top-style", n)), t.push(this._createJscsspDeclarationFromValue("border-right-style", o)), t.push(this._createJscsspDeclarationFromValue("border-bottom-style", s)), t.push(this._createJscsspDeclarationFromValue("border-left-style", r)), n + " " + o + " " + s + " " + r;
  },
  parseBorderEdgeOrOutlineShorthand: function parseBorderEdgeOrOutlineShorthand(e, t, i, n) {
    function s(e, t, i, n, s, r) {
      t.push(e._createJscsspDeclarationFromValue(i + "-width", n)), t.push(e._createJscsspDeclarationFromValue(i + "-style", s)), t.push(e._createJscsspDeclarationFromValue(i + "-color", r));
    }

    for (var r = null, o = null, a = null; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (r || o || a || !e.isIdent(this.kINHERIT)) {
        if (!r && (e.isDimension() || e.isIdent() && e.value in this.kBORDER_WIDTH_NAMES || e.isNumber("0"))) r = e.value;else if (!o && e.isIdent() && e.value in this.kBORDER_STYLE_NAMES) o = e.value;else {
          var l = "outline" == n && e.isIdent("invert") ? "invert" : this.parseColor(e);
          if (a || !l) return "";
          a = l;
        }
      } else r = this.kINHERIT, o = this.kINHERIT, a = this.kINHERIT;
      e = this.getToken(!0, !0);
    }

    return this.forgetState(), r = r || "medium", o = o || "none", a = a || "-moz-initial", "border" == n ? (s(this, t, "border-top", r, o, a), s(this, t, "border-right", r, o, a), s(this, t, "border-bottom", r, o, a), s(this, t, "border-left", r, o, a)) : s(this, t, n, r, o, a), r + " " + o + " " + a;
  },
  parseBackgroundShorthand: function parseBackgroundShorthand(e, t, i) {
    for (var n = {
      left: !0,
      right: !0
    }, s = {
      top: !0,
      bottom: !0
    }, r = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0,
      center: !0
    }, o = null, a = null, l = null, u = null, c = null; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (o || a || l || u || c || !e.isIdent(this.kINHERIT)) {
        if (l || !e.isIdent("scroll") && !e.isIdent("fixed")) {
          if (!c && (e.isIdent() && e.value in r || e.isDimension() || e.isNumber("0") || e.isPercentage())) {
            if (c = e.value, e = this.getToken(!0, !0), e.isDimension() || e.isNumber("0") || e.isPercentage()) c += " " + e.value;else if (e.isIdent() && e.value in r) {
              if (c in n && e.value in n || c in s && e.value in s) return "";
              c += " " + e.value;
            } else this.ungetToken(), c += " center";
          } else if (!a && (e.isIdent("repeat") || e.isIdent("repeat-x") || e.isIdent("repeat-y") || e.isIdent("no-repeat"))) a = e.value;else if (u || !e.isFunction("url(") && !e.isIdent("none")) {
            if (!u && (e.isFunction("linear-gradient(") || e.isFunction("radial-gradient(") || e.isFunction("repeating-linear-gradient(") || e.isFunction("repeating-radial-gradient("))) {
              this.ungetToken();
              var d = this.parseGradient();
              if (!d) return "";
              u = this.serializeGradient(d);
            } else {
              var p = this.parseColor(e);
              if (o || !p) return "";
              o = p;
            }
          } else if (u = e.value, e.isFunction("url(")) {
            e = this.getToken(!0, !0);
            var h = this.parseURL(e);
            if (!h) return "";
            u += h;
          }
        } else l = e.value;
      } else o = this.kINHERIT, a = this.kINHERIT, l = this.kINHERIT, u = this.kINHERIT, c = this.kINHERIT;
      e = this.getToken(!0, !0);
    }

    return this.forgetState(), o = o || "transparent", u = u || "none", a = a || "repeat", l = l || "scroll", c = c || "top left", t.push(this._createJscsspDeclarationFromValue("background-color", o)), t.push(this._createJscsspDeclarationFromValue("background-image", u)), t.push(this._createJscsspDeclarationFromValue("background-repeat", a)), t.push(this._createJscsspDeclarationFromValue("background-attachment", l)), t.push(this._createJscsspDeclarationFromValue("background-position", c)), o + " " + u + " " + a + " " + l + " " + c;
  },
  parseListStyleShorthand: function parseListStyleShorthand(e, t, i) {
    for (var n = {
      inside: !0,
      outside: !0
    }, s = null, r = null, o = null; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (s || r || o || !e.isIdent(this.kINHERIT)) {
        if (!s && e.isIdent() && e.value in this.kLIST_STYLE_TYPE_NAMES) s = e.value;else if (!r && e.isIdent() && e.value in n) r = e.value;else if (!o && e.isFunction("url")) {
          e = this.getToken(!0, !0);
          var a = this.parseURL(e);
          if (!a) return "";
          o = "url(" + a;
        } else if (!e.isIdent("none")) return "";
      } else s = this.kINHERIT, r = this.kINHERIT, o = this.kINHERIT;

      e = this.getToken(!0, !0);
    }

    return this.forgetState(), s = s || "none", o = o || "none", r = r || "outside", t.push(this._createJscsspDeclarationFromValue("list-style-type", s)), t.push(this._createJscsspDeclarationFromValue("list-style-position", r)), t.push(this._createJscsspDeclarationFromValue("list-style-image", o)), s + " " + r + " " + o;
  },
  parseFontShorthand: function parseFontShorthand(e, t, i) {
    for (var n = {
      italic: !0,
      oblique: !0
    }, s = {
      "small-caps": !0
    }, r = {
      bold: !0,
      bolder: !0,
      lighter: !0,
      100: !0,
      200: !0,
      300: !0,
      400: !0,
      500: !0,
      600: !0,
      700: !0,
      800: !0,
      900: !0
    }, o = {
      "xx-small": !0,
      "x-small": !0,
      small: !0,
      medium: !0,
      large: !0,
      "x-large": !0,
      "xx-large": !0,
      larger: !0,
      smaller: !0
    }, a = {
      caption: !0,
      icon: !0,
      menu: !0,
      "message-box": !0,
      "small-caption": !0,
      "status-bar": !0
    }, l = {
      serif: !0,
      "sans-serif": !0,
      cursive: !0,
      fantasy: !0,
      monospace: !0
    }, u = null, c = null, d = null, p = null, h = null, f = "", m = null, g = [], b = 0; e.isNotNull();) {
      if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
        e.isSymbol("}") && this.ungetToken();
        break;
      }

      if (u || c || d || p || h || f || m || !e.isIdent(this.kINHERIT)) {
        if (!m && e.isIdent() && e.value in a) {
          m = e.value;
          break;
        }

        if (!u && e.isIdent() && e.value in n) u = e.value;else if (!c && e.isIdent() && e.value in s) c = e.value;else if (!d && (e.isIdent() || e.isNumber()) && e.value in r) d = e.value;else if (!p && (e.isIdent() && e.value in o || e.isDimension() || e.isPercentage())) {
          if (p = e.value, e = this.getToken(!1, !1), e.isSymbol("/")) {
            if (e = this.getToken(!1, !1), h || !(e.isDimension() || e.isNumber() || e.isPercentage())) return "";
            h = e.value;
          } else if (!e.isWhiteSpace()) continue;
        } else if (e.isIdent("normal")) {
          if (++b > 3) return "";
        } else {
          if (f || !e.isString() && !e.isIdent()) return "";

          for (var v = !1; e.isNotNull();) {
            if (e.isSymbol(";") || i && e.isSymbol("!") || e.isSymbol("}")) {
              this.ungetToken();
              break;
            }

            if (e.isIdent() && e.value in l) {
              var k = new jscsspVariable(kJscsspPRIMITIVE_VALUE, null);
              k.value = e.value, g.push(k), f += e.value;
              break;
            }

            if (e.isString() || e.isIdent()) {
              var k = new jscsspVariable(kJscsspPRIMITIVE_VALUE, null);
              k.value = e.value, g.push(k), f += e.value, v = !1;
            } else {
              if (v || !e.isSymbol(",")) return "";
              f += ", ", v = !0;
            }

            e = this.getToken(!0, !0);
          }
        }
      } else u = this.kINHERIT, c = this.kINHERIT, d = this.kINHERIT, p = this.kINHERIT, h = this.kINHERIT, f = this.kINHERIT, m = this.kINHERIT;

      e = this.getToken(!0, !0);
    }

    return this.forgetState(), m ? (t.push(this._createJscsspDeclarationFromValue("font", m)), m) : (u = u || "normal", c = c || "normal", d = d || "normal", p = p || "medium", h = h || "normal", f = f || "-moz-initial", t.push(this._createJscsspDeclarationFromValue("font-style", u)), t.push(this._createJscsspDeclarationFromValue("font-variant", c)), t.push(this._createJscsspDeclarationFromValue("font-weight", d)), t.push(this._createJscsspDeclarationFromValue("font-size", p)), t.push(this._createJscsspDeclarationFromValue("line-height", h)), t.push(this._createJscsspDeclarationFromValuesArray("font-family", g, f)), u + " " + c + " " + d + " " + p + "/" + h + " " + f);
  },
  _createJscsspDeclaration: function _createJscsspDeclaration(e, t) {
    var i = new jscsspDeclaration();
    return i.property = e, i.value = this.trim11(t), i.parsedCssText = e + ": " + t + ";", i;
  },
  _createJscsspDeclarationFromValue: function _createJscsspDeclarationFromValue(e, t) {
    var i = new jscsspDeclaration();
    i.property = e;
    var n = new jscsspVariable(kJscsspPRIMITIVE_VALUE, null);
    return n.value = t, i.values = [n], i.valueText = t, i.parsedCssText = e + ": " + t + ";", i;
  },
  _createJscsspDeclarationFromValuesArray: function _createJscsspDeclarationFromValuesArray(e, t, i) {
    var n = new jscsspDeclaration();
    return n.property = e, n.values = t, n.valueText = i, n.parsedCssText = e + ": " + i + ";", n;
  },
  parseURL: function parseURL(e) {
    var t = "";
    if (e.isString()) t += e.value, e = this.getToken(!0, !0);else for (;;) {
      if (!e.isNotNull()) return this.reportError(kURL_EOF), "";

      if (e.isWhiteSpace() && (nextToken = this.lookAhead(!0, !0), !nextToken.isSymbol(")"))) {
        this.reportError(kURL_WS_INSIDE), e = this.currentToken();
        break;
      }

      if (e.isSymbol(")")) break;
      t += e.value, e = this.getToken(!1, !1);
    }
    return e.isSymbol(")") ? t + ")" : "";
  },
  parseFunctionArgument: function parseFunctionArgument(e) {
    var t = "";
    if (e.isString()) t += e.value, e = this.getToken(!0, !0);else for (var i = 1;;) {
      if (!e.isNotNull()) return "";
      if ((e.isFunction() || e.isSymbol("(")) && i++, e.isSymbol(")") && ! --i) break;
      t += e.value, e = this.getToken(!1, !1);
    }
    return e.isSymbol(")") ? t + ")" : "";
  },
  parseColor: function parseColor(e) {
    var t = "";

    if (e.isFunction("rgb(") || e.isFunction("rgba(")) {
      t = e.value;
      var i = e.isFunction("rgba(");
      if (e = this.getToken(!0, !0), !e.isNumber() && !e.isPercentage()) return "";
      if (t += e.value, e = this.getToken(!0, !0), !e.isSymbol(",")) return "";
      if (t += ", ", e = this.getToken(!0, !0), !e.isNumber() && !e.isPercentage()) return "";
      if (t += e.value, e = this.getToken(!0, !0), !e.isSymbol(",")) return "";
      if (t += ", ", e = this.getToken(!0, !0), !e.isNumber() && !e.isPercentage()) return "";

      if (t += e.value, i) {
        if (e = this.getToken(!0, !0), !e.isSymbol(",")) return "";
        if (t += ", ", e = this.getToken(!0, !0), !e.isNumber()) return "";
        t += e.value;
      }

      if (e = this.getToken(!0, !0), !e.isSymbol(")")) return "";
      t += e.value;
    } else if (e.isFunction("hsl(") || e.isFunction("hsla(")) {
      t = e.value;
      var n = e.isFunction("hsla(");
      if (e = this.getToken(!0, !0), !e.isNumber()) return "";
      if (t += e.value, e = this.getToken(!0, !0), !e.isSymbol(",")) return "";
      if (t += ", ", e = this.getToken(!0, !0), !e.isPercentage()) return "";
      if (t += e.value, e = this.getToken(!0, !0), !e.isSymbol(",")) return "";
      if (t += ", ", e = this.getToken(!0, !0), !e.isPercentage()) return "";

      if (t += e.value, n) {
        if (e = this.getToken(!0, !0), !e.isSymbol(",")) return "";
        if (t += ", ", e = this.getToken(!0, !0), !e.isNumber()) return "";
        t += e.value;
      }

      if (e = this.getToken(!0, !0), !e.isSymbol(")")) return "";
      t += e.value;
    } else if (e.isIdent() && e.value in this.kCOLOR_NAMES) t = e.value;else if (e.isSymbol("#")) {
      if (e = this.getHexValue(), !e.isHex()) return "";
      var s = e.value.length;
      if (3 != s && 6 != s) return "";
      if (e.value.match(/[a-fA-F0-9]/g).length != s) return "";
      t = "#" + e.value;
    }

    return t;
  },
  parseColorStop: function parseColorStop(e) {
    var t = this.parseColor(e),
        i = "";
    return t ? (e = this.getToken(!0, !0), e.isLength() && (i = e.value, e = this.getToken(!0, !0)), {
      color: t,
      position: i
    }) : null;
  },
  parseGradient: function parseGradient() {
    var e = {
      left: !0,
      right: !0
    },
        t = {
      top: !0,
      bottom: !0
    },
        i = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0,
      center: !0
    },
        n = {
      isRepeating: !1
    },
        s = this.getToken(!0, !0);

    if (s.isNotNull() && (s.isFunction("linear-gradient(") || s.isFunction("radial-gradient(") || s.isFunction("repeating-linear-gradient(") || s.isFunction("repeating-radial-gradient("))) {
      (s.isFunction("radial-gradient(") || s.isFunction("repeating-radial-gradient(")) && (n.isRadial = !0), (s.isFunction("repeating-linear-gradient(") || s.isFunction("repeating-radial-gradient(")) && (n.isRepeating = !0), s = this.getToken(!0, !0);

      if (s.isAngle()) {
        if (n.angle = s.value, !0, s = this.getToken(!0, !0), !s.isSymbol(",")) return null;
        s = this.getToken(!0, !0);
      } else if (s.isIdent("to")) {
        if (!0, s = this.getToken(!0, !0), !(s.isIdent("top") || s.isIdent("bottom") || s.isIdent("left") || s.isIdent("right"))) return null;
        if (n.position = s.value, s = this.getToken(!0, !0), (("top" == n.position || "bottom" == n.position) && (s.isIdent("left") || s.isIdent("right")) || ("left" == n.position || "right" == n.position) && (s.isIdent("top") || s.isIdent("bottom"))) && (n.position += " " + s.value, s = this.getToken(!0, !0)), !s.isSymbol(",")) return null;
        s = this.getToken(!0, !0);
      } else if (n.isRadial) {
        for (n.shape = "", n.extent = "", n.positions = [], n.at = ""; !s.isIdent("at") && !s.isSymbol(",");) {
          if (n.shape || !s.isIdent("circle") && !s.isIdent("ellipse")) {
            if (!n.extent && (s.isIdent("closest-corner") || s.isIdent("closes-side") || s.isIdent("farthest-corner") || s.isIdent("farthest-corner"))) n.extent = s.value, s = this.getToken(!0, !0);else {
              if (!(n.positions.length < 2 && s.isLength())) break;
              n.positions.push(s.value), s = this.getToken(!0, !0);
            }
          } else n.shape = s.value, s = this.getToken(!0, !0);
        }

        if ((1 != n.positions.length || n.extent || "circle" != n.shape && n.shape) && (2 != n.positions.length || n.extent || "ellipse" != n.shape && n.shape) && (n.positions.length || !n.extent) && (n.positions.length || n.extent)) return null;

        if (s.isIdent("at")) {
          if (s = this.getToken(!0, !0), !(s.isIdent() && s.value in i || s.isDimension() || s.isNumber("0") || s.isPercentage())) return null;
          if (n.at = s.value, s = this.getToken(!0, !0), s.isDimension() || s.isNumber("0") || s.isPercentage()) n.at += " " + s.value;else if (s.isIdent() && s.value in i) {
            if (n.at in e && s.value in e || n.at in t && s.value in t) return "";
            n.at += " " + s.value;
          } else this.ungetToken(), n.at += " center";
          s = this.getToken(!0, !0);
        }

        if (n.shape || n.extent || n.positions.length || n.at) {
          if (!s.isSymbol(",")) return null;
          s = this.getToken(!0, !0);
        }
      }

      var r = this.parseColorStop(s);
      if (!r) return null;
      if (s = this.currentToken(), !s.isSymbol(",")) return null;
      s = this.getToken(!0, !0);
      var o = this.parseColorStop(s);
      if (!o) return null;

      for (s = this.currentToken(), s.isSymbol(",") && (s = this.getToken(!0, !0)), n.stops = [r, o]; !s.isSymbol(")");) {
        var a = this.parseColorStop(s);
        if (!a) return null;
        if (s = this.currentToken(), !s.isSymbol(")") && !s.isSymbol(",")) return null;
        s.isSymbol(",") && (s = this.getToken(!0, !0)), n.stops.push(a);
      }

      return n;
    }

    return null;
  },
  serializeGradient: function serializeGradient(e) {
    var t = e.isRadial ? e.isRepeating ? "repeating-radial-gradient(" : "radial-gradient(" : e.isRepeating ? "repeating-linear-gradient(" : "linear-gradient(";
    (e.angle || e.position) && (t += (e.angle ? e.angle : "") + (e.position ? "to " + e.position : "") + ", "), e.isRadial && (t += (e.shape ? e.shape + " " : "") + (e.extent ? e.extent + " " : "") + (e.positions.length ? e.positions.join(" ") + " " : "") + (e.at ? "at " + e.at + " " : "") + (e.shape || e.extent || e.positions.length || e.at ? ", " : ""));

    for (var i = 0; i < e.stops.length; i++) {
      var n = e.stops[i];
      t += n.color + (n.position ? " " + n.position : ""), i != e.stops.length - 1 && (t += ", ");
    }

    return t += ")";
  },
  parseTextShadows: function parseTextShadows() {
    for (var e = [], t = this.getToken(!0, !0), i = "", n = "0px", s = "0px", r = "0px"; t.isNotNull();) {
      if (t.isIdent("none")) e.push({
        none: !0
      }), t = this.getToken(!0, !0);else {
        if (t.isFunction("rgb(") || t.isFunction("rgba(") || t.isFunction("hsl(") || t.isFunction("hsla(") || t.isSymbol("#") || t.isIdent()) {
          var i = this.parseColor(t);
          t = this.getToken(!0, !0);
        }

        if (!(t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt"))) return [];
        var s = t.value;
        if (t = this.getToken(!0, !0), !(t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt"))) return [];
        var r = t.value;

        if (t = this.getToken(!0, !0), t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt")) {
          var n = t.value;
          t = this.getToken(!0, !0);
        }

        if (!i && (t.isFunction("rgb(") || t.isFunction("rgba(") || t.isFunction("hsl(") || t.isFunction("hsla(") || t.isSymbol("#") || t.isIdent())) {
          var i = this.parseColor(t);
          t = this.getToken(!0, !0);
        }

        if (e.push({
          none: !1,
          color: i,
          offsetX: s,
          offsetY: r,
          blurRadius: n
        }), !t.isSymbol(",")) return t.isNotNull() ? [] : e;
        i = "", n = "0px", s = "0px", r = "0px", t = this.getToken(!0, !0);
      }
    }

    return e;
  },
  parseBoxShadows: function parseBoxShadows() {
    for (var e = [], t = this.getToken(!0, !0), i = "", n = "0px", s = "0px", r = "0px", o = "0px", a = !1; t.isNotNull();) {
      if (t.isIdent("none")) e.push({
        none: !0
      }), t = this.getToken(!0, !0);else {
        if (t.isIdent("inset") && (a = !0, t = this.getToken(!0, !0)), !(t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt"))) return [];
        var s = t.value;
        if (t = this.getToken(!0, !0), !a && t.isIdent("inset") && (a = !0, t = this.getToken(!0, !0)), !(t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt"))) return [];
        var r = t.value;

        if (t = this.getToken(!0, !0), !a && t.isIdent("inset") && (a = !0, t = this.getToken(!0, !0)), t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt")) {
          var n = t.value;
          t = this.getToken(!0, !0);
        }

        if (!a && t.isIdent("inset") && (a = !0, t = this.getToken(!0, !0)), t.isPercentage() || t.isDimensionOfUnit("cm") || t.isDimensionOfUnit("mm") || t.isDimensionOfUnit("in") || t.isDimensionOfUnit("pc") || t.isDimensionOfUnit("px") || t.isDimensionOfUnit("em") || t.isDimensionOfUnit("ex") || t.isDimensionOfUnit("pt")) {
          var o = t.value;
          t = this.getToken(!0, !0);
        }

        if (!a && t.isIdent("inset") && (a = !0, t = this.getToken(!0, !0)), t.isFunction("rgb(") || t.isFunction("rgba(") || t.isFunction("hsl(") || t.isFunction("hsla(") || t.isSymbol("#") || t.isIdent()) {
          var i = this.parseColor(t);
          t = this.getToken(!0, !0);
        }

        if (!a && t.isIdent("inset") && (a = !0, t = this.getToken(!0, !0)), e.push({
          none: !1,
          color: i,
          offsetX: s,
          offsetY: r,
          blurRadius: n,
          spreadRadius: o,
          inset: a
        }), !t.isSymbol(",")) return t.isNotNull() ? [] : e;
        a = !1, i = "", n = "0px", o = "0px", s = "0px", r = "0px", t = this.getToken(!0, !0);
      }
    }

    return e;
  },
  parseBorderImage: function parseBorderImage() {
    var e = {
      url: "",
      offsets: [],
      widths: [],
      sizes: []
    },
        t = this.getToken(!0, !0);
    if (!t.isFunction("url(")) return null;
    t = this.getToken(!0, !0);
    var i = this.parseURL(t);
    if (!i) return null;
    if (e.url = i.substr(0, i.length - 1).trim(), ('"' == e.url[0] && '"' == e.url[e.url.length - 1] || "'" == e.url[0] && "'" == e.url[e.url.length - 1]) && (e.url = e.url.substr(1, e.url.length - 2)), t = this.getToken(!0, !0), !t.isNumber() && !t.isPercentage()) return null;
    e.offsets.push(t.value);
    var n;

    for (n = 0; 3 > n && (t = this.getToken(!0, !0), t.isNumber() || t.isPercentage()); n++) {
      e.offsets.push(t.value);
    }

    if (3 == n && (t = this.getToken(!0, !0)), t.isSymbol("/")) {
      if (t = this.getToken(!0, !0), !(t.isDimension() || t.isNumber("0") || t.isIdent() && t.value in this.kBORDER_WIDTH_NAMES)) return null;
      e.widths.push(t.value);

      for (var n = 0; 3 > n && (t = this.getToken(!0, !0), t.isDimension() || t.isNumber("0") || t.isIdent() && t.value in this.kBORDER_WIDTH_NAMES); n++) {
        e.widths.push(t.value);
      }

      3 == n && (t = this.getToken(!0, !0));
    }

    for (var n = 0; 2 > n; n++) {
      if (!(t.isIdent("stretch") || t.isIdent("repeat") || t.isIdent("round"))) return t.isNotNull() ? null : e;
      e.sizes.push(t.value), t = this.getToken(!0, !0);
    }

    return t.isNotNull() ? null : e;
  },
  parseBackgroundImages: function parseBackgroundImages() {
    for (var e = [], t = this.getToken(!0, !0); t.isNotNull();) {
      if (t.isFunction("url(")) {
        t = this.getToken(!0, !0);
        var i = this.parseURL(t);
        e.push({
          type: "image",
          value: "url(" + i
        }), t = this.getToken(!0, !0);
      } else if (t.isFunction("linear-gradient(") || t.isFunction("radial-gradient(") || t.isFunction("repeating-linear-gradient(") || t.isFunction("repeating-radial-gradient(")) {
        this.ungetToken();
        var n = this.parseGradient();
        if (!n) return null;
        e.push({
          type: n.isRadial ? "radial-gradient" : "linear-gradient",
          value: n
        }), t = this.getToken(!0, !0);
      } else {
        if (!(t.isIdent("none") || t.isIdent("inherit") || t.isIdent("initial"))) return null;
        e.push({
          type: t.value
        }), t = this.getToken(!0, !0);
      }

      if (t.isSymbol(",") && (t = this.getToken(!0, !0), !t.isNotNull())) return null;
    }

    return e;
  },
  parseDeclaration: function parseDeclaration(e, t, i, n, s) {
    this.preserveState();
    var r = [];

    if (e.isIdent()) {
      var o = e.value.toLowerCase(),
          a = this.getToken(!0, !0);

      if (a.isSymbol(":")) {
        var a = this.getToken(!0, !0),
            l = "",
            u = [];
        if (n) switch (o) {
          case "background":
            l = this.parseBackgroundShorthand(a, u, i);
            break;

          case "margin":
          case "padding":
            l = this.parseMarginOrPaddingShorthand(a, u, i, o);
            break;

          case "border-color":
            l = this.parseBorderColorShorthand(a, u, i);
            break;

          case "border-style":
            l = this.parseBorderStyleShorthand(a, u, i);
            break;

          case "border-width":
            l = this.parseBorderWidthShorthand(a, u, i);
            break;

          case "border-top":
          case "border-right":
          case "border-bottom":
          case "border-left":
          case "border":
          case "outline":
            l = this.parseBorderEdgeOrOutlineShorthand(a, u, i, o);
            break;

          case "cue":
            l = this.parseCueShorthand(a, u, i);
            break;

          case "pause":
            l = this.parsePauseShorthand(a, u, i);
            break;

          case "font":
            l = this.parseFontShorthand(a, u, i);
            break;

          case "list-style":
            l = this.parseListStyleShorthand(a, u, i);
            break;

          default:
            l = this.parseDefaultPropertyValue(a, u, i, o, s);
        } else l = this.parseDefaultPropertyValue(a, u, i, o, s);

        if (a = this.currentToken(), l) {
          var c = !1;

          if (a.isSymbol("!")) {
            if (a = this.getToken(!0, !0), !a.isIdent("important")) return "";
            if (c = !0, a = this.getToken(!0, !0), !a.isSymbol(";") && !a.isSymbol("}")) return "";
            a.isSymbol("}") && this.ungetToken();
          } else if (a.isNotNull() && !a.isSymbol(";") && !a.isSymbol("}")) return "";

          for (var d = 0; d < u.length; d++) {
            u[d].priority = c, t.push(u[d]);
          }

          return o + ": " + l + ";";
        }
      }
    } else if (e.isComment()) {
      if (this.mPreserveComments) {
        this.forgetState();
        var p = new jscsspComment();
        p.parsedCssText = e.value, t.push(p);
      }

      return e.value;
    }

    this.restoreState();
    var h = e.value;
    r = [];

    for (var a = this.getToken(!1, !1); a.isNotNull();) {
      if (h += a.value, (a.isSymbol(";") || a.isSymbol("}")) && !r.length) {
        a.isSymbol("}") && this.ungetToken();
        break;
      }

      if (a.isSymbol("{") || a.isSymbol("(") || a.isSymbol("[") || a.isFunction()) r.push(a.isFunction() ? "(" : a.value);else if ((a.isSymbol("}") || a.isSymbol(")") || a.isSymbol("]")) && r.length) {
        var f = r[r.length - 1];
        (a.isSymbol("}") && "{" == f || a.isSymbol(")") && "(" == f || a.isSymbol("]") && "[" == f) && r.pop();
      }
      a = this.getToken(!1, !1);
    }

    return "";
  },
  parseKeyframesRule: function parseKeyframesRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value,
        s = !1,
        r = new jscsspKeyframesRule();
    r.currentLine = i, this.preserveState();

    for (var o = this.getToken(!0, !0), a = !1; o.isNotNull();) {
      if (!o.isIdent()) {
        if (o.isSymbol("{")) {
          a || (o.type = jscsspToken.NULL_TYPE);
          break;
        }

        o.type = jscsspToken.NULL_TYPE;
        break;
      }

      if (a = !0, n += " " + o.value, r.name = o.value, o = this.getToken(!0, !0), !o.isSymbol("{")) {
        o.type = jscsspToken.NULL_TYPE;
        break;
      }

      this.ungetToken(), o = this.getToken(!0, !0);
    }

    if (o.isSymbol("{") && r.name) for (n += " { ", o = this.getToken(!0, !1); o.isNotNull();) {
      if (o.isComment() && this.mPreserveComments) {
        n += " " + o.value;
        var l = new jscsspComment();
        l.parsedCssText = o.value, r.cssRules.push(l);
      } else {
        if (o.isSymbol("}")) {
          s = !0;
          break;
        }

        var u = this.parseKeyframeRule(o, r, !0);
        u && (n += u);
      }

      o = this.getToken(!0, !1);
    }
    return s ? (this.forgetState(), r.currentLine = i, r.parsedCssText = n, t.cssRules.push(r), !0) : (this.restoreState(), !1);
  },
  parseKeyframeRule: function parseKeyframeRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned());
    this.preserveState();

    for (var n = e, s = ""; n.isNotNull();) {
      if (!n.isIdent() && !n.isPercentage()) {
        s = "";
        break;
      }

      if (n.isIdent() && !n.isIdent("from") && !n.isIdent("to")) {
        s = "";
        break;
      }

      if (s += n.value, n = this.getToken(!0, !0), n.isSymbol("{")) {
        this.ungetToken();
        break;
      }

      if (!n.isSymbol(",")) {
        s = "";
        break;
      }

      s += ", ", n = this.getToken(!0, !0);
    }

    var r = !1,
        o = [];

    if (s) {
      var a = s;
      if (n = this.getToken(!0, !0), n.isSymbol("{")) for (a += " { ", n = this.getToken(!0, !1);;) {
        if (!n.isNotNull()) {
          r = !0;
          break;
        }

        if (n.isSymbol("}")) {
          a += "}", r = !0;
          break;
        }

        var l = this.parseDeclaration(n, o, !0, !0, t);
        a += (l && o.length ? " " : "") + l, n = this.getToken(!0, !1);
      }
    }

    if (r) {
      var u = new jscsspKeyframeRule();
      return u.currentLine = i, u.parsedCssText = a, u.declarations = o, u.keyText = s, u.parentRule = t, t.cssRules.push(u), a;
    }

    return this.restoreState(), a = this.currentToken().value, this.addUnknownAtRule(t, a), "";
  },
  parseMediaQuery: function parseMediaQuery() {
    var e = {
      width: !0,
      "min-width": !0,
      "max-width": !0,
      height: !0,
      "min-height": !0,
      "max-height": !0,
      "device-width": !0,
      "min-device-width": !0,
      "max-device-width": !0,
      "device-height": !0,
      "min-device-height": !0,
      "max-device-height": !0,
      orientation: !0,
      "aspect-ratio": !0,
      "min-aspect-ratio": !0,
      "max-aspect-ratio": !0,
      "device-aspect-ratio": !0,
      "min-device-aspect-ratio": !0,
      "max-device-aspect-ratio": !0,
      color: !0,
      "min-color": !0,
      "max-color": !0,
      "color-index": !0,
      "min-color-index": !0,
      "max-color-index": !0,
      monochrome: !0,
      "min-monochrome": !0,
      "max-monochrome": !0,
      resolution: !0,
      "min-resolution": !0,
      "max-resolution": !0,
      scan: !0,
      grid: !0
    },
        t = {
      cssText: "",
      amplifier: "",
      medium: "",
      constraints: []
    },
        i = this.getToken(!0, !0);
    if (i.isIdent("all") || i.isIdent("aural") || i.isIdent("braille") || i.isIdent("handheld") || i.isIdent("print") || i.isIdent("projection") || i.isIdent("screen") || i.isIdent("tty") || i.isIdent("tv")) t.medium = i.value, t.cssText += i.value, i = this.getToken(!0, !0);else if (i.isIdent("not") || i.isIdent("only")) {
      if (t.amplifier = i.value.toLowerCase(), t.cssText += i.value.toLowerCase(), i = this.getToken(!0, !0), !(i.isIdent("all") || i.isIdent("aural") || i.isIdent("braille") || i.isIdent("handheld") || i.isIdent("print") || i.isIdent("projection") || i.isIdent("screen") || i.isIdent("tty") || i.isIdent("tv"))) return null;
      t.cssText += " " + i.value, t.medium = i.value, i = this.getToken(!0, !0);
    }

    if (t.medium) {
      if (!i.isNotNull()) return t;
      if (i.isIdent("and")) t.cssText += " and", i = this.getToken(!0, !0);else if (!i.isSymbol("{")) return null;
    }

    for (; i.isSymbol("(");) {
      if (i = this.getToken(!0, !0), !(i.isIdent() && i.value in e)) return null;
      var n = i.value;

      if (i = this.getToken(!0, !0), i.isSymbol(":")) {
        i = this.getToken(!0, !0);

        for (var s = []; !i.isSymbol(")");) {
          s.push(i.value), i = this.getToken(!0, !0);
        }

        if (!i.isSymbol(")")) return null;
        if (t.constraints.push({
          constraint: n,
          value: s
        }), t.cssText += " (" + n + ": " + s.join(" ") + ")", i = this.getToken(!0, !0), !i.isNotNull()) return t;
        if (i.isIdent("and")) t.cssText += " and", i = this.getToken(!0, !0);else if (!i.isSymbol("{")) return null;
      } else {
        if (!i.isSymbol(")")) return null;
        if (t.constraints.push({
          constraint: n,
          value: null
        }), t.cssText += " (" + n + ")", i = this.getToken(!0, !0), !i.isNotNull()) return t;
        if (!i.isIdent("and")) return null;
        t.cssText += " and", i = this.getToken(!0, !0);
      }
    }

    return t;
  },
  parseMediaRule: function parseMediaRule(e, t) {
    var i = CountLF(this.mScanner.getAlreadyScanned()),
        n = e.value,
        s = !1,
        r = new jscsspMediaRule();
    r.currentLine = i, this.preserveState();

    for (var o = this.getToken(!0, !0), a = !1; o.isNotNull();) {
      this.ungetToken();
      var l = this.parseMediaQuery();

      if (o = this.currentToken(), l) {
        if (a = !0, n += " " + l.cssText, r.media.push(l.cssText), !o.isSymbol(",")) {
          if (o.isSymbol("{")) break;
          o.type = jscsspToken.NULL_TYPE;
          break;
        }

        n += ",";
      } else {
        if (o.isSymbol("{")) break;

        if (a) {
          o.type = jscsspToken.NULL_TYPE;
          break;
        }
      }

      o = this.getToken(!0, !0);
    }

    if (o.isSymbol("{") && r.media.length) for (n += " { ", o = this.getToken(!0, !1); o.isNotNull();) {
      if (o.isComment()) {
        if (this.mPreserveComments) {
          n += " " + o.value;
          var u = new jscsspComment();
          u.parsedCssText = o.value, r.cssRules.push(u);
        }
      } else {
        if (o.isSymbol("}")) {
          s = !0;
          break;
        }

        var c = this.parseStyleRule(o, r, !0);
        c && (n += c);
      }

      o = this.getToken(!0, !1);
    }
    return s ? (this.forgetState(), r.parsedCssText = n, t.cssRules.push(r), !0) : (this.restoreState(), !1);
  },
  trim11: function trim11(e) {
    e = e.replace(/^\s+/, "");

    for (var t = e.length - 1; t >= 0; t--) {
      if (/\S/.test(e.charAt(t))) {
        e = e.substring(0, t + 1);
        break;
      }
    }

    return e;
  },
  parseStyleRule: function parseStyleRule(e, t, i) {
    var n = CountLF(this.mScanner.getAlreadyScanned());
    this.preserveState();
    var s = this.parseSelector(e, !1),
        r = !1,
        o = [];

    if (s) {
      s = this.trim11(s.selector);
      var a = s,
          l = this.getToken(!0, !0);

      if (l.isSymbol("{")) {
        a += " { ";

        for (var l = this.getToken(!0, !1);;) {
          if (!l.isNotNull()) {
            r = !0;
            break;
          }

          if (l.isSymbol("}")) {
            a += "}", r = !0;
            break;
          }

          var u = this.parseDeclaration(l, o, !0, !0, t);
          a += (u && o.length ? " " : "") + u, l = this.getToken(!0, !1);
        }
      }
    }

    if (r) {
      var c = new jscsspStyleRule();
      return c.currentLine = n, c.parsedCssText = a, c.declarations = o, c.mSelectorText = s, i ? c.parentRule = t : c.parentStyleSheet = t, t.cssRules.push(c), a;
    }

    return this.restoreState(), a = this.currentToken().value, this.addUnknownAtRule(t, a), "";
  },
  parseSelector: function parseSelector(e, t) {
    for (var i = "", n = {
      a: 0,
      b: 0,
      c: 0,
      d: 0
    }, s = !0, r = e, o = !1, a = !1;;) {
      if (!r.isNotNull()) return t ? {
        selector: i,
        specificity: n
      } : "";

      if (!t && r.isSymbol("{")) {
        (o = !a) && this.ungetToken();
        break;
      }

      if (r.isSymbol(",")) i += r.value, s = !0, a = !1, r = this.getToken(!1, !0);else if (a || !(r.isWhiteSpace() || r.isSymbol(">") || r.isSymbol("+") || r.isSymbol("~"))) {
        var l = this.parseSimpleSelector(r, s, !0);
        if (!l) break;
        i += l.selector, n.b += l.specificity.b, n.c += l.specificity.c, n.d += l.specificity.d, s = !1, a = !1, r = this.getToken(!1, !0);
      } else {
        if (r.isWhiteSpace()) {
          i += " ";
          var u = this.lookAhead(!0, !0);
          if (!u.isNotNull()) return t ? {
            selector: i,
            specificity: n
          } : "";
          (u.isSymbol(">") || u.isSymbol("+") || u.isSymbol("~")) && (r = this.getToken(!0, !0), i += r.value + " ", a = !0);
        } else i += r.value, a = !0;

        s = !0, r = this.getToken(!0, !0);
      }
    }

    return o ? {
      selector: i,
      specificity: n
    } : "";
  },
  isPseudoElement: function isPseudoElement(e) {
    switch (e) {
      case "first-letter":
      case "first-line":
      case "before":
      case "after":
      case "marker":
        return !0;
    }

    return !1;
  },
  parseSimpleSelector: function parseSimpleSelector(e, t, i) {
    var n = "",
        s = {
      a: 0,
      b: 0,
      c: 0,
      d: 0
    };

    if (t && (e.isSymbol("*") || e.isSymbol("|") || e.isIdent())) {
      if (e.isSymbol("*") || e.isIdent()) {
        n += e.value;
        var r = e.isIdent();

        if (e = this.getToken(!1, !0), e.isSymbol("|")) {
          if (n += e.value, e = this.getToken(!1, !0), !e.isIdent() && !e.isSymbol("*")) return null;
          n += e.value, e.isIdent() && s.d++;
        } else this.ungetToken(), r && s.d++;
      } else if (e.isSymbol("|")) {
        if (n += e.value, e = this.getToken(!1, !0), !e.isIdent() && !e.isSymbol("*")) return null;
        n += e.value, e.isIdent() && s.d++;
      }
    } else if (e.isSymbol(".") || e.isSymbol("#")) {
      var o = e.isSymbol(".");
      if (n += e.value, e = this.getToken(!1, !0), !e.isIdent()) return null;
      n += e.value, o ? s.c++ : s.b++;
    } else if (e.isSymbol(":")) {
      if (n += e.value, e = this.getToken(!1, !0), e.isSymbol(":") && (n += e.value, e = this.getToken(!1, !0)), e.isIdent()) n += e.value, this.isPseudoElement(e.value) ? s.d++ : s.c++;else {
        if (!e.isFunction()) return null;

        if (n += e.value, e.isFunction(":not(")) {
          if (!i) return null;
          e = this.getToken(!0, !0);
          var a = this.parseSimpleSelector(e, t, !1);
          if (!a) return null;
          if (n += a.selector, e = this.getToken(!0, !0), !e.isSymbol(")")) return null;
          n += ")", s.c++;
        } else {
          for (;;) {
            if (e = this.getToken(!1, !0), e.isSymbol(")")) {
              n += ")";
              break;
            }

            n += e.value;
          }

          s.c++;
        }
      }
    } else if (e.isSymbol("[")) {
      if (n += "[", e = this.getToken(!0, !0), e.isIdent() || e.isSymbol("*")) {
        n += e.value;
        var l = this.getToken(!0, !0);

        if (l.isSymbol("|")) {
          if (n += "|", e = this.getToken(!0, !0), !e.isIdent()) return null;
          n += e.value;
        } else this.ungetToken();
      } else {
        if (!e.isSymbol("|")) return null;
        if (n += "|", e = this.getToken(!0, !0), !e.isIdent()) return null;
        n += e.value;
      }

      if (e = this.getToken(!0, !0), e.isIncludes() || e.isDashmatch() || e.isBeginsmatch() || e.isEndsmatch() || e.isContainsmatch() || e.isSymbol("=")) {
        if (n += e.value, e = this.getToken(!0, !0), !e.isString() && !e.isIdent()) return null;
        if (n += e.value, e = this.getToken(!0, !0), !e.isSymbol("]")) return null;
        n += e.value, s.c++;
      } else {
        if (!e.isSymbol("]")) return null;
        n += e.value, s.c++;
      }
    } else if (e.isWhiteSpace()) {
      var u = this.lookAhead(!0, !0);
      if (u.isSymbol("{")) return "";
    }

    return n ? {
      selector: n,
      specificity: s
    } : null;
  },
  preserveState: function preserveState() {
    this.mPreservedTokens.push(this.currentToken()), this.mScanner.preserveState();
  },
  restoreState: function restoreState() {
    this.mPreservedTokens.length && (this.mScanner.restoreState(), this.mToken = this.mPreservedTokens.pop());
  },
  forgetState: function forgetState() {
    this.mPreservedTokens.length && (this.mScanner.forgetState(), this.mPreservedTokens.pop());
  },
  parse: function parse(e, t, i) {
    if (!e) return null;
    this.mPreserveWS = t, this.mPreserveComments = i, this.mPreservedTokens = [], this.mScanner.init(e);
    var n = new jscsspStylesheet(),
        s = this.getToken(!1, !1);
    if (!s.isNotNull()) return n;
    s.isAtRule("@charset") && (this.ungetToken(), this.parseCharsetRule(n), s = this.getToken(!1, !1));

    for (var r = !1, o = !1, a = !1; s.isNotNull();) {
      if (s.isWhiteSpace()) t && this.addWhitespace(n, s.value);else if (s.isComment()) this.mPreserveComments && this.addComment(n, s.value);else if (s.isAtRule()) s.isAtRule("@variables") ? o || r ? (this.reportError(kVARIABLES_RULE_POSITION), this.addUnknownAtRule(n, s.value)) : this.parseVariablesRule(s, n) : s.isAtRule("@import") ? r || a ? (this.reportError(kIMPORT_RULE_POSITION), this.addUnknownAtRule(n, s.value)) : o = this.parseImportRule(s, n) : s.isAtRule("@namespace") ? r ? (this.reportError(kNAMESPACE_RULE_POSITION), this.addUnknownAtRule(n, s.value)) : a = this.parseNamespaceRule(s, n) : s.isAtRule("@font-face") ? this.parseFontFaceRule(s, n) ? r = !0 : this.addUnknownAtRule(n, s.value) : s.isAtRule("@page") ? this.parsePageRule(s, n) ? r = !0 : this.addUnknownAtRule(n, s.value) : s.isAtRule("@media") ? this.parseMediaRule(s, n) ? r = !0 : this.addUnknownAtRule(n, s.value) : s.isAtRule("@keyframes") ? this.parseKeyframesRule(s, n) || this.addUnknownAtRule(n, s.value) : s.isAtRule("@charset") ? (this.reportError(kCHARSET_RULE_CHARSET_SOF), this.addUnknownAtRule(n, s.value)) : (this.reportError(kUNKNOWN_AT_RULE), this.addUnknownAtRule(n, s.value));else {
        var l = this.parseStyleRule(s, n, !1);
        l && (r = !0);
      }
      s = this.getToken(!1);
    }

    return n;
  }
}, jscsspToken.NULL_TYPE = 0, jscsspToken.WHITESPACE_TYPE = 1, jscsspToken.STRING_TYPE = 2, jscsspToken.COMMENT_TYPE = 3, jscsspToken.NUMBER_TYPE = 4, jscsspToken.IDENT_TYPE = 5, jscsspToken.FUNCTION_TYPE = 6, jscsspToken.ATRULE_TYPE = 7, jscsspToken.INCLUDES_TYPE = 8, jscsspToken.DASHMATCH_TYPE = 9, jscsspToken.BEGINSMATCH_TYPE = 10, jscsspToken.ENDSMATCH_TYPE = 11, jscsspToken.CONTAINSMATCH_TYPE = 12, jscsspToken.SYMBOL_TYPE = 13, jscsspToken.DIMENSION_TYPE = 14, jscsspToken.PERCENTAGE_TYPE = 15, jscsspToken.HEX_TYPE = 16, jscsspToken.prototype = {
  isNotNull: function isNotNull() {
    return this.type;
  },
  _isOfType: function _isOfType(e, t) {
    return this.type == e && (!t || this.value.toLowerCase() == t);
  },
  isWhiteSpace: function isWhiteSpace(e) {
    return this._isOfType(jscsspToken.WHITESPACE_TYPE, e);
  },
  isString: function isString() {
    return this._isOfType(jscsspToken.STRING_TYPE);
  },
  isComment: function isComment() {
    return this._isOfType(jscsspToken.COMMENT_TYPE);
  },
  isNumber: function isNumber(e) {
    return this._isOfType(jscsspToken.NUMBER_TYPE, e);
  },
  isIdent: function isIdent(e) {
    return this._isOfType(jscsspToken.IDENT_TYPE, e);
  },
  isFunction: function isFunction(e) {
    return this._isOfType(jscsspToken.FUNCTION_TYPE, e);
  },
  isAtRule: function isAtRule(e) {
    return this._isOfType(jscsspToken.ATRULE_TYPE, e);
  },
  isIncludes: function isIncludes() {
    return this._isOfType(jscsspToken.INCLUDES_TYPE);
  },
  isDashmatch: function isDashmatch() {
    return this._isOfType(jscsspToken.DASHMATCH_TYPE);
  },
  isBeginsmatch: function isBeginsmatch() {
    return this._isOfType(jscsspToken.BEGINSMATCH_TYPE);
  },
  isEndsmatch: function isEndsmatch() {
    return this._isOfType(jscsspToken.ENDSMATCH_TYPE);
  },
  isContainsmatch: function isContainsmatch() {
    return this._isOfType(jscsspToken.CONTAINSMATCH_TYPE);
  },
  isSymbol: function isSymbol(e) {
    return this._isOfType(jscsspToken.SYMBOL_TYPE, e);
  },
  isDimension: function isDimension() {
    return this._isOfType(jscsspToken.DIMENSION_TYPE);
  },
  isPercentage: function isPercentage() {
    return this._isOfType(jscsspToken.PERCENTAGE_TYPE);
  },
  isHex: function isHex() {
    return this._isOfType(jscsspToken.HEX_TYPE);
  },
  isDimensionOfUnit: function isDimensionOfUnit(e) {
    return this.isDimension() && this.unit == e;
  },
  isLength: function isLength() {
    return this.isPercentage() || this.isDimensionOfUnit("cm") || this.isDimensionOfUnit("mm") || this.isDimensionOfUnit("in") || this.isDimensionOfUnit("pc") || this.isDimensionOfUnit("px") || this.isDimensionOfUnit("em") || this.isDimensionOfUnit("ex") || this.isDimensionOfUnit("pt");
  },
  isAngle: function isAngle() {
    return this.isDimensionOfUnit("deg") || this.isDimensionOfUnit("rad") || this.isDimensionOfUnit("grad");
  }
};
var kJscsspUNKNOWN_RULE = 0,
    kJscsspSTYLE_RULE = 1,
    kJscsspCHARSET_RULE = 2,
    kJscsspIMPORT_RULE = 3,
    kJscsspMEDIA_RULE = 4,
    kJscsspFONT_FACE_RULE = 5,
    kJscsspPAGE_RULE = 6,
    kJscsspKEYFRAMES_RULE = 7,
    kJscsspKEYFRAME_RULE = 8,
    kJscsspNAMESPACE_RULE = 100,
    kJscsspCOMMENT = 101,
    kJscsspWHITE_SPACE = 102,
    kJscsspVARIABLES_RULE = 200,
    kJscsspSTYLE_DECLARATION = 1e3,
    gTABS = "";
jscsspStylesheet.prototype = {
  insertRule: function insertRule(e, t) {
    try {
      this.cssRules.splice(t, 1, e);
    } catch (e) {}
  },
  deleteRule: function deleteRule(e) {
    try {
      this.cssRules.splice(e);
    } catch (e) {}
  },
  cssText: function cssText() {
    for (var e = "", t = 0; t < this.cssRules.length; t++) {
      e += this.cssRules[t].cssText() + "\n\n";
    }

    return e;
  }
}, jscsspCharsetRule.prototype = {
  cssText: function cssText() {
    return "@charset " + this.encoding + ";";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    };

    if (new CSSParser(e).parseCharsetRule(t)) {
      var i = t.cssRules[0];
      return this.encoding = i.encoding, void (this.parsedCssText = i.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspErrorRule.prototype = {
  cssText: function cssText() {
    return this.parsedCssText;
  }
}, jscsspComment.prototype = {
  cssText: function cssText() {
    return this.parsedCssText;
  },
  setCssText: function setCssText(e) {
    var t = new CSSParser(e),
        i = t.getToken(!0, !1);
    if (!i.isComment()) throw DOMException.SYNTAX_ERR;
    this.parsedCssText = i.value;
  }
}, jscsspWhitespace.prototype = {
  cssText: function cssText() {
    return this.parsedCssText;
  }
}, jscsspImportRule.prototype = {
  cssText: function cssText() {
    var e = this.media.join(", ");
    return "@import " + this.href + (e && "all" != e ? e + " " : "") + ";";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@import") && i.parseImportRule(n, t)) {
      var s = t.cssRules[0];
      return this.href = s.href, this.media = s.media, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspNamespaceRule.prototype = {
  cssText: function cssText() {
    return "@namespace " + (this.prefix ? this.prefix + " " : "") + this.url + ";";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@namespace") && i.parseNamespaceRule(n, t)) {
      var s = t.cssRules[0];
      return this.url = s.url, this.prefix = s.prefix, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspDeclaration.prototype = {
  kCOMMA_SEPARATED: {
    cursor: !0,
    "font-family": !0,
    "voice-family": !0,
    "background-image": !0
  },
  kUNMODIFIED_COMMA_SEPARATED_PROPERTIES: {
    "text-shadow": !0,
    "box-shadow": !0,
    "-moz-transition": !0,
    "-moz-transition-property": !0,
    "-moz-transition-duration": !0,
    "-moz-transition-timing-function": !0,
    "-moz-transition-delay": !0,
    src: !0,
    "-moz-font-feature-settings": !0
  },
  cssText: function cssText() {
    var e = PrefixHelper.prefixesForProperty(this.property),
        t = "";

    if (this.property in this.kUNMODIFIED_COMMA_SEPARATED_PROPERTIES) {
      if (e) {
        t = "";

        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          t += (i ? gTABS : "") + n + ": ", t += this.valueText + (this.priority ? " !important" : "") + ";", t += e.length > 1 && i != e.length - 1 ? "\n" : "";
        }

        return t;
      }

      return this.property + ": " + this.valueText + (this.priority ? " !important" : "") + ";";
    }

    if (e) {
      t = "";

      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        t += (i ? gTABS : "") + n + ": ";

        for (var s = (n in this.kCOMMA_SEPARATED) ? ", " : " ", r = 0; r < this.values.length; r++) {
          if (null == this.values[r].cssText()) return null;
          t += (r ? s : "") + this.values[r].cssText();
        }

        t += (this.priority ? " !important" : "") + ";" + (e.length > 1 && i != e.length - 1 ? "\n" : "");
      }

      return t;
    }

    for (var s = (this.property in this.kCOMMA_SEPARATED) ? ", " : " ", o = {
      webkit: !1,
      presto: !1,
      trident: !1,
      "gecko1.9.2": !1,
      generic: !1
    }, r = 0; r < this.values.length; r++) {
      var a = this.values[r].cssText();
      if (null == a) return null;
      var l = a.indexOf("("),
          u = a;
      if (-1 != l && (u = a.substr(0, l)), u in kCSS_VENDOR_VALUES) for (var c in kCSS_VENDOR_VALUES[u]) {
        o[c] = o[c] || "" != kCSS_VENDOR_VALUES[u][c];
      }
    }

    for (var c in o) {
      if (o[c]) {
        for (var d = "\n" + gTABS + this.property + ": ", r = 0; r < this.values.length; r++) {
          var a = this.values[r].cssText();
          if (null == a) return null;
          var l = a.indexOf("("),
              u = a;

          if (-1 != l && (u = a.substr(0, l)), u in kCSS_VENDOR_VALUES && (functor = kCSS_VENDOR_VALUES[u][c], functor && !(a = "string" == typeof functor ? functor : functor(a, c)))) {
            d = null;
            break;
          }

          d += (r ? s : "") + a;
        }

        t += d ? d + ";" : "\n" + gTABS + "/* Impossible to translate property " + this.property + " for " + c + " */";
      }
    }

    t += "\n" + gTABS + this.property + ": ";

    for (var r = 0; r < this.values.length; r++) {
      var a = this.values[r].cssText();
      null != a && (t += (r ? s : "") + a);
    }

    return t += (this.priority ? " !important" : "") + ";";
  },
  setCssText: function setCssText(e) {
    var t = [],
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (i.parseDeclaration(n, t, !0, !0, null) && t.length && t[0].type == kJscsspSTYLE_DECLARATION) {
      var s = t.cssRules[0];
      return this.property = s.property, this.value = s.value, this.priority = s.priority, void (this.parsedCssText = newRule.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspFontFaceRule.prototype = {
  cssText: function cssText() {
    var e = gTABS + "@font-face {\n",
        t = gTABS;
    gTABS += "  ";

    for (var i = 0; i < this.descriptors.length; i++) {
      e += gTABS + this.descriptors[i].cssText() + "\n";
    }

    return gTABS = t, e + gTABS + "}";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@font-face") && i.parseFontFaceRule(n, t)) {
      var s = t.cssRules[0];
      return this.descriptors = s.descriptors, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspKeyframesRule.prototype = {
  cssText: function cssText() {
    for (var e = "", t = ["moz", "webkit", "ms", "o", ""], i = 0; i < t.length; i++) {
      e += gTABS + "@" + (t[i] ? "-" + t[i] + "-" : "") + "keyframes " + this.name + " {\n";
      var n = gTABS;
      gTABS += "  ";

      for (var s = 0; s < this.cssRules.length; s++) {
        e += gTABS + this.cssRules[s].cssText() + "\n";
      }

      gTABS = n, e += gTABS + "}\n\n";
    }

    return e;
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@-mozkeyframes") && i.parseKeyframesRule(n, t)) {
      var s = t.cssRules[0];
      return this.cssRules = s.cssRules, this.name = s.name, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspKeyframeRule.prototype = {
  cssText: function cssText() {
    var e = this.keyText + " {\n",
        t = gTABS;
    gTABS += "  ";

    for (var i = 0; i < this.declarations.length; i++) {
      this.declarations[i].cssText() && (e += gTABS + this.declarations[i].cssText() + "\n");
    }

    return gTABS = t, e + gTABS + "}";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (!n.isNotNull() && i.parseKeyframeRule(n, t, !1)) {
      var s = t.cssRules[0];
      return this.keyText = s.keyText, this.declarations = s.declarations, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspMediaRule.prototype = {
  cssText: function cssText() {
    var e = gTABS + "@media " + this.media.join(", ") + " {\n",
        t = gTABS;
    gTABS += "  ";

    for (var i = 0; i < this.cssRules.length; i++) {
      e += this.cssRules[i].cssText() + "\n";
    }

    return gTABS = t, e + gTABS + "}";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@media") && i.parseMediaRule(n, t)) {
      var s = t.cssRules[0];
      return this.cssRules = s.cssRules, this.media = s.media, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspStyleRule.prototype = {
  cssText: function cssText() {
    var e = gTABS + this.mSelectorText + " {",
        t = gTABS;
    gTABS += "  ";

    for (var i = 0; i < this.declarations.length; i++) {
      this.declarations[i].cssText() && (e += gTABS + this.declarations[i].cssText());
    }

    return gTABS = t, e + "\n" + gTABS + "}";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (!n.isNotNull() && i.parseStyleRule(n, t, !1)) {
      var s = t.cssRules[0];
      return this.mSelectorText = s.mSelectorText, this.declarations = s.declarations, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  },
  selectorText: function selectorText() {
    return this.mSelectorText;
  },
  setSelectorText: function setSelectorText(e) {
    var t = new CSSParser(e),
        i = t.getToken(!0, !0);

    if (!i.isNotNull()) {
      var n = t.parseSelector(i, !0);
      if (n) return void (this.mSelectorText = n.selector);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspPageRule.prototype = {
  cssText: function cssText() {
    var e = gTABS + "@page " + (this.pageSelector ? this.pageSelector + " " : "") + "{\n",
        t = gTABS;
    gTABS += "  ";

    for (var i = 0; i < this.declarations.length; i++) {
      e += gTABS + this.declarations[i].cssText() + "\n";
    }

    return gTABS = t, e + gTABS + "}";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@page") && i.parsePageRule(n, t)) {
      var s = t.cssRules[0];
      return this.pageSelector = s.pageSelector, this.declarations = s.declarations, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
}, jscsspVariablesRule.prototype = {
  cssText: function cssText() {
    var e = gTABS + "@variables " + (this.media.length ? this.media.join(", ") + " " : "") + "{\n",
        t = gTABS;
    gTABS += "  ";

    for (var i = 0; i < this.declarations.length; i++) {
      e += gTABS + this.declarations[i].cssText() + "\n";
    }

    return gTABS = t, e + gTABS + "}";
  },
  setCssText: function setCssText(e) {
    var t = {
      cssRules: []
    },
        i = new CSSParser(e),
        n = i.getToken(!0, !0);

    if (n.isAtRule("@variables") && i.parseVariablesRule(n, t)) {
      var s = t.cssRules[0];
      return this.declarations = s.declarations, void (this.parsedCssText = s.parsedCssText);
    }

    throw DOMException.SYNTAX_ERR;
  }
};
var kJscsspINHERIT_VALUE = 0,
    kJscsspPRIMITIVE_VALUE = 1,
    kJscsspVARIABLE_VALUE = 4;
jscsspVariable.prototype = {
  cssText: function cssText() {
    return this.type == kJscsspVARIABLE_VALUE ? this.resolveVariable(this.name, this.parentRule, this.parentStyleSheet) : this.value;
  },
  setCssText: function setCssText(e) {
    if (this.type == kJscsspVARIABLE_VALUE) throw DOMException.SYNTAX_ERR;
    this.value = e;
  },
  resolveVariable: function resolveVariable(e) {
    return "var(" + e + ")";
  }
}, window.CSSParser = CSSParser, define("lib/vwpoly/cssparser", function () {}), define("lib/vwpoly/vwpoly", ["lib/vwpoly/cssparser"], function () {
  var e,
      t,
      i,
      n,
      s,
      r = {};
  return e = [function () {
    return new XMLHttpRequest();
  }, function () {
    return new ActiveXObject("Msxml2.XMLHTTP");
  }, function () {
    return new ActiveXObject("Msxml3.XMLHTTP");
  }, function () {
    return new ActiveXObject("Microsoft.XMLHTTP");
  }], i = function i() {
    var t, i;

    for (i = !1, t = 0; t < e.length;) {
      try {
        i = e[t++]();
      } catch (e) {
        e;
        continue;
      }

      break;
    }

    return i;
  }, t = function t(e, _t5) {
    var n, s;
    s = i(), s.onreadystatechange = function () {
      if (4 === s.readyState) {
        if (200 !== s.status && !e.match(/^file:\/\/\//)) throw "Error!";
        console.log("INFO: processing " + e), _t5(s.responseText);
      }
    };

    try {
      s.open("GET", e, !0), s.send();
    } catch (t) {
      n = t, console.log("ERROR: " + n.message + " (" + n.type + ") when accessing " + e);
    }
  }, n = function n() {
    var e, t;
    return e = 0, t = 0, window.innerHeight ? (e = window.innerWidth, t = window.innerHeight) : document.documentElement && document.documentElement.clientHeight ? (e = document.documentElement.clientWidth, t = document.documentElement.clientHeight) : document.body && (e = document.body.clientWidth, t = document.body.clientHeight), {
      width: e,
      height: t
    };
  }, s = function s() {
    var e,
        i,
        s,
        r,
        o,
        a,
        l,
        u,
        c,
        d = "";
    o = function o() {
      var e, t, i;
      i = n(), t = {
        vh: i.height / 100,
        vw: i.width / 100
      }, t.vmin = Math.min(t.vh, t.vw), i.width, i.height;
      var s = /([0-9]+[\.]{0,}[0-9]{0,})vw/g,
          e = d.replace(s, function (e, t) {
        var n = parseFloat(t) || 0;
        return (n = Math.round(n / 100 * i.width)) + "px";
      });
      return null != u.styleSheet ? u.styleSheet.cssText = e : u.innerHTML = e;
    }, l = {}, u = document.createElement("style"), e = document.getElementsByTagName("head")[0], e.appendChild(u);
    var r = document.getElementsByTagName("link");
    s = 0, a = 0;

    for (var c = r.length, p = function p(e) {
      var t = new jscsspStylesheet();
      if (e instanceof jscsspMediaRule && (t = new jscsspMediaRule(), t.media = e.media), e && e.cssRules && e.cssRules.length > 0) for (var i = e.cssRules.length, n = 0; n < i; n++) {
        var s = e.cssRules[n];

        if (s instanceof jscsspMediaRule) {
          var r = p(s);
          t.cssRules.push(r);
        } else if (s instanceof jscsspStyleRule) {
          var o = m(s);
          o && (o.parentRule = t, o.parentStyleSheet = t, t.cssRules.push(o));
        }
      }
      return t;
    }, h = /([0-9]+[\.]{0,}[0-9]{0,}vw)/i, f = /(height|top|bottom)/i, m = function m(e) {
      var t = new jscsspStyleRule();
      if (e && e.declarations && e.declarations.length > 0) for (var i = e.declarations.length, n = 0; n < i; n++) {
        var s = e.declarations[n];
        h.test(s.valueText) ? (t.mSelectorText = e.mSelectorText, t.declarations.push(s)) : f.test(s.property) && (t.mSelectorText = e.mSelectorText, t.declarations.push(s));
      }
      return t.declarations.length > 0 && t;
    }, g = 0; g < c; g++) {
      var i = r[g];
      "stylesheet" === i.rel && (s++, function (e) {
        var i = function i(t) {
          var i = new CSSParser(),
              n = i.parse(t, !1, !1),
              r = p(n),
              t = "" + r.cssText();

          if (l[e.href] = t, ++a === s) {
            d = "";

            for (var o in l) {
              d += l[o];
            }

            window.onresize();
          }
        };

        t(e.href, i);
      }(i));
    }

    window.onresize = o;
  }, r.initLayoutEngine = s, r;
}), define("common/init", ["jquery", "cssua", "modernizr", "lib/vwpoly/vwpoly"], function (e, t, i, n) {
  function s(e, t, i) {
    var n = e.pageX,
        s = e.pageY,
        r = t.offset(),
        o = t.outerHeight(),
        a = t.outerWidth(),
        l = i.offset(),
        u = i.outerHeight(),
        c = r.left,
        d = r.left + a + 20,
        p = r.top + o,
        h = l.top + u + 20;
    return s > p && s < h ? n > c && n < d : 0;
  }

  var r = t.ua.ie < 9,
      o = window.location.href,
      a = e(".n-l-list"),
      l = e(".n-l-sec"),
      u = e(".navigator-list-sec-desktop");
  a.bind("mouseenter", function (t) {
    if (t.stopPropagation(), a.removeClass("current"), !e(this).hasClass("active")) {
      e(this).addClass("current"), u.show();
      var i = a.index(this);
      l.hide(), e(l.get(i)).show();
    }
  }).bind("mouseleave", function (t) {
    t.stopPropagation();
    var i = e(this);
    s(t, i, u) || u.get(0).hasAttribute("mousein") && e(this).hasClass("current") || (i.removeClass("current"), u.hide());
  }), u.bind("mouseenter", function (e) {
    e.stopPropagation(), u.attr("mousein", "1");
  }).bind("mouseleave", function (e) {
    e.stopPropagation(), u.removeAttr("mousein"), a.removeClass("current"), u.hide();
  }), e(".m-s-button").bind("click", function (t) {
    t.stopPropagation(), t.preventDefault(), e(".navigator-list-sec-mobile").toggleClass("open");
  }), e(".n-l-m-item>a").each(function (e, t) {
    t.href == o && (t.style.color = "#f27122");
  }).bind("click", function (t) {
    t.stopPropagation(), t.preventDefault();
    var i = e(this),
        n = i.next();
    n.length ? (i.parent().toggleClass("open"), n.toggleClass("open")) : location.replace(i.attr("href"));
  }), e(".n-l-sec-child-menu a").each(function (t, i) {
    i.href == o && (i.style.color = "#f27122", e(i).parents(".n-l-m-item").find(".n-l-sec-parent").trigger("click"));
  });
  var c = e(".select-simulate");
  c && c.each(function (t, i) {
    function n() {
      var e = s.find("option:selected").text();
      s.prev().text(e);
    }

    var s = e(i);
    n(), s.on("change", n);
  }), e("html").hasClass("lte9") && e("[placeholder]").each(function (t, i) {
    e(i).css("color", "#717171").val(i.getAttribute("placeholder"));
  }).bind("focus", function () {
    var t = e(this),
        i = t.attr("placeholder");
    i === t.val() ? t.css("color", "").val("") : e.trim(t.val()) || t.css("color", "#717171").val(i);
  }).bind("blur", function () {
    var t = e(this),
        i = t.attr("placeholder");
    e.trim(t.val()) ? t.css("color", "") : t.css("color", "#717171").val(i);
  });
  var d = e("#require"),
      p = /^[^\s]+(,[^\s]+\w?)+$/,
      h = d.data("require-css"),
      f = d.data("require-js");

  if (h = p.test(h) ? h.split(",") : h, f = p.test(f) ? f.split(",") : f, AppConfig.Info.isDev && AppConfig.LoadPageRequire({
    css: h
  }), r) {
    var m = document.createElement("link"),
        g = document.createElement("script");
    m.rel = "stylesheet", m.type = "text/css", m.href = AppConfig.CssPath + "/common/ie.css", g.type = "text/javascript", g.src = AppConfig.JsPath + "/patch/respond.min.js", head.appendChild(m), head.appendChild(g);
  }

  t.ua.mobile || t.ua.mac_os_x || t.ua.ie, Modernizr.cssvwunit || n.initLayoutEngine(), AppConfig.LoadPageRequire({
    js: f
  });
});